import { supabase } from './supabaseClient';
import { useState, useRef, useEffect, useCallback } from "react";

// ============================================================
// DİL SİSTEMİ — TR / EN / RU
// ============================================================
const TRANSLATIONS = {
  TR: {
    appName: "Girne Temizlik", appSub: "ELG Homes Property Management",
    dashboard: "Dashboard", sites: "Siteler", personnel: "Personel",
    income: "Gelir & Gider", jobs: "İşler", todos: "Yapılacaklar",
    residents: "Sakin Kullanıcılar", announcements: "Duyurular",
    faults: "Arıza Takip", roles: "Rol Yönetimi",
    add: "Ekle", edit: "Düzenle", delete: "Sil", save: "Kaydet",
    cancel: "İptal", close: "Kapat", detail: "Detay",
    newSite: "Yeni Site Ekle", siteDetail: "Daire Yönetimi",
    totalIncome: "Toplam Gelir", totalExpense: "Toplam Gider",
    balance: "Kasa Bakiyesi", totalSites: "Kayıtlı Siteler",
    pendingJobs: "Bekleyen İşler", activePersonnel: "Aktif Personel",
    paid: "Ödendi", pending: "Bekliyor", late: "Gecikti",
    active: "Aktif", passive: "Pasif", full: "Dolu", empty: "Boş",
    today: "Bugün", allBlocks: "Tüm Bloklar", addApartment: "Daire Ekle",
    bulkAdd: "Toplu Ekle", cardView: "Kart", tableView: "Tablo",
    paymentDetail: "Ödeme Detayı", dues: "Aidat", flat: "Flat Ödemesi",
    otherExpenses: "Diğer Harcamalar", addRecord: "Kayıt Ekle",
    monthlyView: "Aylık Görünüm", yearlyView: "Yıllık Görünüm",
    salary: "Maaş", remaining: "Kalan", carryover: "Devir",
    attendance: "Devam", came: "Geldi", didntCome: "Gelmedi",
    announcement: "Duyuru", addAnnouncement: "Duyuru Ekle",
    publishTo: "Yayınla", allSites: "Tüm Siteler",
    faultReport: "Arıza Bildirimi", status: "Durum",
    reported: "Bildirildi", inProgress: "Devam Ediyor", resolved: "Çözüldü",
    addResident: "Sakin Ekle", phone: "Telefon", password: "Şifre",
    role: "Rol", superAdmin: "Süper Admin", siteManager: "Site Yöneticisi",
    resident: "Sakin", login: "Giriş Yap", logout: "Çıkış",
    updateProfile: "Profili Güncelle", adminSettings: "Yönetim Ayarları",
    siteExpenses: "Site Giderleri", addExpense: "Gider Ekle",
    category: "Kategori", description: "Açıklama", amount: "Tutar",
    date: "Tarih", attachment: "Dosya Eki",
    name: "Ad Soyad", address: "Adres", block: "Blok", apartmentNo: "Daire No",
    owner: "Ev Sahibi", tenant: "Kiracı", plate: "Araç Plaka",
    language: "Dil",
    // Yeni eklenenler
    airbnb: "Airbnb / Kiralık", regularClients: "Düzenli Müşteriler",
    messages: "Mesajlar", sendMessage: "Mesaj Gönder",
    faultTracking: "Arıza Takip", siteExpense: "Site Gideri",
    newNotification: "Yeni Bildirim", present: "Geldi",
    payment: "Ödeme", cash: "Nakit",
  },
  EN: {
    appName: "Girne Temizlik", appSub: "ELG Homes Property Management",
    dashboard: "Dashboard", sites: "Properties", personnel: "Staff",
    income: "Income & Expense", jobs: "Jobs", todos: "To-Do",
    residents: "Resident Users", announcements: "Announcements",
    faults: "Fault Tracking", roles: "Role Management",
    add: "Add", edit: "Edit", delete: "Delete", save: "Save",
    cancel: "Cancel", close: "Close", detail: "Detail",
    newSite: "Add New Property", siteDetail: "Unit Management",
    totalIncome: "Total Income", totalExpense: "Total Expense",
    balance: "Cash Balance", totalSites: "Registered Properties",
    pendingJobs: "Pending Jobs", activePersonnel: "Active Staff",
    paid: "Paid", pending: "Pending", late: "Overdue",
    active: "Active", passive: "Inactive", full: "Occupied", empty: "Vacant",
    today: "Today", allBlocks: "All Blocks", addApartment: "Add Unit",
    bulkAdd: "Bulk Add", cardView: "Card", tableView: "Table",
    paymentDetail: "Payment Detail", dues: "Dues", flat: "Fixed Payment",
    otherExpenses: "Other Expenses", addRecord: "Add Record",
    monthlyView: "Monthly View", yearlyView: "Yearly View",
    salary: "Salary", remaining: "Remaining", carryover: "Carryover",
    attendance: "Attendance", came: "Present", didntCome: "Absent",
    announcement: "Announcement", addAnnouncement: "Add Announcement",
    publishTo: "Publish To", allSites: "All Properties",
    faultReport: "Fault Report", status: "Status",
    reported: "Reported", inProgress: "In Progress", resolved: "Resolved",
    addResident: "Add Resident", phone: "Phone", password: "Password",
    role: "Role", superAdmin: "Super Admin", siteManager: "Property Manager",
    resident: "Resident", login: "Login", logout: "Logout",
    updateProfile: "Update Profile", adminSettings: "Admin Settings",
    siteExpenses: "Property Expenses", addExpense: "Add Expense",
    category: "Category", description: "Description", amount: "Amount",
    date: "Date", attachment: "Attachment",
    name: "Full Name", address: "Address", block: "Block", apartmentNo: "Unit No",
    owner: "Owner", tenant: "Tenant", plate: "License Plate",
    language: "Language",
    airbnb: "Airbnb / Rentals", regularClients: "Regular Clients",
    messages: "Messages", sendMessage: "Send Message",
    faultTracking: "Fault Tracking", siteExpense: "Property Expense",
    newNotification: "New Notification", present: "Present",
    payment: "Payment", cash: "Cash",
  },
  RU: {
    appName: "Girne Temizlik", appSub: "ELG Homes Property Management",
    dashboard: "Дашборд", sites: "Объекты", personnel: "Персонал",
    income: "Доходы и расходы", jobs: "Работы", todos: "Задачи",
    residents: "Жильцы", announcements: "Объявления",
    faults: "Учёт неисправностей", roles: "Управление ролями",
    add: "Добавить", edit: "Редактировать", delete: "Удалить", save: "Сохранить",
    cancel: "Отмена", close: "Закрыть", detail: "Детали",
    newSite: "Добавить объект", siteDetail: "Управление квартирами",
    totalIncome: "Общий доход", totalExpense: "Общий расход",
    balance: "Баланс кассы", totalSites: "Объектов",
    pendingJobs: "Ожидающих работ", activePersonnel: "Активных сотрудников",
    paid: "Оплачено", pending: "Ожидание", late: "Просрочено",
    active: "Активный", passive: "Неактивный", full: "Занято", empty: "Свободно",
    today: "Сегодня", allBlocks: "Все подъезды", addApartment: "Добавить квартиру",
    bulkAdd: "Массовое добавление", cardView: "Карточки", tableView: "Таблица",
    paymentDetail: "Детали платежа", dues: "Взносы", flat: "Фиксированный платёж",
    otherExpenses: "Прочие расходы", addRecord: "Добавить запись",
    monthlyView: "Ежемесячный вид", yearlyView: "Годовой вид",
    salary: "Зарплата", remaining: "Остаток", carryover: "Перенос",
    attendance: "Явка", came: "Пришёл", didntCome: "Не пришёл",
    announcement: "Объявление", addAnnouncement: "Добавить объявление",
    publishTo: "Опубликовать для", allSites: "Все объекты",
    faultReport: "Сообщение о неисправности", status: "Статус",
    reported: "Сообщено", inProgress: "В работе", resolved: "Решено",
    addResident: "Добавить жильца", phone: "Телефон", password: "Пароль",
    role: "Роль", superAdmin: "Супер Администратор", siteManager: "Управляющий",
    resident: "Жилец", login: "Войти", logout: "Выйти",
    updateProfile: "Обновить профиль", adminSettings: "Настройки",
    siteExpenses: "Расходы объекта", addExpense: "Добавить расход",
    category: "Категория", description: "Описание", amount: "Сумма",
    date: "Дата", attachment: "Вложение",
    name: "ФИО", address: "Адрес", block: "Подъезд", apartmentNo: "№ квартиры",
    owner: "Владелец", tenant: "Арендатор", plate: "Номер авто",
    language: "Язык",
    airbnb: "Airbnb / Аренда", regularClients: "Постоянные клиенты",
    messages: "Сообщения", sendMessage: "Отправить",
    faultTracking: "Неисправности", siteExpense: "Расход объекта",
    newNotification: "Новое уведомление", present: "Пришёл",
    payment: "Оплата", cash: "Наличные",
  },
};

// ============================================================
// MOCK DATA
// ============================================================
const CURRENT_YEAR = new Date().getFullYear();
const MOCK = {
  adminProfile: { ad: "Süper Admin", email: "admin@siteyonet.com", tel: "0532 000 00 00", sifre: "admin123" },
  odemeEntegrasyon: {
    aktif: false,
    sagLayici: "iyzico",
    apiKey: "",
    secretKey: "",
    merchantId: "",
    testModu: true,
    odemeSayfaUrl: "",
    returnUrl: "",
    aciklama: "",
  },
  webhookLoglari: [],
  aidatTarihleri: [],
  sakinSikayetler: [
    { id:1, siteId:1, daireId:1, kAd:"Ali Kaya", sakinTel:"0535 100 20 30", tarih:"2025-03-08", tur:"sikayet", baslik:"Gece gürültüsü", icerik:"Geceleri çok gürültü yapılıyor.", durum:"inceleniyor" },
  ],
  airbnbEvler: [
    {
      id: 1,
      baslik: "Deniz Manzaralı Daire",
      adres: "Çeşme, İzmir",
      tur: "daire",
      kapasite: 4,
      odaSayisi: 2,
      banyoSayisi: 1,
      geceLikFiyat: 1200,
      platformlar: ["airbnb", "booking"],
      airbnbUrl: "",
      bookingUrl: "",
      durum: "musait",
      fotograflar: [],
      notlar: "Evcil hayvan kabul edilmez.",
    },
  ],
  airbnbRezervasyon: [
    {
      id: 1,
      evId: 1,
      misafirAd: "John Smith",
      misafirTel: "+1 555 123 4567",
      girisTarihi: "2026-03-20",
      cikisTarihi: "2026-03-25",
      gecelik: 1200,
      toplamTutar: 6000,
      komisyon: 720,
      netGelir: 5280,
      platform: "airbnb",
      durum: "onaylandi",
      notlar: "Erken check-in talep etti.",
      odeme: "odendi",
    },
  ],
  siteler: [
    { id: 1, siteIsmi: "Lale Apartmanı", yonetici: "Ahmet Yılmaz", yoneticiTel: "0532 111 22 33", adres: "Atatürk Cad. No:12, Kadıköy", elektrikAboneNo: "ELK-001", havuzBakimci: "Mehmet Su", asansorBakimci: "Asansör A.Ş.", aidatBedeli: 800, kayitTarihi: "2024-01-15", bloklar: ["A","B","C"] },
    { id: 2, siteIsmi: "Gül Sitesi", yonetici: "Fatma Demir", yoneticiTel: "0533 222 33 44", adres: "Cumhuriyet Sok. No:5, Beşiktaş", elektrikAboneNo: "ELK-002", havuzBakimci: "Su Bakım Ltd.", asansorBakimci: "Elevator Pro", aidatBedeli: 1200, kayitTarihi: "2024-02-20", bloklar: ["A","B"] },
  ],
  siteDetay: [
    { id: 1, siteId: 1, blok: "A", daireNo: 1, evSahibi: "Ali Kaya", evSahibiTel: "0535 100 20 30", kiraci: "Can Öztürk", kiraciTel: "0536 200 30 40", aracPlaka: "34 ABC 123", evDurum: "dolu", aidatBedeli: 800 },
    { id: 2, siteId: 1, blok: "A", daireNo: 2, evSahibi: "Zeynep Arslan", evSahibiTel: "0537 300 40 50", kiraci: "", kiraciTel: "", aracPlaka: "34 XYZ 456", evDurum: "bos", aidatBedeli: 800 },
    { id: 3, siteId: 1, blok: "B", daireNo: 1, evSahibi: "Hasan Çelik", evSahibiTel: "0538 400 50 60", kiraci: "Ayşe Yıldız", kiraciTel: "0539 500 60 70", aracPlaka: "34 KLM 789", evDurum: "dolu", aidatBedeli: 800 },
  ],
  daireOdemeler: {
    "1_2024-01": { aidat: { durum: "odendi", tarih: "2024-01-05" }, flat: { tutar: 200, tarih: "2024-01-05" }, diger: [] },
    "1_2025-03": { aidat: { durum: "bekliyor", tarih: "" }, flat: { tutar: 0, tarih: "" }, diger: [] },
  },
  personel: [
    { id: 1, ad: "Mustafa Aydın", iletisim: "0541 111 11 11", iseBaslama: "2023-03-01", maas: 15000, durum: "aktif" },
    { id: 2, ad: "Elif Kılıç", iletisim: "0542 222 22 22", iseBaslama: "2023-06-15", maas: 12000, durum: "aktif" },
  ],
  personelDetay: [
    { id: 1, personelId: 1, yil: 2025, ay: 3, odeme: 500, aciklama: "Avans", devam: "geldi" },
    { id: 2, personelId: 1, yil: 2025, ay: 3, odeme: 2000, aciklama: "Ara ödeme", devam: "geldi" },
  ],
  gelir: [
    { id: 1, tarih: "2024-06-01", tutar: 5000, aciklama: "Haziran aidat gelirleri" },
    { id: 2, tarih: "2024-06-10", tutar: 2000, aciklama: "İş geliri" },
  ],
  gider: [
    { id: 1, tarih: "2024-06-02", tutar: 1500, aciklama: "Asansör bakım ücreti" },
    { id: 2, tarih: "2024-06-08", tutar: 800, aciklama: "Temizlik malzemesi" },
  ],
  siteGiderleri: [
    { id: 1, siteId: 1, tarih: "2025-03-01", tutar: 1500, aciklama: "Asansör periyodik bakım", kategori: "bakim", dosyaAdi: "" },
    { id: 2, siteId: 1, tarih: "2025-03-05", tutar: 450, aciklama: "Temizlik malzemesi", kategori: "temizlik", dosyaAdi: "" },
    { id: 3, siteId: 2, tarih: "2025-03-08", tutar: 800, aciklama: "Bahçe sulama sistemi", kategori: "bahce", dosyaAdi: "" },
  ],
  isler: [
    { id: 1, tarih: "2024-06-01", musteriIsmi: "Ahmet Bey", musteriTel: "0530 100 10 10", isBilgisi: "Elektrik pano yenileme", adres: "Lale Apt A Blok", bedel: 3500, odemeTuru: "nakit", odemeDurum: "odendi" },
    { id: 2, tarih: "2024-06-05", musteriIsmi: "Fatma Hanım", musteriTel: "0531 200 20 20", isBilgisi: "Su tesisatı onarımı", adres: "Gül Sitesi B Blok 3", bedel: 1200, odemeTuru: "havale", odemeDurum: "bekliyor" },
  ],
  yapilacaklar: [
    { id: 1, tarih: "2024-06-10", baslik: "Lale Apt genel toplantı", aciklama: "Haziran ayı olağan toplantı", durum: "bekliyor" },
    { id: 2, tarih: "2024-06-15", baslik: "Gül Sitesi havuz bakım", aciklama: "Yaz sezonu öncesi", durum: "tamamlandi" },
  ],
  duyurular: [
    { id: 1, siteId: 0, baslik: "Nisan ayı aidat hatırlatması", icerik: "Sayın sakinlerimiz, Nisan ayı aidatlarınızı lütfen 15 Nisan'a kadar ödeyiniz.", tarih: "2025-03-10", dosyaAdi: "", dosyaTur: "" },
    { id: 2, siteId: 1, baslik: "Asansör bakım çalışması", icerik: "15 Mart Cumartesi 09:00-12:00 saatleri arasında asansörümüz bakımda olacaktır.", tarih: "2025-03-08", dosyaAdi: "teklif.pdf", dosyaTur: "pdf" },
  ],
  arizalar: [
    { id: 1, siteId: 1, daireId: 1, sakinAd: "Can Öztürk", sakinTel: "0536 200 30 40", tarih: "2025-03-10", baslik: "Su sızıntısı", aciklama: "Mutfak lavabosunun altından su sızıyor.", konum: "A Blok Daire 1 Mutfak", durum: "bildirildi", adminNot: "" },
    { id: 2, siteId: 1, daireId: 3, sakinAd: "Ayşe Yıldız", sakinTel: "0539 500 60 70", tarih: "2025-03-12", baslik: "Elektrik kesintisi", aciklama: "Balkon prizi çalışmıyor.", konum: "B Blok Daire 1 Balkon", durum: "devamEdiyor", adminNot: "Elektrikçi 15 Mart'ta gelecek." },
  ],
  sakinKullanicilari: [
    { id: 1, ad: "Can Öztürk", tel: "05362003040", sifre: "1234", siteId: 1, daireId: 1, rol: "sakin", aktif: true },
    { id: 2, ad: "Ayşe Yıldız", tel: "05395006070", sifre: "5678", siteId: 1, daireId: 3, rol: "sakin", aktif: true },
    { id: 3, ad: "Ahmet Yılmaz", tel: "05321112233", sifre: "yonetici", siteId: 1, daireId: null, rol: "siteYoneticisi", aktif: true },
  ],
  roller: [
    { id: 1, kullaniciId: 3, siteId: 1, rol: "siteYoneticisi" },
  ],
};

const AYLAR_TR = ["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"];
const BUGUN = new Date();

// Belirli ay/yıl için dönem aidat tutarını tarihe göre bul
function getDönemTutari(aidatTarihleri, siteId, yil, ay) {
  const tarih = new Date(yil, ay - 1, 15);
  const liste = (aidatTarihleri || [])
    .filter(a => String(a.siteId) === String(siteId))
    .filter(a => {
      const bas = new Date(a.baslangicTarihi);
      const bit = a.bitisTarihi ? new Date(a.bitisTarihi) : new Date("2099-12-31");
      return tarih >= bas && tarih <= bit;
    })
    .sort((a, b) => new Date(b.baslangicTarihi) - new Date(a.baslangicTarihi));
  return liste.length > 0 ? Number(liste[0].tutar) : 0;
}

// ============================================================
// MERKEZ KASA HESABI — Tüm kaynaklardan otomatik
// ============================================================
function hesaplaKasa(data) {
  // GELİRLER
  const manuelGelir = (data.gelir || []).reduce((s, x) => s + x.tutar, 0);
  // İşlerden gelen ödemeler (odendi olanlar)
  const isGelir = (data.isler || []).filter(i => i.odemeDurum === "odendi").reduce((s, x) => s + x.bedel, 0);
  // Düzenli müşteri tahsilatları
  const musteriGelir = (data.musteriIslemleri || []).filter(x => x.tip === "odeme").reduce((s, x) => s + x.tutar, 0);
  const toplamGelir = manuelGelir + isGelir + musteriGelir;

  // GİDERLER
  const manuelGider = (data.gider || []).reduce((s, x) => s + x.tutar, 0);
  // Personel avansları (kadrolu + ekstracı)
  const personelGider = (data.personelDetay || []).filter(x => x.tip === "avans").reduce((s, x) => s + x.tutar, 0);
  const toplamGider = manuelGider + personelGider;

  return { toplamGelir, toplamGider, bakiye: toplamGelir - toplamGider, manuelGelir, isGelir, musteriGelir, manuelGider, personelGider };
}

// ============================================================
// ARAMA + TARİH FİLTRE HOOK
// ============================================================
function useFiltre(items, searchFn, tarihFn) {
  const [arama, setArama] = useState("");
  const [baslangic, setBaslangic] = useState("");
  const [bitis, setBitis] = useState("");

  const filtreli = (items || []).filter(item => {
    const aramaEslesti = !arama || searchFn(item, arama.toLowerCase());
    const tarihEslesti = (!baslangic || (tarihFn(item) >= baslangic)) && (!bitis || (tarihFn(item) <= bitis));
    return aramaEslesti && tarihEslesti;
  });

  const FiltreBar = ({ placeholder = "Ara..." }) => (
    <div style={{ display: "flex", gap: 8, marginBottom: 14, flexWrap: "wrap", alignItems: "center" }}>
      <div style={{ position: "relative", flex: 1, minWidth: 180 }}>
        <span style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", fontSize: 14 }}>🔍</span>
        <input
          value={arama}
          onChange={e => setArama(e.target.value)}
          placeholder={placeholder}
          style={{ width: "100%", padding: "8px 12px 8px 32px", borderRadius: 9, border: "1px solid #e2e8f0", fontSize: 13, outline: "none", fontFamily: "inherit" }}
        />
        {arama && <button onClick={() => setArama("")} style={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#94a3b8", fontSize: 16 }}>×</button>}
      </div>
      <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
        <span style={{ fontSize: 12, color: "#64748b", whiteSpace: "nowrap" }}>Tarih:</span>
        <input type="date" value={baslangic} onChange={e => setBaslangic(e.target.value)} style={{ padding: "7px 10px", borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 12, outline: "none" }} />
        <span style={{ fontSize: 12, color: "#94a3b8" }}>—</span>
        <input type="date" value={bitis} onChange={e => setBitis(e.target.value)} style={{ padding: "7px 10px", borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 12, outline: "none" }} />
        {(baslangic || bitis) && <button onClick={() => { setBaslangic(""); setBitis(""); }} style={{ padding: "7px 10px", background: "#f1f5f9", border: "none", borderRadius: 8, cursor: "pointer", fontSize: 12, color: "#64748b" }}>Temizle</button>}
      </div>
      {filtreli.length !== (items || []).length && (
        <span style={{ fontSize: 12, color: "#3b82f6", background: "#dbeafe", padding: "4px 10px", borderRadius: 20, fontWeight: 600 }}>{filtreli.length} sonuç</span>
      )}
    </div>
  );

  return { filtreli, FiltreBar };
}

// ============================================================
// ICONS
// ============================================================
const Icon = ({ name, size = 20 }) => {
  const icons = {
    dashboard: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>,
    building: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="4" y="2" width="16" height="20"/><path d="M9 22V12h6v10"/><path d="M9 7h1"/><path d="M14 7h1"/></svg>,
    users: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
    money: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
    briefcase: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>,
    check: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>,
    wallet: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/><circle cx="16" cy="14" r="1" fill="currentColor"/></svg>,
    plus: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
    edit: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
    trash: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>,
    eye: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>,
    close: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
    back: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>,
    menu: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>,
    bell: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>,
    alert: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>,
    wrench: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>,
    shield: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
    settings: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
    paperclip: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>,
    home: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
    globe: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
    logout: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  };
  return icons[name] || null;
};

// ============================================================
// SHARED COMPONENTS
// ============================================================
function Modal({ title, onClose, children, wide, extraWide }) {
  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className={`modal-box ${wide ? "modal-wide" : ""} ${extraWide ? "modal-xwide" : ""}`}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="icon-btn" onClick={onClose}><Icon name="close" /></button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
}

function Field({ label, type = "text", value, onChange, options, required, fullWidth, placeholder }) {
  return (
    <div className={`field ${fullWidth ? "field-full" : ""}`}>
      <label>{label}{required && <span className="req">*</span>}</label>
      {type === "select" ? (
        <select value={value} onChange={(e) => onChange(e.target.value)}>
          <option value="">Seçiniz...</option>
          {options?.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      ) : type === "textarea" ? (
        <textarea value={value} onChange={(e) => onChange(e.target.value)} rows={3} placeholder={placeholder} />
      ) : (
        <input type={type} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} />
      )}
    </div>
  );
}

function Badge({ text, type }) {
  const types = { success: { bg: "#d1fae5", color: "#065f46" }, danger: { bg: "#fee2e2", color: "#991b1b" }, warning: { bg: "#fef3c7", color: "#92400e" }, info: { bg: "#dbeafe", color: "#1e40af" }, neutral: { bg: "#f1f5f9", color: "#475569" }, purple: { bg: "#ede9fe", color: "#5b21b6" } };
  const s = types[type] || types.neutral;
  return <span style={{ background: s.bg, color: s.color, padding: "2px 10px", borderRadius: 20, fontSize: 12, fontWeight: 600, whiteSpace: "nowrap" }}>{text}</span>;
}

// ============================================================
// LOGIN EKRANI
// ============================================================
function LoginScreen({ onLogin, t, data }) {
  const [form, setForm] = useState({ email: "", sifre: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const giris = async () => {
    setLoading(true);
    await new Promise(r => setTimeout(r, 600));

    const SUPA_URL = process.env.REACT_APP_SUPABASE_URL;
    const SUPA_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

    try {
      // Supabase app_data'dan tüm veriyi çek ve doğrula
      if (SUPA_URL && SUPA_KEY) {
        const res = await fetch(
          `${SUPA_URL}/rest/v1/app_data?id=eq.1&select=veri`,
          { headers: { apikey: SUPA_KEY, Authorization: `Bearer ${SUPA_KEY}` } }
        );
        const rows = await res.json();
        const appData = rows[0]?.veri;

        if (!appData) { setErr("Sunucuya bağlanılamadı."); setLoading(false); return; }

        const temizle = (s) => String(s||"").replace(/[\s\-\(\)]/g,"");

        // Süper Admin kontrolü (e-posta ile)
        if (form.email.includes("@")) {
          if (appData.adminProfile?.email === form.email && appData.adminProfile?.sifre === form.sifre) {
            onLogin(null); return;
          }
          setErr("E-posta veya şifre hatalı."); setLoading(false); return;
        }

        // Site Yöneticisi kontrolü (telefon ile)
        const normTel = temizle(form.email);
        const sakinler = appData.sakinKullanicilari || [];
        const user = sakinler.find(u =>
          temizle(u.tel) === normTel &&
          String(u.sifre) === String(form.sifre) &&
          u.aktif !== false
        );
        if (user) {
          if (user.rol === "siteYoneticisi") {
            onLogin({ rol:"siteYoneticisi", siteId: Number(user.siteId), ad: user.ad });
            return;
          }
          setErr("Bu panel sadece yöneticiler içindir. Sakin panelini kullanın.");
          setLoading(false); return;
        }

        setErr("Telefon veya şifre hatalı."); setLoading(false); return;
      }

      setErr("E-posta/telefon veya şifre hatalı.");
    } catch(e) {
      console.error('Login hatası:', e);
      setErr("Bağlantı hatası. Tekrar deneyin.");
    }
    setLoading(false);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;800&display=swap');
        .lb-root { min-height:100vh; display:flex; font-family:'Inter',system-ui,sans-serif; }
        .lb-left {
          width:55%; background:#0f172a; display:flex; flex-direction:column;
          justify-content:space-between; align-items:center; padding:60px;
          position:relative; overflow:hidden;
        }
        .lb-left::before {
          content:''; position:absolute; top:-120px; right:-120px;
          width:400px; height:400px; border-radius:50%;
          background:radial-gradient(circle, rgba(59,130,246,0.18) 0%, transparent 70%);
        }
        .lb-left::after {
          content:''; position:absolute; bottom:-80px; left:-80px;
          width:300px; height:300px; border-radius:50%;
          background:radial-gradient(circle, rgba(99,102,241,0.15) 0%, transparent 70%);
        }
        .lb-brand { position:relative; z-index:1; text-align:center; margin-bottom:48px; }
        .lb-logo-wrap {
          width:80px; height:80px; background:linear-gradient(135deg,#3b82f6,#6366f1);
          border-radius:24px; display:flex; align-items:center; justify-content:center;
          margin:0 auto 20px; font-size:36px;
          box-shadow:0 20px 60px rgba(59,130,246,0.4);
        }
        .lb-appname { font-size:32px; font-weight:800; color:white; letter-spacing:-0.5px; }
        .lb-appsub { font-size:15px; color:#64748b; margin-top:6px; }
        .lb-features { position:relative; z-index:1; width:100%; max-width:320px; }
        .lb-feat { display:flex; align-items:center; gap:14px; padding:14px 0; border-bottom:1px solid rgba(255,255,255,0.06); }
        .lb-feat:last-child { border-bottom:none; }
        .lb-feat-ico { width:38px; height:38px; border-radius:10px; display:flex; align-items:center; justify-content:center; font-size:18px; flex-shrink:0; }
        .lb-feat-text { font-size:14px; color:#94a3b8; }
        .lb-feat-text strong { display:block; color:#e2e8f0; font-size:14px; font-weight:600; margin-bottom:1px; }
        .lb-right {
          width:45%; background:#f8fafc; display:flex; align-items:center; justify-content:center; padding:60px 50px;
        }
        .lb-form-wrap { width:100%; max-width:380px; }
        .lb-form-title { font-size:26px; font-weight:800; color:#0f172a; margin-bottom:6px; }
        .lb-form-sub { font-size:14px; color:#64748b; margin-bottom:36px; }
        .lb-field { margin-bottom:18px; }
        .lb-field label { display:block; font-size:13px; font-weight:600; color:#374151; margin-bottom:7px; }
        .lb-field input {
          width:100%; border:1.5px solid #e2e8f0; border-radius:12px;
          padding:13px 16px; font-size:14px; outline:none; background:white;
          color:#1e293b; font-family:inherit; transition:border-color 0.2s, box-shadow 0.2s;
        }
        .lb-field input:focus { border-color:#3b82f6; box-shadow:0 0 0 3px rgba(59,130,246,0.12); }
        .lb-err { background:#fee2e2; color:#991b1b; border-radius:10px; padding:10px 14px; font-size:13px; margin-bottom:16px; }
        .lb-btn {
          width:100%; background:linear-gradient(135deg,#3b82f6,#6366f1);
          color:white; border:none; border-radius:12px; padding:14px;
          font-size:15px; font-weight:700; cursor:pointer; font-family:inherit;
          transition:opacity 0.2s, transform 0.1s;
          display:flex; align-items:center; justify-content:center; gap:8px; min-height:50px;
        }
        .lb-btn:hover { opacity:0.92; }
        .lb-btn:active { transform:scale(0.99); }
        .lb-btn:disabled { opacity:0.7; cursor:wait; }
        .lb-demo { margin-top:20px; background:white; border:1px solid #e2e8f0; border-radius:12px; padding:14px 16px; }
        .lb-demo-label { font-size:11px; font-weight:600; color:#94a3b8; text-transform:uppercase; letter-spacing:0.5px; margin-bottom:8px; }
        .lb-demo-row { display:flex; justify-content:space-between; align-items:center; }
        .lb-demo-info { font-size:13px; color:#475569; }
        .lb-demo-info strong { color:#1e293b; }
        .lb-demo-btn {
          background:#f1f5f9; border:none; border-radius:8px; padding:6px 12px;
          font-size:12px; font-weight:600; color:#475569; cursor:pointer;
        }
        .lb-demo-btn:hover { background:#e2e8f0; }
        .lb-spinner { width:18px; height:18px; border:2px solid rgba(255,255,255,0.4); border-top-color:white; border-radius:50%; animation:lbspin 0.6s linear infinite; }
        @keyframes lbspin { to { transform:rotate(360deg); } }
        @media(max-width:768px) {
          .lb-root { flex-direction:column; }
          .lb-left { width:100%; padding:40px 24px; }
          .lb-features { display:none; }
          .lb-right { width:100%; padding:40px 24px; }
        }
      `}</style>
      <div className="lb-root">
        {/* SOL PANEL */}
        <div className="lb-left">
          <div className="lb-brand">
            <div className="lb-logo-wrap">🏠</div>
            <div className="lb-appname" style={{fontSize:20, lineHeight:1.3}}>Girne Temizlik</div>
            <div className="lb-appname" style={{fontSize:14, fontWeight:500, opacity:0.8, marginTop:2}}>ELG Homes Property Management</div>
            <div className="lb-appsub">Profesyonel Mülk Yönetim Sistemi</div>
          </div>
          <div className="lb-features">
            {[
              { ico: "🏢", bg: "rgba(59,130,246,0.15)", title: "Çoklu Site Yönetimi", sub: "Tüm sitelerinizi tek panelden yönetin" },
              { ico: "💳", bg: "rgba(16,185,129,0.15)", title: "Aidat & Ödeme Takibi", sub: "Otomatik bakiye devri ve hatırlatmalar" },
              { ico: "🔧", bg: "rgba(245,158,11,0.15)", title: "Arıza Bildirimleri", sub: "Sakinlerden anlık arıza takibi" },
              { ico: "📢", bg: "rgba(99,102,241,0.15)", title: "Duyuru Sistemi", sub: "PDF ekli duyurular tüm sakinlere" },
              { ico: "🌍", bg: "rgba(239,68,68,0.15)", title: "Çok Dilli Arayüz", sub: "Türkçe, İngilizce, Rusça destek" },
            ].map((f) => (
              <div key={f.title} className="lb-feat">
                <div className="lb-feat-ico" style={{ background: f.bg }}>{f.ico}</div>
                <div className="lb-feat-text"><strong>{f.title}</strong>{f.sub}</div>
              </div>
            ))}
          </div>
          {/* Copyright footer */}
          <div style={{ position:"relative", zIndex:1, marginTop:"auto", paddingTop:32, textAlign:"center" }}>
            <div style={{ fontSize:12, color:"rgba(148,163,184,0.8)", marginBottom:4 }}>
              © {new Date().getFullYear()} Girne Temizlik. Tüm Hakları Saklıdır.
            </div>
            <div style={{ fontSize:13, color:"rgba(148,163,184,0.9)", fontWeight:600 }}>
              📞 0542 875 5733
            </div>
          </div>
        </div>

        {/* SAĞ PANEL — FORM */}
        <div className="lb-right">
          <div className="lb-form-wrap">
            <div className="lb-form-title">Hoş Geldiniz 👋</div>
            <div className="lb-form-sub">Admin panelinize erişmek için giriş yapın</div>

            <div className="lb-field">
              <label>E-posta veya Telefon No</label>
              <input
                type="text"
                value={form.email}
                onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))}
                placeholder="admin@siteyonet.com veya 0532..."
                autoComplete="username"
              />
            </div>
            <div className="lb-field">
              <label>Şifre</label>
              <input
                type="password"
                value={form.sifre}
                onChange={(e) => setForm((p) => ({ ...p, sifre: e.target.value }))}
                placeholder="••••••••"
                onKeyDown={(e) => e.key === "Enter" && giris()}
                autoComplete="current-password"
              />
            </div>

            {err && <div className="lb-err">⚠️ {err}</div>}

            <button className="lb-btn" onClick={giris} disabled={loading}>
              {loading ? <span className="lb-spinner" /> : t.login}
            </button>

            {/* Sakin Paneli Giriş Linki */}
            <div style={{
              marginTop: 16,
              padding: "14px 18px",
              background: "linear-gradient(135deg,rgba(59,130,246,0.08),rgba(99,102,241,0.08))",
              border: "1px solid rgba(99,102,241,0.2)",
              borderRadius: 12,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 12,
            }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#e2e8f0" }}>🏠 Sakin misiniz?</div>
                <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2 }}>Sakin panelinize buradan giriş yapın</div>
              </div>
              <button
                onClick={() => {
                  localStorage.removeItem("sakin_session");
                  window.open(window.location.origin + "?panel=sakin", "_blank");
                }}
                style={{
                  background: "linear-gradient(135deg,#3b82f6,#6366f1)",
                  color: "white",
                  border: "none",
                  borderRadius: 9,
                  padding: "9px 16px",
                  fontSize: 12,
                  fontWeight: 700,
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                Sakin Girişi →
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

// ============================================================
// ADMİN AYARLARI — Profil, Ödeme Entegrasyonu, Webhook, Loglar
// ============================================================
function AdminAyarlari({ data, setData, t }) {
  const [tab, setTab] = useState("profil"); // profil | odeme | webhook | loglar
  const [form, setForm] = useState({ ...data.adminProfile });
  const [odemeForm, setOdemeForm] = useState({ ...(data.odemeEntegrasyon || MOCK.odemeEntegrasyon) });
  const [profilKaydedildi, setProfilKaydedildi] = useState(false);
  const [odemeKaydedildi, setOdemeKaydedildi] = useState(false);
  const [mockOdemeForm, setMockOdemeForm] = useState({ daireId:"", ayKey:"", tutar:"", ad:"" });
  const [mockSonuc, setMockSonuc] = useState(null);

  const saveProfil = () => {
    setData(d => ({ ...d, adminProfile: { ...form } }));
    setProfilKaydedildi(true);
    setTimeout(() => setProfilKaydedildi(false), 2500);
  };

  const saveOdeme = () => {
    setData(d => ({ ...d, odemeEntegrasyon: { ...odemeForm } }));
    setOdemeKaydedildi(true);
    setTimeout(() => setOdemeKaydedildi(false), 2500);
  };

  // Webhook payload işle → daire ödeme kaydını güncelle
  const webhookOdemeKaydet = (daireId, ayKey, tutar, ad) => {
    const tarih = new Date().toISOString().split("T")[0];
    const key = `${daireId}_${ayKey}`;
    const mevcutOdeme = data.daireOdemeler?.[key] || { aidat: {}, flat: { tutar: 0, tarih: "" }, diger: [] };
    const log = {
      id: Date.now(),
      tarih,
      daireId: Number(daireId),
      ayKey,
      tutar: Number(tutar),
      ad,
      durum: "basarili",
      kaynak: "webhook",
    };
    setData(d => ({
      ...d,
      daireOdemeler: {
        ...d.daireOdemeler,
        [key]: { ...mevcutOdeme, aidat: { durum: "odendi", tarih } },
      },
      // Gelir kaydı ekle
      gelir: [...d.gelir, {
        id: Date.now() + 1,
        tarih,
        tutar: Number(tutar),
        aciklama: `Online aidat ödemesi — ${ad || `Daire ${daireId}`} (${ayKey})`,
        kaynak: `webhook_${key}`,
      }],
      // Webhook log'u ekle
      webhookLoglari: [...(d.webhookLoglari || []), log],
    }));
    return log;
  };

  // Mock webhook tetikle
  const mockWebhookGonder = () => {
    const { daireId, ayKey, tutar, ad } = mockOdemeForm;
    if (!daireId || !ayKey) { setMockSonuc({ tip: "hata", mesaj: "Daire ID ve ay zorunludur." }); return; }
    const log = webhookOdemeKaydet(daireId, ayKey, tutar || data.siteDetay?.find(d=>d.id===Number(daireId))?.aidatBedeli || 800, ad || "Test");
    setMockSonuc({ tip: "basarili", log });
    setTimeout(() => setMockSonuc(null), 6000);
  };

  const fp = (k, v) => setForm(p => ({ ...p, [k]: v }));
  const fo = (k, v) => setOdemeForm(p => ({ ...p, [k]: v }));

  const sagLayicilar = [
    { value:"iyzico", label:"iyzico",   logo:"💳", renk:"#1a1a2e", aciklama:"Türkiye'nin önde gelen ödeme altyapısı" },
    { value:"paytr",  label:"PayTR",    logo:"💳", renk:"#003087", aciklama:"Hızlı entegrasyon, düşük komisyon" },
    { value:"stripe", label:"Stripe",   logo:"💳", renk:"#635bff", aciklama:"Global ödeme altyapısı" },
    { value:"custom", label:"Özel URL", logo:"🔗", renk:"#0f172a", aciklama:"Kendi ödeme sayfanızı entegre edin" },
  ];

  const entStatus = data.odemeEntegrasyon || MOCK.odemeEntegrasyon;
  const loglari = data.webhookLoglari || [];

  // Webhook URL — sadece gösterim için (gerçek backend olmadan simülasyon)
  const webhookUrl = `${window.location.origin}/api/webhook/odeme?token=${btoa(entStatus.secretKey || "demo")}`;

  const tabList = [
    ["profil",  "👤 Profil"],
    ["odeme",   "💳 Ödeme Entegrasyonu"],
    ["webhook", "🔗 Webhook Ayarları"],
    ["loglar",  `📋 Ödeme Logları ${loglari.length > 0 ? `(${loglari.length})` : ""}`],
    ["yedek",   "💾 Yedek & Geri Yükleme"],
  ];

  return (
    <div className="page">
      <div className="page-header"><h2>{t.adminSettings}</h2></div>

      {/* SEKMELER */}
      <div style={{ display:"flex", gap:4, marginBottom:24, flexWrap:"wrap" }}>
        {tabList.map(([id, lbl]) => (
          <button key={id} onClick={() => setTab(id)} style={{
            padding:"8px 16px", borderRadius:9, border:"1px solid #e2e8f0", cursor:"pointer",
            fontWeight:600, fontSize:13, background:tab===id?"#0f172a":"white",
            color:tab===id?"white":"#475569", transition:"all 0.15s",
          }}>{lbl}</button>
        ))}
      </div>

      {/* ──── PROFİL ──── */}
      {tab==="profil" && (
        <div style={{ background:"white", borderRadius:16, padding:24, border:"1px solid #e2e8f0", maxWidth:600 }}>
          <div style={{ display:"flex", alignItems:"center", gap:16, marginBottom:24 }}>
            <div style={{ width:60, height:60, background:"linear-gradient(135deg,#3b82f6,#6366f1)", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", color:"white", fontSize:22, fontWeight:700 }}>
              {(form.ad||"A").split(" ").map(w=>w[0]).join("").slice(0,2)}
            </div>
            <div><div style={{fontSize:18,fontWeight:700}}>{data.adminProfile.ad}</div><div style={{fontSize:13,color:"#64748b"}}>Süper Admin</div></div>
          </div>
          <div className="form-grid">
            <Field label={t.name} value={form.ad} onChange={v=>fp("ad",v)} />
            <Field label="E-posta" type="email" value={form.email} onChange={v=>fp("email",v)} />
            <Field label={t.phone} value={form.tel} onChange={v=>fp("tel",v)} />
            <Field label={t.password} type="password" value={form.sifre} onChange={v=>fp("sifre",v)} />
          </div>
          {profilKaydedildi && <div style={{background:"#d1fae5",color:"#065f46",padding:"10px 14px",borderRadius:10,fontSize:13,fontWeight:600,marginTop:12}}>✅ Profil güncellendi!</div>}
          <div style={{marginTop:20,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <button style={{background:"#fee2e2",color:"#991b1b",border:"none",borderRadius:8,padding:"8px 16px",cursor:"pointer",fontSize:13,fontWeight:600}}
              onClick={()=>{
  if(window.confirm("Tüm veriler sıfırlanacak. Emin misiniz?")) {
    supabase.from('app_data').upsert({ id: 1, veri: null }).then(() => window.location.reload());
  }
}}>
              🗑️ Verileri Sıfırla
            </button>
            <button className="btn-primary" onClick={saveProfil}>{t.updateProfile}</button>
          </div>
        </div>
      )}

      {/* ──── ÖDEME ENTEGRASYONU ──── */}
      {tab==="odeme" && (
        <div style={{ maxWidth:700 }}>
          {/* Durum banner */}
          <div style={{ background:entStatus.aktif?"linear-gradient(135deg,#064e3b,#065f46)":"linear-gradient(135deg,#1e293b,#334155)",
            borderRadius:14, padding:"16px 20px", marginBottom:20, display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:12 }}>
            <div style={{display:"flex",alignItems:"center",gap:12}}>
              <div style={{fontSize:32}}>{entStatus.aktif?"✅":"⭕"}</div>
              <div>
                <div style={{fontSize:15,fontWeight:700,color:"white"}}>Online Ödeme {entStatus.aktif?"Aktif":"Pasif"}</div>
                <div style={{fontSize:12,color:"#94a3b8"}}>{entStatus.aktif?`${entStatus.sagLayici?.toUpperCase()} entegrasyonu${entStatus.testModu?" · Test Modu":""}` : "Sakinler online ödeme yapamaz"}</div>
              </div>
            </div>
            <button onClick={()=>fo("aktif",!odemeForm.aktif)} style={{
              background:odemeForm.aktif?"#10b981":"#ef4444", color:"white", border:"none", borderRadius:10, padding:"8px 20px", cursor:"pointer", fontWeight:700, fontSize:13 }}>
              {odemeForm.aktif?"🟢 Aktif — Kapat":"🔴 Pasif — Aç"}
            </button>
          </div>

          <div style={{background:"white",borderRadius:16,padding:24,border:"1px solid #e2e8f0"}}>
            <div style={{fontSize:15,fontWeight:700,marginBottom:16}}>Ödeme Sağlayıcısı</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:8,marginBottom:20}}>
              {sagLayicilar.map(s=>(
                <button key={s.value} onClick={()=>fo("sagLayici",s.value)} style={{
                  padding:"12px 14px", borderRadius:10, border:`2px solid ${odemeForm.sagLayici===s.value?"#3b82f6":"#e2e8f0"}`,
                  background:odemeForm.sagLayici===s.value?"#eff6ff":"white", cursor:"pointer", textAlign:"left"}}>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <span style={{fontSize:18}}>{s.logo}</span>
                    <div>
                      <div style={{fontWeight:700,fontSize:13,color:odemeForm.sagLayici===s.value?"#1d4ed8":"#1e293b"}}>{s.label}</div>
                      <div style={{fontSize:11,color:"#64748b"}}>{s.aciklama}</div>
                    </div>
                  </div>
                </button>
              ))}
            </div>

            {odemeForm.sagLayici==="custom" ? (
              <div className="form-grid">
                <Field label="Ödeme Sayfası URL" value={odemeForm.odemeSayfaUrl} onChange={v=>fo("odemeSayfaUrl",v)} fullWidth placeholder="https://odeme.sirketiniz.com/aidat"/>
                <Field label="Açıklama (Sakinlere gösterilir)" value={odemeForm.aciklama} onChange={v=>fo("aciklama",v)} fullWidth placeholder="Online ödeme için tıklayın..."/>
              </div>
            ) : (
              <div className="form-grid">
                <Field label="API Key" value={odemeForm.apiKey} onChange={v=>fo("apiKey",v)} placeholder="pk_live_..."/>
                <Field label="Secret Key" value={odemeForm.secretKey} onChange={v=>fo("secretKey",v)} type="password" placeholder="sk_live_..."/>
                <Field label="Merchant ID" value={odemeForm.merchantId} onChange={v=>fo("merchantId",v)} placeholder="Mağaza ID"/>
                <div style={{display:"flex",flexDirection:"column",gap:6}}>
                  <label style={{fontSize:12,fontWeight:600,color:"#374151"}}>Mod</label>
                  <button onClick={()=>fo("testModu",!odemeForm.testModu)} style={{
                    padding:"10px 14px", border:"1px solid #e2e8f0", borderRadius:10, cursor:"pointer",
                    background:odemeForm.testModu?"#fef3c7":"#d1fae5", color:odemeForm.testModu?"#92400e":"#065f46",
                    fontWeight:600, fontSize:13, textAlign:"left"}}>
                    {odemeForm.testModu?"🧪 Test Modu":"✅ Canlı Mod"}
                  </button>
                </div>
                <Field label="Başarılı Ödeme Yönlendirme URL (Return URL)" value={odemeForm.returnUrl||""} onChange={v=>fo("returnUrl",v)} placeholder="https://siteyonet.com/odeme-basarili" fullWidth/>
                <Field label="Ödeme Sayfası URL (isteğe bağlı)" value={odemeForm.odemeSayfaUrl||""} onChange={v=>fo("odemeSayfaUrl",v)} placeholder="https://eft.iyzipay.com/..." fullWidth/>
              </div>
            )}

            {odemeKaydedildi && <div style={{background:"#d1fae5",color:"#065f46",padding:"10px 14px",borderRadius:10,fontSize:13,fontWeight:600,marginTop:12}}>✅ Ayarlar kaydedildi!</div>}
            <div style={{marginTop:16,display:"flex",justifyContent:"flex-end"}}>
              <button className="btn-primary" onClick={saveOdeme}>💾 Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {/* ──── WEBHOOK AYARLARI ──── */}
      {tab==="webhook" && (
        <div style={{ maxWidth:720 }}>
          {/* Webhook nedir? */}
          <div style={{background:"linear-gradient(135deg,#1e293b,#334155)",borderRadius:14,padding:"18px 22px",marginBottom:20,color:"white"}}>
            <div style={{fontSize:16,fontWeight:800,marginBottom:6}}>🔗 Webhook Sistemi</div>
            <div style={{fontSize:13,color:"#94a3b8",lineHeight:1.6}}>
              Ödeme sağlayıcısı (iyzico, PayTR, Stripe) ödeme başarıyla tamamlandığında bu URL'e otomatik bildirim gönderir.
              Sistem bu bildirimi alıp aidat kaydını <strong style={{color:"#10b981"}}>otomatik "Ödendi"</strong> olarak işaretler ve kasaya gelir kaydeder.
            </div>
          </div>

          {/* Webhook URL kartı */}
          <div style={{background:"white",borderRadius:16,padding:24,border:"1px solid #e2e8f0",marginBottom:16}}>
            <div style={{fontSize:14,fontWeight:700,marginBottom:12}}>📌 Sisteminizin Webhook Endpoint URL'i</div>
            <div style={{background:"#f8fafc",borderRadius:10,padding:"12px 16px",border:"1px solid #e2e8f0",marginBottom:12}}>
              <div style={{fontSize:11,color:"#64748b",marginBottom:4}}>Bu URL'i ödeme sağlayıcınızın paneline girin:</div>
              <div style={{fontFamily:"monospace",fontSize:13,color:"#1e293b",wordBreak:"break-all",fontWeight:600}}>
                {webhookUrl}
              </div>
              <button onClick={()=>{ navigator.clipboard.writeText(webhookUrl); }} style={{marginTop:8,background:"#dbeafe",color:"#1d4ed8",border:"none",borderRadius:7,padding:"5px 12px",fontSize:12,cursor:"pointer",fontWeight:600}}>
                📋 Kopyala
              </button>
            </div>

            {/* Her sağlayıcı için kurulum rehberi */}
            <div style={{fontSize:14,fontWeight:700,marginBottom:12}}>📖 Sağlayıcı Bazlı Kurulum</div>
            {[
              {
                name:"iyzico",
                logo:"💳",
                renk:"#1a1a2e",
                adimlar:[
                  "iyzico Merchant Panel → Ayarlar → Webhook Ayarları",
                  "Webhook URL alanına yukarıdaki URL'i yapıştırın",
                  "Tetikleyici olay: PAYMENT_SUCCESS seçin",
                  "Secret Key: Admin panelindeki Secret Key ile aynı olmalı",
                  "Kaydedin ve 'Test Webhook Gönder' ile doğrulayın",
                ],
              },
              {
                name:"PayTR",
                logo:"💳",
                renk:"#003087",
                adimlar:[
                  "PayTR Merchant Panel → Mağaza Ayarları → Bildirim URL",
                  "Başarılı Ödeme Bildirim URL alanına URL'i yapıştırın",
                  "Merchant Key: Admin panelindeki Secret Key ile eşleşmeli",
                  "Hash algoritması: SHA-256 seçin",
                  "Kaydet — PayTR test ödemesiyle doğrulayın",
                ],
              },
              {
                name:"Stripe",
                logo:"💳",
                renk:"#635bff",
                adimlar:[
                  "Stripe Dashboard → Developers → Webhooks",
                  "'Add endpoint' → URL alanına yukarıdaki URL'i girin",
                  "Event: payment_intent.succeeded seçin",
                  "Webhook signing secret'i kopyalayıp Secret Key alanına yapıştırın",
                  "'Test webhook' ile doğrulayın",
                ],
              },
            ].map(s=>(
              <details key={s.name} style={{marginBottom:8,border:"1px solid #e2e8f0",borderRadius:10,overflow:"hidden"}}>
                <summary style={{padding:"12px 16px",cursor:"pointer",fontWeight:700,fontSize:13,background:"#f8fafc",display:"flex",alignItems:"center",gap:8}}>
                  <span style={{fontSize:16}}>{s.logo}</span> {s.name} Kurulumu
                </summary>
                <div style={{padding:"14px 16px"}}>
                  {s.adimlar.map((a,i)=>(
                    <div key={i} style={{display:"flex",gap:10,marginBottom:8}}>
                      <div style={{width:22,height:22,borderRadius:"50%",background:"#3b82f6",color:"white",fontSize:11,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>{i+1}</div>
                      <div style={{fontSize:13,color:"#374151",lineHeight:1.5}}>{a}</div>
                    </div>
                  ))}
                </div>
              </details>
            ))}
          </div>

          {/* Webhook payload formatı */}
          <div style={{background:"white",borderRadius:16,padding:24,border:"1px solid #e2e8f0",marginBottom:16}}>
            <div style={{fontSize:14,fontWeight:700,marginBottom:12}}>📦 Beklenen Webhook Payload Formatı</div>
            <div style={{background:"#0f172a",borderRadius:10,padding:"14px 18px",fontFamily:"monospace",fontSize:12,color:"#e2e8f0",lineHeight:1.8}}>
              <div style={{color:"#64748b",marginBottom:6}}>// POST {`{webhookUrl}`}</div>
              <div style={{color:"#7dd3fc"}}>{`{`}</div>
              <div style={{paddingLeft:16}}>
                <div><span style={{color:"#86efac"}}>"event"</span>: <span style={{color:"#fde68a"}}>"payment.success"</span>,</div>
                <div><span style={{color:"#86efac"}}>"daireId"</span>: <span style={{color:"#fde68a"}}>"1"</span>,&nbsp;<span style={{color:"#64748b"}}>// Daire ID (siteDetay)</span></div>
                <div><span style={{color:"#86efac"}}>"ayKey"</span>: <span style={{color:"#fde68a"}}>"2025-03"</span>,&nbsp;<span style={{color:"#64748b"}}>// YYYY-MM formatı</span></div>
                <div><span style={{color:"#86efac"}}>"tutar"</span>: <span style={{color:"#c084fc"}}>{`800`}</span>,</div>
                <div><span style={{color:"#86efac"}}>"sakinAd"</span>: <span style={{color:"#fde68a"}}>"Can Öztürk"</span>,</div>
                <div><span style={{color:"#86efac"}}>"token"</span>: <span style={{color:"#fde68a"}}>"secretkey_hash"</span></div>
              </div>
              <div style={{color:"#7dd3fc"}}>{`}`}</div>
            </div>
            <div style={{marginTop:10,fontSize:12,color:"#64748b"}}>
              ⚠️ URL'e gelen token, Secret Key'in base64 hash'i ile eşleşmezse istek reddedilir.
            </div>
          </div>

          {/* Mock Webhook Test Paneli */}
          <div style={{background:"white",borderRadius:16,padding:24,border:"2px dashed #e2e8f0"}}>
            <div style={{fontSize:14,fontWeight:700,marginBottom:4}}>🧪 Mock Webhook Test Paneli</div>
            <div style={{fontSize:12,color:"#64748b",marginBottom:16}}>Backend olmadan, webhook'u simüle ederek gerçek ödeme akışını test edin.</div>
            <div className="form-grid">
              <div style={{display:"flex",flexDirection:"column",gap:5}}>
                <label style={{fontSize:12,fontWeight:600,color:"#374151"}}>Daire ID</label>
                <select value={mockOdemeForm.daireId} onChange={e=>setMockOdemeForm(p=>({...p,daireId:e.target.value}))}
                  style={{padding:"9px 12px",borderRadius:9,border:"1px solid #e2e8f0",fontSize:13,outline:"none"}}>
                  <option value="">— Daire seç —</option>
                  {(data.siteDetay||[]).map(d=>(
                    <option key={d.id} value={d.id}>{d.blok} Blok Daire {d.daireNo} — {d.kiraci||d.evSahibi}</option>
                  ))}
                </select>
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:5}}>
                <label style={{fontSize:12,fontWeight:600,color:"#374151"}}>Ay (YYYY-MM)</label>
                <input value={mockOdemeForm.ayKey} onChange={e=>setMockOdemeForm(p=>({...p,ayKey:e.target.value}))}
                  placeholder="2025-03" style={{padding:"9px 12px",borderRadius:9,border:"1px solid #e2e8f0",fontSize:13,outline:"none"}}/>
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:5}}>
                <label style={{fontSize:12,fontWeight:600,color:"#374151"}}>Tutar (₺)</label>
                <input type="number" value={mockOdemeForm.tutar} onChange={e=>setMockOdemeForm(p=>({...p,tutar:e.target.value}))}
                  placeholder="800" style={{padding:"9px 12px",borderRadius:9,border:"1px solid #e2e8f0",fontSize:13,outline:"none"}}/>
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:5}}>
                <label style={{fontSize:12,fontWeight:600,color:"#374151"}}>Sakin Adı</label>
                <input value={mockOdemeForm.ad} onChange={e=>setMockOdemeForm(p=>({...p,ad:e.target.value}))}
                  placeholder="Can Öztürk" style={{padding:"9px 12px",borderRadius:9,border:"1px solid #e2e8f0",fontSize:13,outline:"none"}}/>
              </div>
            </div>
            {mockSonuc && (
              <div style={{marginTop:14,padding:"12px 16px",borderRadius:10,
                background:mockSonuc.tip==="basarili"?"#d1fae5":"#fee2e2",
                color:mockSonuc.tip==="basarili"?"#065f46":"#991b1b",fontSize:13,fontWeight:600}}>
                {mockSonuc.tip==="basarili"
                  ? `✅ Webhook simüle edildi! Daire ${mockSonuc.log?.daireId} — ${mockSonuc.log?.ayKey} → Ödendi olarak işaretlendi. Kasa güncellendi.`
                  : `❌ ${mockSonuc.mesaj}`}
              </div>
            )}
            <div style={{marginTop:14,display:"flex",justifyContent:"flex-end"}}>
              <button className="btn-primary" onClick={mockWebhookGonder} style={{display:"flex",alignItems:"center",gap:8}}>
                <Icon name="send" size={15}/> Mock Webhook Gönder
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ──── ÖDEME LOGLARI ──── */}
      {tab==="loglar" && (
        <div style={{ maxWidth:800 }}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
            <div>
              <div style={{fontSize:15,fontWeight:700}}>📋 Webhook Ödeme Logları</div>
              <div style={{fontSize:12,color:"#64748b"}}>Tüm webhook bildirimleri ve işlem sonuçları</div>
            </div>
            {loglari.length>0&&(
              <button onClick={()=>{ if(window.confirm("Tüm loglar silinsin mi?")) setData(d=>({...d,webhookLoglari:[]})); }}
                style={{background:"#fee2e2",color:"#991b1b",border:"none",borderRadius:8,padding:"7px 14px",cursor:"pointer",fontSize:12,fontWeight:600}}>
                🗑️ Logları Temizle
              </button>
            )}
          </div>
          {loglari.length===0 ? (
            <div style={{background:"white",borderRadius:14,border:"1px solid #e2e8f0",padding:40,textAlign:"center",color:"#94a3b8"}}>
              <div style={{fontSize:32,marginBottom:8}}>📭</div>
              <div style={{fontWeight:600}}>Henüz webhook logu yok.</div>
              <div style={{fontSize:12,marginTop:4}}>Webhook sekmesinden mock test gönderin veya gerçek ödeme yapın.</div>
            </div>
          ) : (
            <div style={{background:"white",borderRadius:14,border:"1px solid #e2e8f0",overflow:"hidden"}}>
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Tarih</th>
                    <th>Daire</th>
                    <th>Dönem</th>
                    <th>Tutar</th>
                    <th>Sakin</th>
                    <th>Kaynak</th>
                    <th>Durum</th>
                  </tr>
                </thead>
                <tbody>
                  {[...loglari].reverse().map(l=>{
                    const daire = (data.siteDetay||[]).find(d=>d.id===Number(l.daireId));
                    return (
                      <tr key={l.id}>
                        <td style={{fontSize:12}}>{l.tarih}</td>
                        <td>{daire ? `${daire.blok} Blok D:${daire.daireNo}` : `Daire ${l.daireId}`}</td>
                        <td style={{fontFamily:"monospace",fontSize:12}}>{l.ayKey}</td>
                        <td><strong style={{color:"#10b981"}}>₺{Number(l.tutar).toLocaleString()}</strong></td>
                        <td>{l.ad}</td>
                        <td>
                          <span style={{background:"#ede9fe",color:"#6d28d9",padding:"2px 8px",borderRadius:20,fontSize:11,fontWeight:600}}>
                            {l.kaynak==="webhook"?"🔗 Webhook":"👤 Manuel"}
                          </span>
                        </td>
                        <td><Badge text="Başarılı" type="success"/></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ──── YEDEK & GERİ YÜKLEME ──── */}
      {tab === "yedek" && (
        <div style={{ maxWidth: 700 }}>

          {/* Açıklama banner */}
          <div style={{ background:"linear-gradient(135deg,#1e293b,#334155)", borderRadius:14, padding:"16px 20px", marginBottom:20, color:"white" }}>
            <div style={{ fontSize:16, fontWeight:800, marginBottom:6 }}>💾 Veri Yedekleme Sistemi</div>
            <div style={{ fontSize:13, color:"#94a3b8", lineHeight:1.6 }}>
              Tüm site verileri (daireler, sakinler, aidatlar, gelir/gider, personel, rezervasyonlar) tek bir JSON dosyasına kaydedilir.
              İstediğiniz zaman yükleyerek sistemi geri yükleyebilirsiniz.
            </div>
          </div>

          {/* YEDEK AL */}
          <YedekAl data={data} />

          {/* GERİ YÜKLE */}
          <GeriYukle setData={setData} />

          {/* OTOMATİK YEDEK BİLGİSİ */}
          <div style={{ background:"white", borderRadius:14, border:"1px solid #e2e8f0", padding:20, marginTop:16 }}>
            <div style={{ fontSize:14, fontWeight:700, marginBottom:12 }}>📅 Otomatik Yedek Geçmişi</div>
            <OtomatikYedekListesi />
          </div>

        </div>
      )}
    </div>
  );
}

// ============================================================
// YEDEK & GERİ YÜKLEME BİLEŞENLERİ
// ============================================================

function YedekAl({ data }) {
  const [indirildi, setIndirildi] = useState(false);

  const yedekAl = async () => {
    const simdi = new Date();
    const tarihStr = `${simdi.getFullYear()}-${String(simdi.getMonth()+1).padStart(2,"0")}-${String(simdi.getDate()).padStart(2,"0")}`;
    const saatStr  = `${String(simdi.getHours()).padStart(2,"0")}${String(simdi.getMinutes()).padStart(2,"0")}`;
    const yedek = { versiyon:"1.0", olusturulma:simdi.toISOString(), uygulama:"Girne Temizlik - ELG Homes", veri:data };

    // Dosyalar artık Supabase app_data içinde base64 olarak saklanır
    yedek.idbDosyalar = {};

    // Sohbet mesajları artık app_data içinde siteMesajlar_X key'lerinde
    // Yedekte bunları ayrıca eklemiyoruz — app_data yedekle birlikte geliyor
    yedek.sohbetler = {};

    // İndir
    const json = JSON.stringify(yedek, null, 2);
    const blob = new Blob([json], { type:"application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href=url; a.download=`ELG_Yedek_${tarihStr}_${saatStr}.json`; a.click();
    URL.revokeObjectURL(url);

    // Yedek geçmişi
    try {
      // Yedek geçmişi artık izlenmiyor — Supabase veri kaynağı
    } catch {}

    setIndirildi(true); setTimeout(()=>setIndirildi(false), 3000);
  };

  const ist = [
    {l:"Siteler",      v:(data.siteler||[]).length},
    {l:"Daireler",     v:(data.siteDetay||[]).length},
    {l:"Sakinler",     v:(data.sakinKullanicilari||[]).length},
    {l:"Ödeme Kaydı",  v:Object.keys(data.daireOdemeler||{}).length},
    {l:"Personel",     v:(data.personel||[]).length},
    {l:"Duyurular",    v:(data.duyurular||[]).length},
    {l:"Arızalar",     v:(data.arizalar||[]).length},
    {l:"Gelir/Gider",  v:(data.gelir||[]).length+(data.gider||[]).length},
    {l:"Airbnb Rez.",  v:(data.airbnbRezervasyon||[]).length},
    {l:"Müşteriler",   v:(data.duzenlMusteriler||[]).length},
  ];

  return (
    <div style={{background:"white",borderRadius:14,border:"1px solid #e2e8f0",padding:20,marginBottom:16}}>
      <div style={{fontSize:14,fontWeight:700,marginBottom:4}}>📤 Yedek Al</div>
      <div style={{fontSize:12,color:"#64748b",marginBottom:14}}>Tüm veriler, duyuru dosyaları ve sohbet geçmişi dahil tek dosyaya kaydedilir.</div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(110px,1fr))",gap:8,marginBottom:16}}>
        {ist.map(s=>(
          <div key={s.l} style={{background:"#f8fafc",borderRadius:8,padding:"8px 10px",textAlign:"center"}}>
            <div style={{fontSize:18,fontWeight:800,color:"#0f172a"}}>{s.v}</div>
            <div style={{fontSize:10,color:"#64748b"}}>{s.l}</div>
          </div>
        ))}
      </div>
      <button onClick={yedekAl} style={{width:"100%",padding:14,
        background:indirildi?"linear-gradient(135deg,#10b981,#059669)":"linear-gradient(135deg,#3b82f6,#6366f1)",
        color:"white",border:"none",borderRadius:12,cursor:"pointer",fontWeight:800,fontSize:15,transition:"all 0.3s"}}>
        {indirildi?"✅ Yedek İndirildi!":"📥 Yedek Dosyası İndir (.json)"}
      </button>
    </div>
  );
}

function GeriYukle({ setData }) {
  const fileRef = useRef(null);
  const [onizleme, setOnizleme] = useState(null);
  const [hata, setHata] = useState("");
  const [yuklendi, setYuklendi] = useState(false);

  const dosyaOku = (e) => {
    const file = e.target.files?.[0]; if (!file) return;
    setHata(""); setOnizleme(null);
    const reader = new FileReader();
    reader.onload = (ev) => {
      try {
        const parsed = JSON.parse(ev.target.result);
        if (!parsed.veri || !parsed.versiyon) { setHata("Geçersiz yedek dosyası."); return; }
        setOnizleme(parsed);
      } catch { setHata("Dosya okunamadı. Geçerli bir .json yedek dosyası seçin."); }
    };
    reader.readAsText(file); e.target.value="";
  };

  const geriYukle = async () => {
    if (!onizleme) return;
    if (!window.confirm(`⚠️ DİKKAT: Mevcut tüm veriler silinecek!\n${new Date(onizleme.olusturulma).toLocaleString("tr-TR")} tarihli yedek yüklenecek.\n\nEmin misiniz?`)) return;

    setData(onizleme.veri);

    // Dosyalar artık Supabase app_data içinde — geri yükleme otomatik

    // Sohbet verileri app_data içinde — ayrıca geri yükleme gerekmez

    setYuklendi(true); setOnizleme(null);
    setTimeout(()=>setYuklendi(false), 4000);
  };

  return (
    <div style={{background:"white",borderRadius:14,border:"2px dashed #e2e8f0",padding:20}}>
      <div style={{fontSize:14,fontWeight:700,marginBottom:4}}>📂 Yedeği Geri Yükle</div>
      <div style={{fontSize:12,color:"#64748b",marginBottom:14}}>Daha önce indirdiğiniz <strong>.json</strong> yedek dosyasını seçin.</div>

      <input ref={fileRef} type="file" accept=".json" onChange={dosyaOku} style={{display:"none"}}/>
      <button onClick={()=>fileRef.current?.click()}
        style={{padding:"10px 20px",background:"#f8fafc",border:"1px solid #e2e8f0",borderRadius:10,cursor:"pointer",fontSize:13,fontWeight:600,color:"#475569",marginBottom:12}}>
        📁 JSON Dosyası Seç
      </button>

      {hata && <div style={{background:"#fee2e2",color:"#991b1b",borderRadius:8,padding:"10px 14px",fontSize:13,fontWeight:600,marginBottom:10}}>❌ {hata}</div>}
      {yuklendi && <div style={{background:"#d1fae5",color:"#065f46",borderRadius:8,padding:"10px 14px",fontSize:13,fontWeight:600,marginBottom:10}}>✅ Veri başarıyla geri yüklendi!</div>}

      {onizleme && (
        <div style={{background:"#f0fdf4",borderRadius:12,border:"1px solid #86efac",padding:16,marginBottom:14}}>
          <div style={{fontSize:13,fontWeight:700,color:"#065f46",marginBottom:10}}>📋 Yedek Önizleme</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,fontSize:12,marginBottom:14}}>
            {[
              ["Oluşturulma", new Date(onizleme.olusturulma).toLocaleString("tr-TR")],
              ["Versiyon", onizleme.versiyon],
              ["Siteler", (onizleme.veri.siteler||[]).length],
              ["Daireler", (onizleme.veri.siteDetay||[]).length],
              ["Sakinler", (onizleme.veri.sakinKullanicilari||[]).length],
              ["Duyuru Dosyası", Object.keys(onizleme.idbDosyalar||{}).length],
              ["Sohbet Kanalı", Object.keys(onizleme.sohbetler||{}).length],
              ["Airbnb Rez.", (onizleme.veri.airbnbRezervasyon||[]).length],
            ].map(([k,v])=>(
              <div key={k}><span style={{color:"#64748b"}}>{k}:</span> <strong>{v}</strong></div>
            ))}
          </div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>setOnizleme(null)}
              style={{flex:1,padding:10,background:"#f1f5f9",border:"none",borderRadius:9,cursor:"pointer",fontWeight:600,fontSize:13}}>
              İptal
            </button>
            <button onClick={geriYukle}
              style={{flex:2,padding:10,background:"linear-gradient(135deg,#ef4444,#dc2626)",color:"white",border:"none",borderRadius:9,cursor:"pointer",fontWeight:700,fontSize:13}}>
              ⚠️ Geri Yükle (Mevcut Veriler Silinir)
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

function OtomatikYedekListesi() {
  const liste = [];
  if (liste.length===0) return <div style={{color:"#94a3b8",fontSize:13,textAlign:"center",padding:16}}>Henüz yedek alınmamış.</div>;
  return (
    <div>
      <div style={{fontSize:12,color:"#64748b",marginBottom:10}}>Son {liste.length} yedek:</div>
      {liste.map((y,i)=>(
        <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:"#f8fafc",borderRadius:8,padding:"8px 12px",fontSize:12,marginBottom:6}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <span style={{fontSize:16}}>{i===0?"🟢":"⚪"}</span>
            <div>
              <div style={{fontWeight:600}}>{new Date(y.tarih).toLocaleString("tr-TR")}</div>
              {i===0&&<div style={{fontSize:10,color:"#10b981"}}>Son yedek</div>}
            </div>
          </div>
          <span style={{background:"#e2e8f0",borderRadius:20,padding:"2px 10px",fontWeight:600,color:"#475569"}}>{y.boyut}</span>
        </div>
      ))}
    </div>
  );
}

// ============================================================
// DASHBOARD
// ============================================================
function Dashboard({ data, t }) {
  const totalGelir = data.gelir.reduce((a, b) => a + b.tutar, 0);
  const totalGider = data.gider.reduce((a, b) => a + b.tutar, 0);
  const kasaOzet = hesaplaKasa(data);
  const kasa = kasaOzet.bakiye;
  const stats = [
    { label: t.balance, value: `₺${kasa.toLocaleString()}`, icon: "wallet", color: kasa >= 0 ? "#10b981" : "#ef4444", bg: kasa >= 0 ? "#d1fae5" : "#fee2e2" },
    { label: t.totalIncome, value: `₺${kasaOzet.toplamGelir.toLocaleString()}`, icon: "money", color: "#3b82f6", bg: "#dbeafe" },
    { label: t.totalExpense, value: `₺${kasaOzet.toplamGider.toLocaleString()}`, icon: "money", color: "#ef4444", bg: "#fee2e2" },
    { label: t.totalSites, value: data.siteler.length, icon: "building", color: "#8b5cf6", bg: "#ede9fe" },
    { label: t.pendingJobs, value: data.isler.filter((i) => i.odemeDurum === "bekliyor").length, icon: "briefcase", color: "#f59e0b", bg: "#fef3c7" },
    { label: t.faults, value: data.arizalar.filter((a) => a.durum !== "cozuldu").length, icon: "wrench", color: "#ef4444", bg: "#fee2e2" },
    { label: t.activePersonnel, value: data.personel.filter((p) => p.durum === "aktif").length, icon: "users", color: "#10b981", bg: "#d1fae5" },
    { label: t.announcements, value: data.duyurular.length, icon: "bell", color: "#6366f1", bg: "#e0e7ff" },
  ];
  return (
    <div className="page">
      <div className="page-header">
        <h2>{t.dashboard}</h2>
        <span style={{ color: "#64748b", fontSize: 13 }}>{BUGUN.toLocaleDateString("tr-TR", { weekday: "long", year: "numeric", month: "long", day: "numeric" })}</span>
      </div>
      <div className="stats-grid">
        {stats.map((s) => (
          <div key={s.label} className="stat-card">
            <div className="stat-icon" style={{ background: s.bg, color: s.color }}><Icon name={s.icon} size={24} /></div>
            <div><div className="stat-value" style={{ color: s.color }}>{s.value}</div><div className="stat-label">{s.label}</div></div>
          </div>
        ))}
      </div>
      <div className="dash-grid">
        <div className="dash-card">
          <h3>{t.faults}</h3>
          {data.arizalar.slice(0, 4).map((a) => (
            <div key={a.id} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid #f1f5f9", fontSize: 13 }}>
              <div><strong>{a.baslik}</strong><div style={{ fontSize: 12, color: "#94a3b8" }}>{a.sakinAd} · {a.tarih}</div></div>
              <Badge text={a.durum === "bildirildi" ? "Yeni" : a.durum === "devamEdiyor" ? "Devam" : "Çözüldü"} type={a.durum === "bildirildi" ? "danger" : a.durum === "devamEdiyor" ? "warning" : "success"} />
            </div>
          ))}
        </div>
        <div className="dash-card">
          <h3>{t.announcements}</h3>
          {data.duyurular.map((d) => (
            <div key={d.id} style={{ padding: "8px 0", borderBottom: "1px solid #f1f5f9" }}>
              <div style={{ fontSize: 13, fontWeight: 600 }}>{d.baslik}</div>
              <div style={{ fontSize: 12, color: "#94a3b8" }}>{d.tarih} · {d.siteId === 0 ? "Tüm Siteler" : data.siteler.find((s) => s.id === d.siteId)?.siteIsmi}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ============================================================
// SITELER
// ============================================================
function Siteler({ data, setData, onSelectSite, t }) {
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const emptyForm = { siteIsmi: "", yonetici: "", yoneticiTel: "", adres: "", elektrikAboneNo: "", havuzBakimci: "", asansorBakimci: "", aidatBedeli: "", bloklar: "", kayitTarihi: new Date().toISOString().split("T")[0] };
  const save = () => {
    const item = { ...form, aidatBedeli: Number(form.aidatBedeli), bloklar: form.bloklar.split(",").map((b) => b.trim()).filter(Boolean), id: modal === "edit" ? form.id : Date.now() };
    if (modal === "add") setData((d) => ({ ...d, siteler: [...d.siteler, item] }));
    else setData((d) => ({ ...d, siteler: d.siteler.map((s) => s.id === item.id ? item : s) }));
    setModal(null);
  };
  const del = (id) => { if (window.confirm("Bu siteyi silmek istediğinize emin misiniz?")) setData((d) => ({ ...d, siteler: d.siteler.filter((s) => s.id !== id) })); };
  const f = (k, v) => setForm((p) => ({ ...p, [k]: v }));
  return (
    <div className="page">
      <div className="page-header">
        <h2>{t.sites}</h2>
        <button className="btn-primary" onClick={() => { setForm(emptyForm); setModal("add"); }}><Icon name="plus" size={16} /> {t.newSite}</button>
      </div>
      <div className="card-grid">
        {data.siteler.map((s) => (
          <div key={s.id} className="site-card">
            <div className="site-card-header">
              <div className="site-icon"><Icon name="building" size={28} /></div>
              <div><h3>{s.siteIsmi}</h3><p>{s.adres}</p></div>
            </div>
            <div className="site-info-grid">
              <div><span>{t.name}</span><strong>{s.yonetici}</strong></div>
              <div><span>{t.dues}</span><strong>₺{s.aidatBedeli}</strong></div>
              <div><span>{t.block}</span><strong>{s.bloklar.join(", ")}</strong></div>
              <div><span>{t.date}</span><strong>{s.kayitTarihi}</strong></div>
            </div>
            <div className="card-actions">
              <button className="btn-outline" onClick={() => onSelectSite(s)}><Icon name="eye" size={15} /> {t.detail}</button>
              <button className="btn-outline" onClick={() => { setForm({ ...s, bloklar: s.bloklar.join(",") }); setModal("edit"); }}><Icon name="edit" size={15} /></button>
              <button className="btn-danger-outline" onClick={() => del(s.id)}><Icon name="trash" size={15} /></button>
            </div>
          </div>
        ))}
      </div>
      {modal && (
        <Modal title={modal === "add" ? t.newSite : t.edit} onClose={() => setModal(null)} wide>
          <div className="form-grid">
            <Field label="Site İsmi" value={form.siteIsmi} onChange={(v) => f("siteIsmi", v)} required />
            <Field label="Yönetici" value={form.yonetici} onChange={(v) => f("yonetici", v)} />
            <Field label="Yönetici Tel" value={form.yoneticiTel} onChange={(v) => f("yoneticiTel", v)} />
            <Field label="Aidat (₺)" type="number" value={form.aidatBedeli} onChange={(v) => f("aidatBedeli", v)} />
            <Field label={t.address} value={form.adres} onChange={(v) => f("adres", v)} />
            <Field label="Elektrik No" value={form.elektrikAboneNo} onChange={(v) => f("elektrikAboneNo", v)} />
            <Field label="Havuz Bakımcı" value={form.havuzBakimci} onChange={(v) => f("havuzBakimci", v)} />
            <Field label="Asansör Bakımcı" value={form.asansorBakimci} onChange={(v) => f("asansorBakimci", v)} />
            <Field label="Bloklar (A,B,C)" value={form.bloklar} onChange={(v) => f("bloklar", v)} />
            <Field label={t.date} type="date" value={form.kayitTarihi} onChange={(v) => f("kayitTarihi", v)} />
          </div>
          <div className="modal-footer"><button className="btn-secondary" onClick={() => setModal(null)}>{t.cancel}</button><button className="btn-primary" onClick={save}>{t.save}</button></div>
        </Modal>
      )}
    </div>
  );
}

// ============================================================
// DUYURULAR
// ============================================================
function Duyurular({ data, setData, t }) {
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({});
  const fileRef = useRef(null);
  const [cozulenUrlMap, setCozulenUrlMap] = useState({});
  const emptyForm = { siteId: 0, baslik: "", icerik: "", tarih: new Date().toISOString().split("T")[0], dosyaAdi: "", dosyaTur: "", dosyaUrl: "" };

  // Duyuru dosya URL'leri artık base64 olarak Supabase'de saklanır
  // __idb: ve __ref: eski formatlar — geriye dönük boş döner
  useEffect(() => {
    const yeni = {};
    for (const d of data.duyurular) {
      if (!d.dosyaUrl) continue;
      if (!d.dosyaUrl.startsWith("__")) {
        yeni[d.id] = d.dosyaUrl; // base64 veya URL — direkt kullan
      }
    }
    setCozulenUrlMap(yeni);
  }, [data.duyurular]); // eslint-disable-line react-hooks/exhaustive-deps

  const [hata, setHata] = useState("");

  const save = async () => {
    if (!form.baslik?.trim()) { setHata("Başlık zorunludur."); return; }
    setHata("");
    const id = Date.now();
    // Dosyayı doğrudan base64 olarak app_data içine kaydet (tüm cihazlarda görünsün)
    const item = { ...form, id, dosyaUrl: form.dosyaUrl || "" };
    setData((d) => ({ ...d, duyurular: [item, ...d.duyurular] }));
    setModal(false);
    setHata("");
  };

  const del = async (id) => {
    if (!window.confirm("Sil?")) return;
    const duyuru = data.duyurular.find(d => d.id === id);
    // Dosya Supabase'de duyuru verisiyle birlikte silinir
    setData((d) => ({ ...d, duyurular: d.duyurular.filter((x) => x.id !== id) }));
  };

  const handleFile = (e) => {
    const file = e.target.files?.[0]; if (!file) return;
    const tur = file.name.split(".").pop().toLowerCase();
    const reader = new FileReader();
    reader.onload = (ev) => setForm(p => ({ ...p, dosyaAdi: file.name, dosyaTur: tur, dosyaUrl: ev.target.result }));
    reader.readAsDataURL(file);
  };

  const f = (k, v) => setForm((p) => ({ ...p, [k]: v }));
  return (
    <div className="page">
      <div className="page-header">
        <h2>{t.announcements}</h2>
        <button className="btn-primary" onClick={() => { setForm(emptyForm); setModal(true); }}><Icon name="plus" size={16} /> {t.addAnnouncement}</button>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {data.duyurular.map((d) => {
          const site = data.siteler.find((s) => s.id === d.siteId);
          const gercekUrl = cozulenUrlMap[d.id] || "";
          return (
            <div key={d.id} style={{ background: "white", borderRadius: 14, padding: 20, border: "1px solid #e2e8f0" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
                <div>
                  <div style={{ fontSize: 16, fontWeight: 700 }}>{d.baslik}</div>
                  <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>{d.tarih} · {d.siteId === 0 ? "Tüm Siteler" : site?.siteIsmi}</div>
                </div>
                <button className="icon-btn danger" onClick={() => del(d.id)}><Icon name="trash" size={15} /></button>
              </div>
              <p style={{ fontSize: 14, color: "#475569", lineHeight: 1.6 }}>{d.icerik}</p>
              {d.dosyaAdi && (
                <div style={{ marginTop: 10, display: "flex", alignItems: "center", gap: 8, background: "#f8fafc", borderRadius: 8, padding: "8px 12px" }}>
                  <Icon name="paperclip" size={14} />
                  <span style={{ fontSize: 13, color: "#3b82f6", flex: 1 }}>{d.dosyaAdi}</span>
                  <Badge text={d.dosyaTur?.toUpperCase()} type="info" />
                  {gercekUrl && (
                    <button
                      onClick={() => { const a = document.createElement("a"); a.href = gercekUrl; a.download = d.dosyaAdi; a.click(); }}
                      style={{ background: "#3b82f6", color: "white", border: "none", borderRadius: 6, padding: "3px 10px", fontSize: 12, cursor: "pointer", fontWeight: 600 }}>
                      ⬇️ İndir
                    </button>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
      {modal && (
        <Modal title={t.addAnnouncement} onClose={() => setModal(false)} wide>
          <div className="form-grid">
            <Field label={t.publishTo} type="select" value={String(form.siteId)} onChange={(v) => f("siteId", Number(v))} options={[{ value: "0", label: "Tüm Siteler" }, ...data.siteler.map((s) => ({ value: String(s.id), label: s.siteIsmi }))]} />
            <Field label={t.date} type="date" value={form.tarih} onChange={(v) => f("tarih", v)} />
            <Field label="Başlık" value={form.baslik} onChange={(v) => f("baslik", v)} required fullWidth />
            <Field label="İçerik" type="textarea" value={form.icerik} onChange={(v) => f("icerik", v)} fullWidth />
          </div>
          <div style={{ marginTop: 16 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>{t.attachment} (PDF, Word, Excel, Resim)</label>
            <input ref={fileRef} type="file" accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.tif,.tiff" onChange={handleFile} style={{ fontSize: 13 }} />
            {form.dosyaAdi && (
              <div style={{ marginTop: 8, display: "flex", alignItems: "center", gap: 8, background: form.dosyaUrl ? "#d1fae5" : "#fef3c7", borderRadius: 8, padding: "8px 12px" }}>
                <Icon name="paperclip" size={13} />
                <span style={{ fontSize: 13, color: form.dosyaUrl ? "#065f46" : "#92400e", fontWeight: 600 }}>
                  {form.dosyaAdi} {form.dosyaUrl ? "✅ Hazır" : "⏳ Yükleniyor..."}
                </span>
              </div>
            )}
          </div>
          {hata && <div style={{ marginTop: 10, background: "#fee2e2", color: "#991b1b", borderRadius: 8, padding: "8px 12px", fontSize: 13, fontWeight: 600 }}>⚠️ {hata}</div>}
          <div className="modal-footer"><button className="btn-secondary" onClick={() => { setModal(false); setHata(""); }}>{t.cancel}</button><button className="btn-primary" onClick={save}>{t.save}</button></div>
        </Modal>
      )}
    </div>
  );
}

// ============================================================
// ARIZA TAKİP
// ============================================================
function ArizaTakip({ data, setData, t }) {
  const [raporModal, setRaporModal] = useState(false);
  const [selectedAriza, setSelectedAriza] = useState(null);
  const [adminNot, setAdminNot] = useState("");
  const [filterDurum, setFilterDurum] = useState("hepsi");
  const [mainTab, setMainTab] = useState("ariza"); // ariza | sikayet

  const durumlar = { bildirildi: { label: "Yeni Bildirim", type: "danger" }, devamEdiyor: { label: "Devam Ediyor", type: "warning" }, cozuldu: { label: "Çözüldü", type: "success" } };
  const sikayetDurumCfg = { bekliyor:{l:"Bekliyor",bg:"#fef3c7",c:"#92400e"}, inceleniyor:{l:"İnceleniyor",bg:"#dbeafe",c:"#185fa5"}, cozuldu:{l:"Çözüldü",bg:"#d1fae5",c:"#065f46"} };
  const turCfg = { sikayet:{l:"Şikayet",bg:"#fee2e2",c:"#991b1b"}, oneri:{l:"Öneri",bg:"#dbeafe",c:"#185fa5"}, gorus:{l:"Görüş",bg:"#ede9fe",c:"#533489"} };

  const guncelle = (id, durum) => {
    setData((d) => ({ ...d, arizalar: d.arizalar.map((a) => a.id === id ? { ...a, durum, adminNot: adminNot || a.adminNot } : a) }));
    setSelectedAriza(null);
  };

  const sikayetGuncelle = (id, durum) => {
    setData((d) => ({ ...d, sakinSikayetler: (d.sakinSikayetler||[]).map(s => s.id === id ? { ...s, durum } : s) }));
  };

  const sikayetler = data.sakinSikayetler || [];

  const durumFiltreli = filterDurum === "hepsi" ? data.arizalar : data.arizalar.filter((a) => a.durum === filterDurum);

  const { filtreli, FiltreBar } = useFiltre(
    durumFiltreli,
    (x, q) => x.baslik?.toLowerCase().includes(q) || x.sakinAd?.toLowerCase().includes(q) || x.konum?.toLowerCase().includes(q) || x.aciklama?.toLowerCase().includes(q),
    x => x.tarih
  );

  const { filtreli: filtreliSikayet, FiltreBar: SikayetFiltreBar } = useFiltre(
    sikayetler,
    (x, q) => x.baslik?.toLowerCase().includes(q) || x.kAd?.toLowerCase().includes(q) || x.icerik?.toLowerCase().includes(q),
    x => x.tarih
  );

  return (
    <div className="page">
      <div className="page-header">
        <h2>{t.faults}</h2>
        <div style={{display:"flex",gap:8}}><button className="btn-secondary" onClick={()=>setRaporModal(true)}>Rapor Al</button></div>
        {sikayetler.filter(s=>s.durum==="bekliyor").length > 0 && (
          <div style={{ background:"#fee2e2", color:"#991b1b", borderRadius:8, padding:"6px 12px", fontSize:12, fontWeight:700 }}>
            🔔 {sikayetler.filter(s=>s.durum==="bekliyor").length} bekleyen şikayet/öneri
          </div>
        )}
      </div>

      {/* Ana sekme: Arıza / Şikayet */}
      <div style={{ display:"flex", gap:0, marginBottom:16, background:"#f1f5f9", borderRadius:10, padding:4, width:"fit-content" }}>
        {[["ariza",`🔧 Arıza Bildirimleri (${data.arizalar.length})`],["sikayet",`💬 Şikayet & Görüş (${sikayetler.length})`]].map(([id,lbl])=>(
          <button key={id} onClick={()=>setMainTab(id)} style={{ padding:"8px 18px", borderRadius:8, border:"none", cursor:"pointer", fontWeight:700, fontSize:13,
            background:mainTab===id?"white":"transparent", color:mainTab===id?"#0f172a":"#64748b",
            boxShadow:mainTab===id?"0 1px 4px rgba(0,0,0,0.1)":"none" }}>
            {lbl}
          </button>
        ))}
      </div>

      {/* ─── ARIZA SEKMESİ ─── */}
      {mainTab==="ariza" && (
        <>
          <div className="tab-row" style={{ marginBottom: 12 }}>
            {[["hepsi","Tümü"],["bildirildi","Yeni"],["devamEdiyor","Devam Ediyor"],["cozuldu","Çözüldü"]].map(([v,l]) => (
              <button key={v} className={`tab-btn ${filterDurum===v?"active":""}`} onClick={() => setFilterDurum(v)}>{l} ({(v==="hepsi"?data.arizalar:data.arizalar.filter(a=>a.durum===v)).length})</button>
            ))}
          </div>
          <FiltreBar placeholder="Başlık, sakin adı veya konum ara..." />
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {filtreli.map((a) => {
              const site = data.siteler.find((s) => s.id === a.siteId);
              const cfg = durumlar[a.durum] || durumlar.bildirildi;
              return (
                <div key={a.id} style={{ background: "white", borderRadius: 14, padding: 18, border: "1px solid #e2e8f0" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
                    <div>
                      <div style={{ fontSize: 15, fontWeight: 700 }}>{a.baslik}</div>
                      <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>{site?.siteIsmi} · {a.konum} · {a.tarih}</div>
                    </div>
                    <Badge text={cfg.label} type={cfg.type} />
                  </div>
                  <p style={{ fontSize: 13, color: "#475569", marginBottom: 10 }}>{a.aciklama}</p>
                  <div style={{ display: "flex", gap: 8, alignItems: "center", justifyContent: "space-between" }}>
                    <div style={{ fontSize: 13 }}><strong>Sakin:</strong> {a.sakinAd} — {a.sakinTel}</div>
                    <button className="btn-outline" style={{ fontSize: 12 }} onClick={() => { setSelectedAriza(a); setAdminNot(a.adminNot || ""); }}>Durum Güncelle</button>
                  </div>
                  {a.adminNot && <div style={{ marginTop: 10, background: "#f0fdf4", borderRadius: 8, padding: "8px 12px", fontSize: 13, color: "#065f46" }}>📝 {a.adminNot}</div>}
                </div>
              );
            })}
            {filtreli.length === 0 && <div className="empty-state">Kayıt yok.</div>}
          </div>
        </>
      )}

      {/* ─── ŞİKAYET & GÖRÜŞ SEKMESİ ─── */}
      {mainTab==="sikayet" && (
        <>
          <SikayetFiltreBar placeholder="Başlık, sakin adı ara..." />
          <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
            {filtreliSikayet.sort((a,b)=>b.tarih.localeCompare(a.tarih)).map(s => {
              const tur = turCfg[s.tur] || { l:s.tur||"Diğer", bg:"#f1f5f9", c:"#475569" };
              const dur = sikayetDurumCfg[s.durum] || sikayetDurumCfg.bekliyor;
              const site = data.siteler.find(st => st.id === s.siteId);
              return (
                <div key={s.id} style={{ background:"white", borderRadius:14, padding:18, border:"1px solid #e2e8f0" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:8 }}>
                    <div style={{ display:"flex", gap:6, alignItems:"center", flexWrap:"wrap" }}>
                      <span style={{ background:tur.bg, color:tur.c, padding:"3px 10px", borderRadius:20, fontSize:11, fontWeight:600 }}>{tur.l}</span>
                      <span style={{ fontSize:14, fontWeight:700 }}>{s.baslik}</span>
                    </div>
                    <div style={{ display:"flex", gap:6, alignItems:"center" }}>
                      <span style={{ background:dur.bg, color:dur.c, padding:"3px 10px", borderRadius:20, fontSize:11, fontWeight:600 }}>{dur.l}</span>
                    </div>
                  </div>
                  <p style={{ fontSize:13, color:"#475569", marginBottom:8 }}>{s.icerik}</p>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:8 }}>
                    <div style={{ fontSize:12, color:"#64748b" }}>
                      👤 {s.kAd} {s.sakinTel && `· ${s.sakinTel}`}
                      {site && ` · ${site.siteIsmi}`}
                      {" · "}{s.tarih}
                    </div>
                    <div style={{ display:"flex", gap:6 }}>
                      {["bekliyor","inceleniyor","cozuldu"].map(d => (
                        <button key={d} onClick={()=>sikayetGuncelle(s.id, d)}
                          style={{ padding:"4px 10px", borderRadius:8, border:"1px solid #e2e8f0", cursor:"pointer", fontSize:11, fontWeight:600,
                            background:s.durum===d?sikayetDurumCfg[d].bg:"white", color:s.durum===d?sikayetDurumCfg[d].c:"#64748b" }}>
                          {sikayetDurumCfg[d].l}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })}
            {filtreliSikayet.length === 0 && <div className="empty-state">Henüz şikayet veya öneri yok.</div>}
          </div>
        </>
      )}

      {selectedAriza && (
        <Modal title="Arıza Durumu Güncelle" onClose={() => setSelectedAriza(null)}>
          <div style={{ marginBottom: 16 }}>
            <strong>{selectedAriza.baslik}</strong>
            <p style={{ fontSize: 13, color: "#64748b", marginTop: 4 }}>{selectedAriza.aciklama}</p>
          </div>
          <Field label="Admin Notu / Sakin Bilgilendirmesi" type="textarea" value={adminNot} onChange={setAdminNot} />
          <div className="modal-footer" style={{ flexWrap: "wrap", gap: 8 }}>
            <button className="btn-secondary" onClick={() => setSelectedAriza(null)}>{t.cancel}</button>
            <button style={{ background: "#fef3c7", color: "#92400e", border: "none", borderRadius: 8, padding: "8px 14px", cursor: "pointer", fontWeight: 600, fontSize: 13 }} onClick={() => guncelle(selectedAriza.id, "devamEdiyor")}>Devam Ediyor</button>
            <button className="btn-primary" onClick={() => guncelle(selectedAriza.id, "cozuldu")}>✓ Çözüldü</button>
          </div>
        </Modal>
      )}
      {raporModal && <EvrenselRaporModal tip="arizalar" data={data} onClose={()=>setRaporModal(false)} />}
    </div>
  );
}

// ============================================================
// SİTE GİDERLERİ
// ============================================================
function SiteGiderleri({ data, setData, t }) {
  const [raporModal, setRaporModal] = useState(false);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({});
  const [filterSite, setFilterSite] = useState(0);
  const fileRef = useRef(null);
  const emptyForm = { siteId: data.siteler[0]?.id || 1, tarih: new Date().toISOString().split("T")[0], tutar: "", aciklama: "", kategori: "bakim", dosyaAdi: "" };

  const save = () => {
    setData((d) => ({ ...d, siteGiderleri: [...(d.siteGiderleri || []), { ...form, tutar: Number(form.tutar), id: Date.now() }] }));
    setModal(false);
  };
  const del = (id) => { if (window.confirm("Sil?")) setData((d) => ({ ...d, siteGiderleri: d.siteGiderleri.filter((g) => g.id !== id) })); };

  const handleFile = (e) => {
    const file = e.target.files?.[0];
    if (file) setForm((p) => ({ ...p, dosyaAdi: file.name }));
  };

  const katRenk = { bakim: "#dbeafe", temizlik: "#d1fae5", bahce: "#dcfce7", havuz: "#cffafe", elektrik: "#fef3c7", guvenlik: "#ede9fe", diger: "#f1f5f9" };
  const siteFiltreli = filterSite === 0 ? (data.siteGiderleri || []) : (data.siteGiderleri || []).filter((g) => g.siteId === filterSite);

  const { filtreli, FiltreBar } = useFiltre(
    siteFiltreli,
    (x, q) => x.aciklama?.toLowerCase().includes(q) || x.kategori?.toLowerCase().includes(q),
    x => x.tarih
  );

  const toplam = filtreli.reduce((a, b) => a + b.tutar, 0);
  const f = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  return (
    <div className="page">
      <div className="page-header">
        <h2>{t.siteExpenses}</h2>
        <div style={{display:"flex",gap:8}}><button className="btn-secondary" onClick={()=>setRaporModal(true)}>Rapor Al</button></div>
        <button className="btn-primary" onClick={() => { setForm(emptyForm); setModal(true); }}><Icon name="plus" size={16} /> {t.addExpense}</button>
      </div>
      <div className="filter-tabs">
        <button className={`filter-tab ${filterSite===0?"active":""}`} onClick={() => setFilterSite(0)}>Tüm Siteler ({(data.siteGiderleri||[]).length})</button>
        {data.siteler.map((s) => <button key={s.id} className={`filter-tab ${filterSite===s.id?"active":""}`} onClick={() => setFilterSite(s.id)}>{s.siteIsmi} ({(data.siteGiderleri||[]).filter(g=>g.siteId===s.id).length})</button>)}
      </div>
      <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
        <div style={{ background: "#fee2e2", borderRadius: 12, padding: "10px 18px", border: "1px solid #fecaca" }}>
          <div style={{ fontSize: 11, color: "#991b1b" }}>Toplam Gider</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: "#ef4444" }}>₺{toplam.toLocaleString()}</div>
        </div>
        <div style={{ background: "#f1f5f9", borderRadius: 12, padding: "10px 18px", border: "1px solid #e2e8f0" }}>
          <div style={{ fontSize: 11, color: "#64748b" }}>Kayıt Sayısı</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: "#475569" }}>{filtreli.length}</div>
        </div>
      </div>
      <FiltreBar placeholder="Açıklama veya kategori ara..." />
      <div className="table-card">
        <table className="data-table">
          <thead><tr><th>Site</th><th>{t.date}</th><th>Kategori</th><th>{t.description}</th><th>{t.amount}</th><th>Ek</th><th>İşlem</th></tr></thead>
          <tbody>
            {filtreli.sort((a,b) => b.tarih.localeCompare(a.tarih)).map((g) => {
              const site = data.siteler.find((s) => s.id === g.siteId);
              return (
                <tr key={g.id}>
                  <td>{site?.siteIsmi}</td>
                  <td>{g.tarih}</td>
                  <td><span style={{ background: katRenk[g.kategori] || "#f1f5f9", padding: "2px 10px", borderRadius: 20, fontSize: 12, fontWeight: 600 }}>{g.kategori}</span></td>
                  <td>{g.aciklama}</td>
                  <td><strong style={{ color: "#ef4444" }}>₺{Number(g.tutar).toLocaleString()}</strong></td>
                  <td>{g.dosyaAdi ? <span style={{ fontSize: 12, color: "#3b82f6" }}><Icon name="paperclip" size={12} /> {g.dosyaAdi}</span> : "—"}</td>
                  <td><button className="icon-btn danger" onClick={() => del(g.id)}><Icon name="trash" size={15} /></button></td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {filtreli.length === 0 && <div className="empty-state">Kayıt yok.</div>}
      </div>
      {modal && (
        <Modal title={t.addExpense} onClose={() => setModal(false)} wide>
          <div className="form-grid">
            <Field label="Site" type="select" value={String(form.siteId)} onChange={(v) => f("siteId", Number(v))} options={data.siteler.map((s) => ({ value: String(s.id), label: s.siteIsmi }))} />
            <Field label={t.date} type="date" value={form.tarih} onChange={(v) => f("tarih", v)} />
            <Field label={t.category} type="select" value={form.kategori} onChange={(v) => f("kategori", v)} options={["bakim","temizlik","bahce","havuz","elektrik","guvenlik","diger"].map((k) => ({ value: k, label: k }))} />
            <Field label={`${t.amount} (₺)`} type="number" value={form.tutar} onChange={(v) => f("tutar", v)} required />
            <Field label={t.description} type="textarea" value={form.aciklama} onChange={(v) => f("aciklama", v)} fullWidth />
          </div>
          <div style={{ marginTop: 14 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>{t.attachment} (Teklif, Fatura vb.)</label>
            <input ref={fileRef} type="file" accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.png" onChange={handleFile} style={{ fontSize: 13 }} />
            {form.dosyaAdi && <div style={{ marginTop: 6, color: "#3b82f6", fontSize: 13 }}>{form.dosyaAdi}</div>}
          </div>
          <div className="modal-footer"><button className="btn-secondary" onClick={() => setModal(false)}>{t.cancel}</button><button className="btn-primary" onClick={save}>{t.save}</button></div>
        </Modal>
      )}
      {raporModal && <EvrenselRaporModal tip="siteGiderleri" data={data} onClose={()=>setRaporModal(false)} />}
    </div>
  );
}

// ============================================================
// SAKİN KULLANICILARI — Site bazlı sekmeler
// ============================================================
function SakinKullanicilari({ data, setData, t }) {
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [filterSite, setFilterSite] = useState(0);
  const emptyForm = { ad: "", tel: "", sifre: "1234", siteId: data.siteler[0]?.id || 1, daireId: "", rol: "sakin", aktif: true, mesajEngel: false };

  const save = () => {
    const item = {
      ...form,
      siteId: Number(form.siteId) || 0,
      daireId: form.daireId ? Number(form.daireId) : null,
      aktif: form.aktif !== false && form.aktif !== "pasif",
      id: modal === "edit" ? form.id : Date.now(),
    };
    if (modal === "add") setData((d) => ({ ...d, sakinKullanicilari: [...(d.sakinKullanicilari || []), item] }));
    else setData((d) => ({ ...d, sakinKullanicilari: (d.sakinKullanicilari || []).map((u) => u.id === item.id ? item : u) }));
    setModal(null);
  };

  // Mesaj engel toggle — setData ile Supabase'e yaz (tüm cihazlara yayılır)
  const toggleMesajEngel = (u) => {
    const yeni = !u.mesajEngel;
    const label = yeni ? "mesaj göndermesi engellensin" : "mesaj engellemesi kaldırılsın";
    if (!window.confirm(`${u.ad} için ${label} mi?`)) return;
    setData((d) => ({
      ...d,
      sakinKullanicilari: (d.sakinKullanicilari || []).map(x =>
        x.id === u.id ? { ...x, mesajEngel: yeni } : x
      ),
    }));
  };

  const del = (id) => { if (window.confirm("Sil?")) setData((d) => ({ ...d, sakinKullanicilari: (d.sakinKullanicilari || []).filter((u) => u.id !== id) })); };
  const f = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const rolRenk = { superAdmin: "purple", siteYoneticisi: "info", sakin: "neutral" };
  const rolLabel = { superAdmin: t.superAdmin, siteYoneticisi: t.siteManager, sakin: t.resident };

  const tumKullanicilar = data.sakinKullanicilari || [];
  const siteFiltreli = filterSite === 0 ? tumKullanicilar : tumKullanicilar.filter((u) => u.siteId === filterSite);

  const { filtreli: gosterilenler, FiltreBar } = useFiltre(
    siteFiltreli,
    (x, q) => x.ad?.toLowerCase().includes(q) || x.tel?.includes(q),
    x => String(x.id)
  );

  return (
    <div className="page">
      <div className="page-header">
        <h2>{t.residents}</h2>
        <button className="btn-primary" onClick={() => { setForm(emptyForm); setModal("add"); }}><Icon name="plus" size={16} /> {t.addResident}</button>
      </div>

      <div style={{ background: "#fef3c7", border: "1px solid #f59e0b", borderRadius: 10, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: "#92400e" }}>
        💡 Giriş: <strong>Telefon numarası</strong> (kullanıcı adı) + şifre. Şifreler yalnızca admin tarafından belirlenir.
      </div>

      <div className="filter-tabs">
        <button className={`filter-tab ${filterSite === 0 ? "active" : ""}`} onClick={() => setFilterSite(0)}>
          Tümü ({tumKullanicilar.length})
        </button>
        {data.siteler.map((s) => (
          <button key={s.id} className={`filter-tab ${filterSite === s.id ? "active" : ""}`} onClick={() => setFilterSite(s.id)}>
            {s.siteIsmi} ({tumKullanicilar.filter((u) => u.siteId === s.id).length})
          </button>
        ))}
      </div>
      <FiltreBar placeholder="Ad veya telefon ara..." />

      <div className="table-card">
        <table className="data-table">
          <thead><tr><th>{t.name}</th><th>Tel (Kullanıcı Adı)</th><th>Şifre</th><th>Site</th><th>{t.role}</th><th>Durum</th><th>Mesaj</th><th>İşlem</th></tr></thead>
          <tbody>
            {gosterilenler.map((u) => {
              const site = data.siteler.find((s) => s.id === u.siteId);
              return (
                <tr key={u.id}>
                  <td><strong>{u.ad}</strong></td>
                  <td style={{ fontFamily: "monospace", fontSize: 13 }}>{u.tel}</td>
                  <td><span style={{ background: "#f1f5f9", padding: "2px 8px", borderRadius: 6, fontSize: 12, fontFamily: "monospace" }}>{"•".repeat(u.sifre?.length || 4)}</span></td>
                  <td>{site?.siteIsmi || "—"}</td>
                  <td><Badge text={rolLabel[u.rol] || u.rol} type={rolRenk[u.rol] || "neutral"} /></td>
                  <td><Badge text={u.aktif ? t.active : t.passive} type={u.aktif ? "success" : "neutral"} /></td>
                  <td>
                    <button
                      onClick={() => toggleMesajEngel(u)}
                      title={u.mesajEngel ? "Mesaj gönderimi engelli — kaldırmak için tıkla" : "Mesaj gönderimi serbest — engellemek için tıkla"}
                      style={{
                        background: u.mesajEngel ? "#fee2e2" : "#d1fae5",
                        color: u.mesajEngel ? "#991b1b" : "#065f46",
                        border: "none", borderRadius: 8, padding: "4px 10px",
                        fontSize: 11, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap",
                      }}>
                      {u.mesajEngel ? "🚫 Engelli" : "✅ Serbest"}
                    </button>
                  </td>
                  <td>
                    <div style={{ display: "flex", gap: 4 }}>
                      <button className="icon-btn" onClick={() => { setForm({ ...u }); setModal("edit"); }}><Icon name="edit" size={15} /></button>
                      <button className="icon-btn danger" onClick={() => del(u.id)}><Icon name="trash" size={15} /></button>
                    </div>
                  </td>
                </tr>
              );
            })}
            {gosterilenler.length === 0 && <tr><td colSpan={8} style={{ textAlign: "center", padding: 24, color: "#94a3b8" }}>Kayıt yok</td></tr>}
          </tbody>
        </table>
      </div>

      {modal && (
        <Modal title={modal === "add" ? t.addResident : "Kullanıcı Düzenle"} onClose={() => setModal(null)} wide>
          <div className="form-grid">
            <Field label={t.name} value={form.ad} onChange={(v) => f("ad", v)} required />
            <Field label="Tel (Giriş için)" value={form.tel} onChange={(v) => f("tel", v)} required />
            <Field label="Şifre" value={form.sifre} onChange={(v) => f("sifre", v)} required />
            <Field label={t.role} type="select" value={form.rol} onChange={(v) => f("rol", v)} options={[{ value: "sakin", label: t.resident }, { value: "siteYoneticisi", label: t.siteManager }]} />
            <Field label="Site" type="select" value={String(form.siteId)} onChange={(v) => f("siteId", Number(v))} options={data.siteler.map((s) => ({ value: String(s.id), label: s.siteIsmi }))} />
            <Field label="Durum" type="select" value={form.aktif ? "aktif" : "pasif"} onChange={(v) => f("aktif", v === "aktif")} options={[{ value: "aktif", label: t.active }, { value: "pasif", label: t.passive }]} />
          </div>
          <div className="modal-footer">
            <button className="btn-secondary" onClick={() => setModal(null)}>{t.cancel}</button>
            <button className="btn-primary" onClick={save}>{t.save}</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ============================================================
// PERSONEL — Kadrolu & Ekstracı
// ============================================================
function Personel({ data, setData, t }) {
  const [raporModal, setRaporModal] = useState(false);
  const [tab, setTab] = useState("kadrolu"); // kadrolu | ekstraci
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [detayPersonel, setDetayPersonel] = useState(null);
  const [devamModal, setDevamModal] = useState(false);
  const [devamForm, setDevamForm] = useState({});
  const [avansModal, setAvansModal] = useState(false);
  const [avansForm, setAvansForm] = useState({});
  const [selectedYil, setSelectedYil] = useState(BUGUN.getFullYear());
  const [selectedAy, setSelectedAy] = useState(BUGUN.getMonth() + 1);
  const yillar = [2024, 2025, 2026];

  const emptyKadrolu = { tip: "kadrolu", ad: "", iletisim: "", iseBaslama: new Date().toISOString().split("T")[0], maas: "", durum: "aktif" };
  const emptyEkstraci = { tip: "ekstraci", ad: "", iletisim: "", iseBaslama: new Date().toISOString().split("T")[0], gunlukUcret: "", durum: "aktif" };

  const savePersonel = () => {
    const item = {
      ...form,
      maas: form.tip === "kadrolu" ? Number(form.maas) : 0,
      gunlukUcret: form.tip === "ekstraci" ? Number(form.gunlukUcret) : 0,
      id: modal === "edit" ? form.id : Date.now(),
    };
    if (modal === "add") setData((d) => ({ ...d, personel: [...d.personel, item] }));
    else setData((d) => ({ ...d, personel: d.personel.map((p) => p.id === item.id ? item : p) }));
    setModal(null);
  };

  const delPersonel = (id) => { if (window.confirm("Sil?")) setData((d) => ({ ...d, personel: d.personel.filter((p) => p.id !== id) })); };

  // Kadrolu: aylık özet (avans düşüldükten sonra kalan)
  const getKadroluOzet = (pid, yil, ay) => {
    const p = data.personel.find((x) => x.id === pid);
    if (!p) return { maasBaz: 0, odenen: 0, kalan: 0, avanslar: [] };
    const avanslar = (data.personelDetay || []).filter(d => d.personelId === pid && d.yil === yil && d.ay === ay && d.tip === "avans");
    const odenen = avanslar.reduce((s, a) => s + a.tutar, 0);
    return { maasBaz: p.maas, odenen, kalan: p.maas - odenen, avanslar };
  };

  // Ekstracı: aylık özet (gelen gün × günlük ücret - avans)
  const getEkstraciOzet = (pid, yil, ay) => {
    const p = data.personel.find((x) => x.id === pid);
    if (!p) return { gelenGun: 0, brutKazanc: 0, avanslar: [], odenen: 0, kalan: 0, devamlar: [] };
    const devamlar = (data.personelDetay || []).filter(d => d.personelId === pid && d.yil === yil && d.ay === ay && d.tip === "devam");
    const avanslar = (data.personelDetay || []).filter(d => d.personelId === pid && d.yil === yil && d.ay === ay && d.tip === "avans");
    const gelenGun = devamlar.filter(d => d.durum === "geldi").length;
    const brutKazanc = gelenGun * (p.gunlukUcret || 0);
    const odenen = avanslar.reduce((s, a) => s + a.tutar, 0);
    return { gelenGun, brutKazanc, avanslar, odenen, kalan: brutKazanc - odenen, devamlar };
  };

  // Devam kaydı ekle (ekstracı)
  const saveDevam = () => {
    const item = { id: Date.now(), personelId: detayPersonel.id, yil: selectedYil, ay: selectedAy, tip: "devam", tarih: devamForm.tarih, durum: devamForm.durum, aciklama: devamForm.aciklama || "" };
    setData((d) => ({ ...d, personelDetay: [...(d.personelDetay || []), item] }));
    setDevamModal(false);
  };

  // Avans kaydet → kasadan düş (gider olarak ekle)
  const saveAvans = () => {
    const tutar = Number(avansForm.tutar) || 0;
    const item = { id: Date.now(), personelId: detayPersonel.id, yil: selectedYil, ay: selectedAy, tip: "avans", tarih: avansForm.tarih || new Date().toISOString().split("T")[0], tutar, aciklama: avansForm.aciklama || "" };
    const giderItem = { id: `avans_${item.id}`, tarih: item.tarih, tutar, aciklama: `Personel avansı: ${detayPersonel.ad}${item.aciklama ? " — " + item.aciklama : ""}`, kaynak: `avans_${item.id}` };
    setData((d) => ({ ...d, personelDetay: [...(d.personelDetay || []), item], gider: [...d.gider, giderItem] }));
    setAvansModal(false);
  };

  const delDetay = (id) => {
    if (window.confirm("Kaydı sil?")) {
      setData((d) => ({
        ...d,
        personelDetay: (d.personelDetay || []).filter((x) => x.id !== id),
        gider: d.gider.filter(g => g.kaynak !== `avans_${id}`),
      }));
    }
  };

  const personeller = (data.personel || []).filter(p => (tab === "kadrolu" ? p.tip === "kadrolu" : p.tip === "ekstraci"));
  const f = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const GUNLER = Array.from({ length: 31 }, (_, i) => i + 1);

  return (
    <div className="page">
      <div className="page-header">
        <h2>{t.personnel}</h2>
        <div style={{display:"flex",gap:8}}><button className="btn-secondary" onClick={()=>setRaporModal(true)}>Rapor Al</button></div>
        <div style={{ display: "flex", gap: 8 }}>
          <button className="btn-primary" onClick={() => { setForm(tab === "kadrolu" ? emptyKadrolu : emptyEkstraci); setModal("add"); }}>
            <Icon name="plus" size={16} /> {tab === "kadrolu" ? "Kadrolu Ekle" : "Ekstracı Ekle"}
          </button>
        </div>
      </div>

      {/* TİP SEKMELERİ */}
      <div style={{ display: "flex", gap: 0, marginBottom: 20, background: "#f1f5f9", borderRadius: 12, padding: 4, width: "fit-content" }}>
        <button onClick={() => { setTab("kadrolu"); setDetayPersonel(null); }} style={{ padding: "9px 22px", borderRadius: 9, border: "none", cursor: "pointer", fontWeight: 700, fontSize: 14, background: tab === "kadrolu" ? "white" : "transparent", color: tab === "kadrolu" ? "#0f172a" : "#64748b", boxShadow: tab === "kadrolu" ? "0 1px 4px rgba(0,0,0,0.1)" : "none", transition: "all 0.15s" }}>
          👔 Kadrolu ({(data.personel || []).filter(p => p.tip === "kadrolu").length})
        </button>
        <button onClick={() => { setTab("ekstraci"); setDetayPersonel(null); }} style={{ padding: "9px 22px", borderRadius: 9, border: "none", cursor: "pointer", fontWeight: 700, fontSize: 14, background: tab === "ekstraci" ? "white" : "transparent", color: tab === "ekstraci" ? "#0f172a" : "#64748b", boxShadow: tab === "ekstraci" ? "0 1px 4px rgba(0,0,0,0.1)" : "none", transition: "all 0.15s" }}>
          🔨 Ekstracı ({(data.personel || []).filter(p => p.tip === "ekstraci").length})
        </button>
      </div>

      {/* KADROLU LİSTE */}
      {tab === "kadrolu" && (
        <div>
          {personeller.length === 0 && <div className="empty-state" style={{ background: "white", borderRadius: 14, border: "1px solid #e2e8f0" }}>Kadrolu personel yok. Eklemek için butona tıklayın.</div>}
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {personeller.map(p => {
              const ozet = getKadroluOzet(p.id, selectedYil, selectedAy);
              const yuzde = Math.round((ozet.odenen / (ozet.maasBaz || 1)) * 100);
              return (
                <div key={p.id} style={{ background: "white", borderRadius: 14, border: "1px solid #e2e8f0", overflow: "hidden" }}>
                  <div style={{ padding: "16px 20px", display: "flex", alignItems: "center", gap: 16 }}>
                    {/* Avatar */}
                    <div style={{ width: 48, height: 48, borderRadius: "50%", background: "linear-gradient(135deg,#3b82f6,#6366f1)", color: "white", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 16, flexShrink: 0 }}>
                      {p.ad.split(" ").map(w => w[0]).join("").slice(0, 2)}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 700, fontSize: 15, color: "#0f172a" }}>{p.ad}</div>
                      <div style={{ fontSize: 12, color: "#64748b" }}>{p.iletisim} · İşe başlama: {p.iseBaslama}</div>
                    </div>
                    {/* Maaş bilgisi */}
                    <div style={{ textAlign: "center", background: "#f8fafc", borderRadius: 10, padding: "10px 16px", minWidth: 100 }}>
                      <div style={{ fontSize: 11, color: "#64748b" }}>Maaş</div>
                      <div style={{ fontWeight: 800, fontSize: 18, color: "#0f172a" }}>₺{p.maas.toLocaleString()}</div>
                    </div>
                    <div style={{ textAlign: "center", background: "#fee2e2", borderRadius: 10, padding: "10px 16px", minWidth: 100 }}>
                      <div style={{ fontSize: 11, color: "#991b1b" }}>Avans</div>
                      <div style={{ fontWeight: 800, fontSize: 18, color: "#ef4444" }}>₺{ozet.odenen.toLocaleString()}</div>
                    </div>
                    <div style={{ textAlign: "center", background: "#d1fae5", borderRadius: 10, padding: "10px 16px", minWidth: 100 }}>
                      <div style={{ fontSize: 11, color: "#065f46" }}>Kalan</div>
                      <div style={{ fontWeight: 800, fontSize: 18, color: "#10b981" }}>₺{ozet.kalan.toLocaleString()}</div>
                    </div>
                    {/* Aksiyonlar */}
                    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                      <button className="btn-outline" style={{ fontSize: 12 }} onClick={() => { setDetayPersonel(p); }}>
                        {detayPersonel?.id === p.id ? "▲ Kapat" : "▼ Detay"}
                      </button>
                      <button className="btn-primary" style={{ fontSize: 12 }} onClick={() => { setDetayPersonel(p); setAvansModal(true); setAvansForm({ tarih: new Date().toISOString().split("T")[0], tutar: "", aciklama: "" }); }}>
                        + Avans
                      </button>
                    </div>
                    <div style={{ display: "flex", gap: 4 }}>
                      <button className="icon-btn" onClick={() => { setForm({ ...p }); setModal("edit"); }}><Icon name="edit" size={15} /></button>
                      <button className="icon-btn danger" onClick={() => delPersonel(p.id)}><Icon name="trash" size={15} /></button>
                    </div>
                  </div>
                  {/* İlerleme barı */}
                  <div style={{ padding: "0 20px 16px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: "#64748b", marginBottom: 4 }}>
                      <span>Avans kullanımı</span><span>%{yuzde}</span>
                    </div>
                    <div style={{ height: 6, background: "#f1f5f9", borderRadius: 99 }}>
                      <div style={{ height: 6, background: yuzde > 80 ? "#ef4444" : yuzde > 50 ? "#f59e0b" : "#10b981", borderRadius: 99, width: `${Math.min(yuzde, 100)}%`, transition: "width 0.3s" }} />
                    </div>
                  </div>
                  {/* Detay satırları */}
                  {detayPersonel?.id === p.id && (
                    <div style={{ borderTop: "1px solid #f1f5f9", padding: "14px 20px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                          <select value={selectedYil} onChange={e => setSelectedYil(Number(e.target.value))} style={{ padding: "5px 8px", borderRadius: 7, border: "1px solid #e2e8f0", fontSize: 13 }}>
                            {yillar.map(y => <option key={y} value={y}>{y}</option>)}
                          </select>
                          <select value={selectedAy} onChange={e => setSelectedAy(Number(e.target.value))} style={{ padding: "5px 8px", borderRadius: 7, border: "1px solid #e2e8f0", fontSize: 13 }}>
                            {AYLAR_TR.map((a, i) => <option key={i} value={i + 1}>{a}</option>)}
                          </select>
                        </div>
                        <span style={{ fontSize: 13, color: "#64748b" }}>{AYLAR_TR[selectedAy - 1]} {selectedYil} — Avans Kayıtları</span>
                      </div>
                      {ozet.avanslar.length === 0 ? (
                        <div style={{ textAlign: "center", color: "#94a3b8", padding: "16px 0", fontSize: 13 }}>Bu ay avans kaydı yok.</div>
                      ) : (
                        <table className="data-table">
                          <thead><tr><th>Tarih</th><th>Tutar</th><th>Açıklama</th><th>İşlem</th></tr></thead>
                          <tbody>
                            {ozet.avanslar.map(a => (
                              <tr key={a.id}><td>{a.tarih}</td><td style={{ color: "#ef4444", fontWeight: 700 }}>₺{a.tutar.toLocaleString()}</td><td>{a.aciklama || "—"}</td><td><button className="icon-btn danger" onClick={() => delDetay(a.id)}><Icon name="trash" size={14} /></button></td></tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* EKSTRACI LİSTE */}
      {tab === "ekstraci" && (
        <div>
          {/* Ay/Yıl seçici */}
          <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 16, background: "white", borderRadius: 12, padding: "12px 16px", border: "1px solid #e2e8f0" }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: "#475569" }}>Dönem:</span>
            <select value={selectedYil} onChange={e => setSelectedYil(Number(e.target.value))} style={{ padding: "6px 10px", borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 13 }}>
              {yillar.map(y => <option key={y} value={y}>{y}</option>)}
            </select>
            <select value={selectedAy} onChange={e => setSelectedAy(Number(e.target.value))} style={{ padding: "6px 10px", borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 13 }}>
              {AYLAR_TR.map((a, i) => <option key={i} value={i + 1}>{a}</option>)}
            </select>
            <span style={{ fontSize: 13, color: "#64748b" }}>{AYLAR_TR[selectedAy - 1]} {selectedYil}</span>
          </div>

          {personeller.length === 0 && <div className="empty-state" style={{ background: "white", borderRadius: 14, border: "1px solid #e2e8f0" }}>Ekstracı personel yok.</div>}
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            {personeller.map(p => {
              const ozet = getEkstraciOzet(p.id, selectedYil, selectedAy);
              const ayGunSayisi = new Date(selectedYil, selectedAy, 0).getDate();
              return (
                <div key={p.id} style={{ background: "white", borderRadius: 14, border: "1px solid #e2e8f0", overflow: "hidden" }}>
                  {/* Üst bilgi satırı */}
                  <div style={{ padding: "16px 20px", display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
                    <div style={{ width: 48, height: 48, borderRadius: "50%", background: "linear-gradient(135deg,#f59e0b,#ef4444)", color: "white", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 16, flexShrink: 0 }}>
                      {p.ad.split(" ").map(w => w[0]).join("").slice(0, 2)}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 700, fontSize: 15, color: "#0f172a" }}>{p.ad}</div>
                      <div style={{ fontSize: 12, color: "#64748b" }}>{p.iletisim} · Günlük: <strong style={{ color: "#f59e0b" }}>₺{p.gunlukUcret}</strong></div>
                    </div>
                    {/* Özet kutular */}
                    {[
                      { l: "Gelen Gün", v: `${ozet.gelenGun}/${ayGunSayisi}`, bg: "#dbeafe", c: "#1e40af" },
                      { l: "Brüt Kazanç", v: `₺${ozet.brutKazanc.toLocaleString()}`, bg: "#fef3c7", c: "#92400e" },
                      { l: "Avans", v: `₺${ozet.odenen.toLocaleString()}`, bg: "#fee2e2", c: "#991b1b" },
                      { l: "Net Alacak", v: `₺${ozet.kalan.toLocaleString()}`, bg: "#d1fae5", c: "#065f46" },
                    ].map(s => (
                      <div key={s.l} style={{ textAlign: "center", background: s.bg, borderRadius: 10, padding: "9px 14px", minWidth: 90 }}>
                        <div style={{ fontSize: 10, color: s.c, opacity: 0.8 }}>{s.l}</div>
                        <div style={{ fontWeight: 800, fontSize: 16, color: s.c }}>{s.v}</div>
                      </div>
                    ))}
                    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                      <button className="btn-outline" style={{ fontSize: 12 }} onClick={() => setDetayPersonel(detayPersonel?.id === p.id ? null : p)}>
                        {detayPersonel?.id === p.id ? "▲ Kapat" : "▼ Detay"}
                      </button>
                      <button className="btn-primary" style={{ fontSize: 12 }} onClick={() => { setDetayPersonel(p); setDevamModal(true); setDevamForm({ tarih: new Date().toISOString().split("T")[0], durum: "geldi", aciklama: "" }); }}>
                        + Devam
                      </button>
                      <button className="btn-secondary" style={{ fontSize: 12, background: "#fef3c7", color: "#92400e", border: "none" }} onClick={() => { setDetayPersonel(p); setAvansModal(true); setAvansForm({ tarih: new Date().toISOString().split("T")[0], tutar: "", aciklama: "" }); }}>
                        + Avans
                      </button>
                    </div>
                    <div style={{ display: "flex", gap: 4 }}>
                      <button className="icon-btn" onClick={() => { setForm({ ...p }); setModal("edit"); }}><Icon name="edit" size={15} /></button>
                      <button className="icon-btn danger" onClick={() => delPersonel(p.id)}><Icon name="trash" size={15} /></button>
                    </div>
                  </div>

                  {/* DEVAM TAKVİMİ */}
                  {detayPersonel?.id === p.id && (
                    <div style={{ borderTop: "1px solid #f1f5f9", padding: "16px 20px" }}>
                      <div style={{ fontSize: 13, fontWeight: 700, color: "#475569", marginBottom: 12 }}>
                        {AYLAR_TR[selectedAy - 1]} {selectedYil} — Devam Takvimi
                      </div>
                      {/* Gün ızgarası */}
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 6, marginBottom: 16 }}>
                        {["Pzt","Sal","Çar","Per","Cum","Cmt","Paz"].map(g => (
                          <div key={g} style={{ textAlign: "center", fontSize: 10, fontWeight: 700, color: "#94a3b8", paddingBottom: 4 }}>{g}</div>
                        ))}
                        {/* Boşluk hücreleri */}
                        {Array.from({ length: (new Date(selectedYil, selectedAy - 1, 1).getDay() + 6) % 7 }).map((_, i) => <div key={`e${i}`} />)}
                        {/* Günler */}
                        {Array.from({ length: ayGunSayisi }, (_, i) => i + 1).map(gun => {
                          const tarih = `${selectedYil}-${String(selectedAy).padStart(2,"0")}-${String(gun).padStart(2,"0")}`;
                          const kayit = ozet.devamlar.find(d => d.tarih === tarih);
                          const bg = !kayit ? "#f8fafc" : kayit.durum === "geldi" ? "#d1fae5" : "#fee2e2";
                          const color = !kayit ? "#94a3b8" : kayit.durum === "geldi" ? "#065f46" : "#991b1b";
                          const simge = !kayit ? "" : kayit.durum === "geldi" ? "✓" : "✕";
                          return (
                            <div key={gun} title={kayit?.aciklama || ""} style={{ textAlign: "center", padding: "6px 2px", borderRadius: 7, background: bg, cursor: "default", border: `1px solid ${!kayit ? "#e2e8f0" : kayit.durum === "geldi" ? "#86efac" : "#fca5a5"}` }}>
                              <div style={{ fontSize: 11, fontWeight: 600, color }}>{gun}</div>
                              <div style={{ fontSize: 10, color, fontWeight: 700 }}>{simge}</div>
                            </div>
                          );
                        })}
                      </div>
                      {/* Açıklama listesi (gelmediği günler) */}
                      {ozet.devamlar.filter(d => d.durum === "gelmedi" && d.aciklama).length > 0 && (
                        <div style={{ marginBottom: 12 }}>
                          <div style={{ fontSize: 12, fontWeight: 600, color: "#64748b", marginBottom: 6 }}>Mazeret notları:</div>
                          {ozet.devamlar.filter(d => d.durum === "gelmedi" && d.aciklama).map(d => (
                            <div key={d.id} style={{ fontSize: 12, color: "#475569", padding: "4px 0" }}>• {d.tarih}: {d.aciklama}</div>
                          ))}
                        </div>
                      )}
                      {/* Avanslar */}
                      {ozet.avanslar.length > 0 && (
                        <div>
                          <div style={{ fontSize: 12, fontWeight: 600, color: "#64748b", marginBottom: 6 }}>Avanslar:</div>
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                            {ozet.avanslar.map(a => (
                              <div key={a.id} style={{ background: "#fef3c7", borderRadius: 8, padding: "5px 12px", fontSize: 12, color: "#92400e", display: "flex", alignItems: "center", gap: 8 }}>
                                <span>{a.tarih}</span><span style={{ fontWeight: 700 }}>₺{a.tutar.toLocaleString()}</span>{a.aciklama && <span>— {a.aciklama}</span>}
                                <button style={{ background: "none", border: "none", cursor: "pointer", color: "#ef4444", fontSize: 14, padding: 0 }} onClick={() => delDetay(a.id)}>×</button>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* PERSONEL EKLE/DÜZENLE */}
      {modal && (
        <Modal title={modal === "add" ? (tab === "kadrolu" ? "Kadrolu Personel Ekle" : "Ekstracı Ekle") : "Personeli Düzenle"} onClose={() => setModal(null)}>
          <div className="form-grid">
            <Field label="Ad Soyad" value={form.ad} onChange={v => f("ad", v)} required />
            <Field label="İletişim" value={form.iletisim} onChange={v => f("iletisim", v)} />
            <Field label="İşe Başlama" type="date" value={form.iseBaslama} onChange={v => f("iseBaslama", v)} />
            {form.tip === "kadrolu"
              ? <Field label="Aylık Maaş (₺)" type="number" value={form.maas} onChange={v => f("maas", v)} required />
              : <Field label="Günlük Ücret (₺)" type="number" value={form.gunlukUcret} onChange={v => f("gunlukUcret", v)} required />
            }
            <Field label="Durum" type="select" value={form.durum} onChange={v => f("durum", v)} options={[{ value: "aktif", label: "Aktif" }, { value: "pasif", label: "Pasif" }]} />
          </div>
          <div className="modal-footer">
            <button className="btn-secondary" onClick={() => setModal(null)}>İptal</button>
            <button className="btn-primary" onClick={savePersonel}>Kaydet</button>
          </div>
        </Modal>
      )}

      {/* AVANS MODAL */}
      {avansModal && detayPersonel && (
        <Modal title={`${detayPersonel.ad} — Avans Ekle`} onClose={() => setAvansModal(false)}>
          <div style={{ background: "#fef3c7", borderRadius: 8, padding: "8px 12px", marginBottom: 14, fontSize: 13, color: "#92400e" }}>
            {AYLAR_TR[selectedAy - 1]} {selectedYil} dönemi için avans kaydedilecek.
          </div>
          <div className="form-grid">
            <Field label="Tarih" type="date" value={avansForm.tarih} onChange={v => setAvansForm(p => ({ ...p, tarih: v }))} />
            <Field label="Tutar (₺)" type="number" value={avansForm.tutar} onChange={v => setAvansForm(p => ({ ...p, tutar: v }))} required />
            <Field label="Açıklama" value={avansForm.aciklama} onChange={v => setAvansForm(p => ({ ...p, aciklama: v }))} fullWidth />
          </div>
          <div className="modal-footer">
            <button className="btn-secondary" onClick={() => setAvansModal(false)}>İptal</button>
            <button className="btn-primary" onClick={saveAvans}>Kaydet</button>
          </div>
        </Modal>
      )}

      {/* DEVAM MODAL (Ekstracı) */}
      {devamModal && detayPersonel && (
        <Modal title={`${detayPersonel.ad} — Devam Kaydı`} onClose={() => setDevamModal(false)}>
          <div className="form-grid">
            <Field label="Tarih" type="date" value={devamForm.tarih} onChange={v => setDevamForm(p => ({ ...p, tarih: v }))} />
            <Field label="Durum" type="select" value={devamForm.durum} onChange={v => setDevamForm(p => ({ ...p, durum: v }))} options={[{ value: "geldi", label: "✓ Geldi" }, { value: "gelmedi", label: "✕ Gelmedi" }]} />
            <Field label="Mazeret / Not (opsiyonel)" value={devamForm.aciklama} onChange={v => setDevamForm(p => ({ ...p, aciklama: v }))} fullWidth placeholder="Örn: Hasta, İzinli, Özel sebep..." />
          </div>
          <div className="modal-footer">
            <button className="btn-secondary" onClick={() => setDevamModal(false)}>İptal</button>
            <button className="btn-primary" onClick={saveDevam}>Kaydet</button>
          </div>
        </Modal>
      )}
      {raporModal && <EvrenselRaporModal tip="personel" data={data} onClose={()=>setRaporModal(false)} />}
    </div>
  );
}

// ============================================================
// DÜZENLİ MÜŞTERİLER
// ============================================================
function DuzenlMusteriler({ data, setData, t }) {
  const [raporModal, setRaporModal] = useState(false);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [detayMusteri, setDetayMusteri] = useState(null);
  const [isModal, setIsModal] = useState(false);
  const [isForm, setIsForm] = useState({});
  const [odemeModal, setOdemeModal] = useState(false);
  const [odemeForm, setOdemeForm] = useState({});

  const musteriler = data.duzenlMusteriler || [];

  const { filtreli: filtreliMusteriler, FiltreBar } = useFiltre(
    musteriler,
    (x, q) => x.ad?.toLowerCase().includes(q) || x.tel?.includes(q) || x.adres?.toLowerCase().includes(q),
    x => x.id ? String(x.id) : ""
  );

  const emptyForm = { ad: "", tel: "", adres: "", notlar: "" };

  const saveMusteri = () => {
    const item = { ...form, id: modal === "edit" ? form.id : Date.now() };
    if (modal === "add") setData(d => ({ ...d, duzenlMusteriler: [...(d.duzenlMusteriler || []), item] }));
    else setData(d => ({ ...d, duzenlMusteriler: (d.duzenlMusteriler || []).map(m => m.id === item.id ? item : m) }));
    setModal(null);
  };

  const delMusteri = (id) => { if (window.confirm("Bu müşteriyi silmek istediğinize emin misiniz?")) setData(d => ({ ...d, duzenlMusteriler: (d.duzenlMusteriler || []).filter(m => m.id !== id) })); };

  // İş kaydı ekle
  const saveIs = () => {
    const is = { id: Date.now(), musteriId: detayMusteri.id, tarih: isForm.tarih, aciklama: isForm.aciklama || "", ucret: Number(isForm.ucret) || 0, tip: "is" };
    setData(d => ({ ...d, musteriIslemleri: [...(d.musteriIslemleri || []), is] }));
    setIsModal(false);
  };

  // Ödeme kaydı ekle → kasaya gelir olarak yansıt
  const saveOdeme = () => {
    const tutar = Number(odemeForm.tutar) || 0;
    const od = { id: Date.now(), musteriId: detayMusteri.id, tarih: odemeForm.tarih, aciklama: odemeForm.aciklama || "", tutar, tip: "odeme" };
    const gelirItem = { id: `musteri_${od.id}`, tarih: od.tarih, tutar, aciklama: `Müşteri tahsilatı: ${detayMusteri.ad}${od.aciklama ? " — " + od.aciklama : ""}`, kaynak: `musteri_${od.id}` };
    setData(d => ({ ...d, musteriIslemleri: [...(d.musteriIslemleri || []), od], gelir: [...d.gelir, gelirItem] }));
    setOdemeModal(false);
  };

  const delIslem = (id) => {
    if (window.confirm("Kaydı sil?")) {
      setData(d => ({
        ...d,
        musteriIslemleri: (d.musteriIslemleri || []).filter(x => x.id !== id),
        gelir: d.gelir.filter(g => g.kaynak !== `musteri_${id}`),
      }));
    }
  };

  // Müşteri özeti
  const getMusteriOzet = (musteriId) => {
    const islemler = (data.musteriIslemleri || []).filter(x => x.musteriId === musteriId);
    const toplamBorc = islemler.filter(x => x.tip === "is").reduce((s, x) => s + x.ucret, 0);
    const toplamOdenen = islemler.filter(x => x.tip === "odeme").reduce((s, x) => s + x.tutar, 0);
    const kalanBorc = toplamBorc - toplamOdenen;
    const isGunleri = islemler.filter(x => x.tip === "is").length;
    return { toplamBorc, toplamOdenen, kalanBorc, isGunleri, islemler };
  };

  const f = (k, v) => setForm(p => ({ ...p, [k]: v }));

  return (
    <div className="page">
      <div className="page-header">
        <h2>Düzenli Müşteriler</h2>
        <div style={{display:"flex",gap:8}}><button className="btn-secondary" onClick={()=>setRaporModal(true)}>Rapor Al</button></div>
        <button className="btn-primary" onClick={() => { setForm(emptyForm); setModal("add"); }}>
          <Icon name="plus" size={16} /> Müşteri Ekle
        </button>
      </div>

      {/* Kasa özeti */}
      {(() => {
        const topTahsilat = (data.musteriIslemleri || []).filter(x => x.tip === "odeme").reduce((s, x) => s + x.tutar, 0);
        const topBorc = (data.musteriIslemleri || []).filter(x => x.tip === "is").reduce((s, x) => s + x.ucret, 0);
        return (
          <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
            <div style={{ background: "#dbeafe", borderRadius: 12, padding: "10px 16px", border: "1px solid #93c5fd" }}>
              <div style={{ fontSize: 11, color: "#1e40af" }}>Toplam İş Bedeli</div>
              <div style={{ fontWeight: 800, fontSize: 18, color: "#1e40af" }}>₺{topBorc.toLocaleString()}</div>
            </div>
            <div style={{ background: "#d1fae5", borderRadius: 12, padding: "10px 16px", border: "1px solid #6ee7b7" }}>
              <div style={{ fontSize: 11, color: "#065f46" }}>💰 Tahsilat → Kasaya Eklendi</div>
              <div style={{ fontWeight: 800, fontSize: 18, color: "#10b981" }}>₺{topTahsilat.toLocaleString()}</div>
            </div>
            <div style={{ background: topBorc - topTahsilat > 0 ? "#fee2e2" : "#d1fae5", borderRadius: 12, padding: "10px 16px", border: "1px solid #fca5a5" }}>
              <div style={{ fontSize: 11, color: "#991b1b" }}>Kalan Alacak</div>
              <div style={{ fontWeight: 800, fontSize: 18, color: topBorc - topTahsilat > 0 ? "#ef4444" : "#10b981" }}>₺{(topBorc - topTahsilat).toLocaleString()}</div>
            </div>
          </div>
        );
      })()}

      <FiltreBar placeholder="Müşteri adı, telefon veya adres ara..." />

      {musteriler.length === 0 && (
        <div style={{ background: "white", borderRadius: 14, border: "1px solid #e2e8f0", padding: 40, textAlign: "center", color: "#94a3b8" }}>
          Henüz düzenli müşteri kaydı yok. Eklemek için butona tıklayın.
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        {filtreliMusteriler.map(m => {
          const ozet = getMusteriOzet(m.id);
          const acik = detayMusteri?.id === m.id;
          return (
            <div key={m.id} style={{ background: "white", borderRadius: 14, border: "1px solid #e2e8f0", overflow: "hidden" }}>
              {/* BAŞLIK SATIRI */}
              <div style={{ padding: "16px 20px", display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
                <div style={{ width: 46, height: 46, borderRadius: "50%", background: "linear-gradient(135deg,#8b5cf6,#6366f1)", color: "white", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 16, flexShrink: 0 }}>
                  {m.ad.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase()}
                </div>
                <div style={{ flex: 1, minWidth: 140 }}>
                  <div style={{ fontWeight: 700, fontSize: 15, color: "#0f172a" }}>{m.ad}</div>
                  <div style={{ fontSize: 12, color: "#64748b" }}>📞 {m.tel}</div>
                  {m.adres && <div style={{ fontSize: 12, color: "#94a3b8" }}>📍 {m.adres}</div>}
                </div>

                {/* Özet kartlar */}
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {[
                    { l: "İş Günü", v: ozet.isGunleri, bg: "#ede9fe", c: "#5b21b6" },
                    { l: "Toplam Borç", v: `₺${ozet.toplamBorc.toLocaleString()}`, bg: "#dbeafe", c: "#1e40af" },
                    { l: "Ödenen", v: `₺${ozet.toplamOdenen.toLocaleString()}`, bg: "#d1fae5", c: "#065f46" },
                    { l: "Kalan Borç", v: `₺${ozet.kalanBorc.toLocaleString()}`, bg: ozet.kalanBorc > 0 ? "#fee2e2" : "#d1fae5", c: ozet.kalanBorc > 0 ? "#991b1b" : "#065f46" },
                  ].map(s => (
                    <div key={s.l} style={{ textAlign: "center", background: s.bg, borderRadius: 9, padding: "8px 12px", minWidth: 80 }}>
                      <div style={{ fontSize: 10, color: s.c, opacity: 0.8 }}>{s.l}</div>
                      <div style={{ fontWeight: 800, fontSize: 15, color: s.c }}>{s.v}</div>
                    </div>
                  ))}
                </div>

                {/* Aksiyonlar */}
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                  <button className="btn-outline" style={{ fontSize: 12 }} onClick={() => setDetayMusteri(acik ? null : m)}>
                    {acik ? "▲ Kapat" : "▼ Geçmiş"}
                  </button>
                  <button className="btn-primary" style={{ fontSize: 12 }} onClick={() => { setDetayMusteri(m); setIsForm({ tarih: new Date().toISOString().split("T")[0], aciklama: "", ucret: "" }); setIsModal(true); }}>
                    + İş Ekle
                  </button>
                  <button style={{ fontSize: 12, padding: "6px 12px", background: "#d1fae5", color: "#065f46", border: "none", borderRadius: 8, cursor: "pointer", fontWeight: 600 }} onClick={() => { setDetayMusteri(m); setOdemeForm({ tarih: new Date().toISOString().split("T")[0], tutar: "", aciklama: "" }); setOdemeModal(true); }}>
                    💰 Tahsilat
                  </button>
                </div>
                <div style={{ display: "flex", gap: 4 }}>
                  <button className="icon-btn" onClick={() => { setForm({ ...m }); setModal("edit"); }}><Icon name="edit" size={15} /></button>
                  <button className="icon-btn danger" onClick={() => delMusteri(m.id)}><Icon name="trash" size={15} /></button>
                </div>
              </div>

              {/* DETAY — İşlem geçmişi */}
              {acik && (
                <div style={{ borderTop: "1px solid #f1f5f9", padding: "14px 20px" }}>
                  {ozet.islemler.length === 0 ? (
                    <div style={{ textAlign: "center", color: "#94a3b8", padding: "12px 0", fontSize: 13 }}>Henüz işlem kaydı yok.</div>
                  ) : (
                    <table className="data-table">
                      <thead>
                        <tr><th>Tarih</th><th>Tür</th><th>Açıklama</th><th>Tutar</th><th>İşlem</th></tr>
                      </thead>
                      <tbody>
                        {ozet.islemler.sort((a, b) => b.tarih.localeCompare(a.tarih)).map(i => (
                          <tr key={i.id}>
                            <td>{i.tarih}</td>
                            <td>
                              {i.tip === "is"
                                ? <span style={{ background: "#ede9fe", color: "#5b21b6", padding: "2px 8px", borderRadius: 12, fontSize: 11, fontWeight: 600 }}>🔧 İş</span>
                                : <span style={{ background: "#d1fae5", color: "#065f46", padding: "2px 8px", borderRadius: 12, fontSize: 11, fontWeight: 600 }}>💰 Ödeme</span>
                              }
                            </td>
                            <td style={{ fontSize: 13 }}>{i.aciklama || "—"}</td>
                            <td style={{ fontWeight: 700, color: i.tip === "is" ? "#3b82f6" : "#10b981" }}>
                              {i.tip === "is" ? `₺${i.ucret.toLocaleString()}` : `₺${i.tutar.toLocaleString()}`}
                            </td>
                            <td><button className="icon-btn danger" onClick={() => delIslem(i.id)}><Icon name="trash" size={14} /></button></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                  {m.notlar && <div style={{ marginTop: 10, fontSize: 12, color: "#64748b", background: "#f8fafc", borderRadius: 8, padding: "8px 12px" }}>📝 {m.notlar}</div>}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* MÜŞTERİ EKLE/DÜZENLE MODAL */}
      {modal && (
        <Modal title={modal === "add" ? "Müşteri Ekle" : "Müşteri Düzenle"} onClose={() => setModal(null)}>
          <div className="form-grid">
            <Field label="Ad Soyad" value={form.ad} onChange={v => f("ad", v)} required />
            <Field label="Telefon" value={form.tel} onChange={v => f("tel", v)} />
            <Field label="Adres" value={form.adres} onChange={v => f("adres", v)} fullWidth />
            <Field label="Notlar" type="textarea" value={form.notlar} onChange={v => f("notlar", v)} fullWidth />
          </div>
          <div className="modal-footer">
            <button className="btn-secondary" onClick={() => setModal(null)}>İptal</button>
            <button className="btn-primary" onClick={saveMusteri}>Kaydet</button>
          </div>
        </Modal>
      )}

      {/* İŞ EKLE MODAL */}
      {isModal && detayMusteri && (
        <Modal title={`${detayMusteri.ad} — İş Kaydı`} onClose={() => setIsModal(false)}>
          <div className="form-grid">
            <Field label="Tarih" type="date" value={isForm.tarih} onChange={v => setIsForm(p => ({ ...p, tarih: v }))} />
            <Field label="Hizmet Ücreti (₺)" type="number" value={isForm.ucret} onChange={v => setIsForm(p => ({ ...p, ucret: v }))} required />
            <Field label="Açıklama (opsiyonel)" value={isForm.aciklama} onChange={v => setIsForm(p => ({ ...p, aciklama: v }))} fullWidth />
          </div>
          <div className="modal-footer">
            <button className="btn-secondary" onClick={() => setIsModal(false)}>İptal</button>
            <button className="btn-primary" onClick={saveIs}>Kaydet</button>
          </div>
        </Modal>
      )}

      {/* TAHSİLAT MODAL */}
      {odemeModal && detayMusteri && (
        <Modal title={`${detayMusteri.ad} — Tahsilat`} onClose={() => setOdemeModal(false)}>
          {(() => { const oz = getMusteriOzet(detayMusteri.id); return oz.kalanBorc > 0 && <div style={{ background: "#fee2e2", borderRadius: 8, padding: "8px 12px", marginBottom: 14, fontSize: 13, color: "#991b1b" }}>Kalan borç: <strong>₺{oz.kalanBorc.toLocaleString()}</strong></div>; })()}
          <div className="form-grid">
            <Field label="Tarih" type="date" value={odemeForm.tarih} onChange={v => setOdemeForm(p => ({ ...p, tarih: v }))} />
            <Field label="Tahsilat Tutarı (₺)" type="number" value={odemeForm.tutar} onChange={v => setOdemeForm(p => ({ ...p, tutar: v }))} required />
            <Field label="Not (opsiyonel)" value={odemeForm.aciklama} onChange={v => setOdemeForm(p => ({ ...p, aciklama: v }))} fullWidth />
          </div>
          <div className="modal-footer">
            <button className="btn-secondary" onClick={() => setOdemeModal(false)}>İptal</button>
            <button className="btn-primary" onClick={saveOdeme}>Tahsilat Yap</button>
          </div>
        </Modal>
      )}
      {raporModal && <EvrenselRaporModal tip="duzenlMusteriler" data={data} onClose={()=>setRaporModal(false)} />}
    </div>
  );
}

// ============================================================
// AİRBNB / KİRALIK EVLER — Sadece Admin
// ============================================================
function AirbnbEvler({ data, setData, t }) {
  const [tab, setTab]       = useState("evler");
  const [modal, setModal]   = useState(null);
  const [form, setForm]     = useState({});
  const [selectedEv, setSelectedEv] = useState(null);
  const [filterEv, setFilterEv]     = useState(0);
  const [takvimYil, setTakvimYil]   = useState(new Date().getFullYear());
  const [takvimAy,  setTakvimAy]    = useState(new Date().getMonth());

  const evler        = data.airbnbEvler || [];
  const rezervasyonlar = data.airbnbRezervasyon || [];
  const bugunTarih   = new Date().toISOString().split("T")[0];

  const f = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const durumCfg = {
    musait:    { l:"Müsait",    bg:"#d1fae5", c:"#065f46", dot:"#10b981" },
    rezerveli: { l:"Rezerveli", bg:"#dbeafe", c:"#1e40af", dot:"#3b82f6" },
    bakim:     { l:"Bakımda",   bg:"#fef3c7", c:"#92400e", dot:"#f59e0b" },
    kapali:    { l:"Kapalı",    bg:"#f1f5f9", c:"#475569", dot:"#94a3b8" },
  };
  const rezDurumCfg = {
    beklemede:  { l:"Beklemede",  bg:"#fef3c7", c:"#92400e" },
    onaylandi:  { l:"Onaylandı",  bg:"#d1fae5", c:"#065f46" },
    iptal:      { l:"İptal",      bg:"#fee2e2", c:"#991b1b" },
    tamamlandi: { l:"Tamamlandı", bg:"#ede9fe", c:"#5b21b6" },
  };
  const platformCfg = {
    airbnb:  { l:"Airbnb",      bg:"#fee2e2", c:"#991b1b" },
    booking: { l:"Booking.com", bg:"#dbeafe", c:"#1e40af" },
    direkt:  { l:"Direkt",      bg:"#d1fae5", c:"#065f46" },
    diger:   { l:"Diğer",       bg:"#f1f5f9", c:"#475569" },
  };

  const geceSayisi = (giris, cikis) => {
    if (!giris || !cikis) return 0;
    return Math.max(0, Math.round((new Date(cikis) - new Date(giris)) / 86400000));
  };

  const delEv = (id) => {
    if (window.confirm("Bu evi silmek istediğinize emin misiniz?")) {
      setData(d => ({
        ...d,
        airbnbEvler: (d.airbnbEvler || []).filter(e => e.id !== id),
        airbnbRezervasyon: (d.airbnbRezervasyon || []).filter(r => r.evId !== id),
      }));
    }
  };

  const delRez = (id) => {
    if (window.confirm("Rezervasyonu sil?")) {
      setData(d => ({
        ...d,
        airbnbRezervasyon: (d.airbnbRezervasyon || []).filter(r => r.id !== id),
        gelir: d.gelir.filter(g => g.kaynak !== `airbnb_${id}`),
      }));
    }
  };

  const saveEv = () => {
    const item = {
      ...form,
      id: modal === "editEv" ? form.id : Date.now(),
      kapasite: Number(form.kapasite) || 2,
      odaSayisi: Number(form.odaSayisi) || 1,
      banyoSayisi: Number(form.banyoSayisi) || 1,
      geceLikFiyat: Number(form.geceLikFiyat) || 0,
      platformlar: form.platformlar || [],
    };
    if (modal === "addEv") setData(d => ({ ...d, airbnbEvler: [...(d.airbnbEvler || []), item] }));
    else setData(d => ({ ...d, airbnbEvler: (d.airbnbEvler || []).map(e => e.id === item.id ? item : e) }));
    setModal(null);
  };

  const saveRez = () => {
    const gece    = geceSayisi(form.girisTarihi, form.cikisTarihi);
    const gecelik = Number(form.gecelik) || selectedEv?.geceLikFiyat || 0;
    const toplam  = Number(form.toplamTutar) || gece * gecelik;
    const kOran   = Number(form.komisyonOran) || 0;
    const komisyon = Math.round(toplam * (kOran / 100));
    const net      = toplam - komisyon;
    const item = { ...form, id: modal === "editRez" ? form.id : Date.now(), gecelik, toplamTutar: toplam, komisyon, netGelir: net, geceSayisi: gece };

    setData(d => {
      const yeniRez = modal === "addRez"
        ? [...(d.airbnbRezervasyon || []), item]
        : (d.airbnbRezervasyon || []).map(r => r.id === item.id ? item : r);
      let yeniGelir = d.gelir.filter(g => g.kaynak !== `airbnb_${item.id}`);
      if (item.odeme === "odendi" && item.durum !== "iptal") {
        yeniGelir.push({
          id: Date.now() + 1,
          tarih: item.cikisTarihi || item.girisTarihi,
          tutar: net,
          aciklama: `Airbnb: ${item.misafirAd} — ${evler.find(e=>e.id===item.evId)?.baslik||"Ev"} (${item.girisTarihi}→${item.cikisTarihi})`,
          kaynak: `airbnb_${item.id}`,
        });
      }
      return { ...d, airbnbRezervasyon: yeniRez, gelir: yeniGelir };
    });
    setModal(null);
  };

  const toplamNetGelir = rezervasyonlar.filter(r=>r.odeme==="odendi"&&r.durum!=="iptal").reduce((s,r)=>s+(r.netGelir||0),0);
  const aktifRez       = rezervasyonlar.filter(r=>r.durum==="onaylandi").length;
  const bugunAktif     = rezervasyonlar.filter(r=>r.durum==="onaylandi"&&r.girisTarihi<=bugunTarih&&r.cikisTarihi>bugunTarih).length;

  const ayGunSayisi = new Date(takvimYil, takvimAy + 1, 0).getDate();
  const ilkGun      = (new Date(takvimYil, takvimAy, 1).getDay() + 6) % 7;

  const gunRezervasyonlar = (gun) => {
    const tarih = `${takvimYil}-${String(takvimAy+1).padStart(2,"0")}-${String(gun).padStart(2,"0")}`;
    return rezervasyonlar.filter(r => r.durum !== "iptal" && r.girisTarihi <= tarih && r.cikisTarihi > tarih);
  };

  const { filtreli: filtreliRez, FiltreBar: RezFiltreBar } = useFiltre(
    filterEv === 0 ? rezervasyonlar : rezervasyonlar.filter(r => r.evId === filterEv),
    (x, q) => x.misafirAd?.toLowerCase().includes(q) || x.platform?.toLowerCase().includes(q) || x.notlar?.toLowerCase().includes(q),
    x => x.girisTarihi
  );
  const { filtreli: filtreliEvler, FiltreBar: EvFiltreBar } = useFiltre(
    evler,
    (x, q) => x.baslik?.toLowerCase().includes(q) || x.adres?.toLowerCase().includes(q),
    x => String(x.id)
  );

  const emptyEv  = { baslik:"", adres:"", tur:"daire", kapasite:2, odaSayisi:1, banyoSayisi:1, geceLikFiyat:"", platformlar:["airbnb"], airbnbUrl:"", bookingUrl:"", durum:"musait", notlar:"" };
  const emptyRez = { evId:evler[0]?.id||"", misafirAd:"", misafirTel:"", girisTarihi:"", cikisTarihi:"", gecelik:"", toplamTutar:"", komisyonOran:10, platform:"airbnb", durum:"onaylandi", notlar:"", odeme:"bekliyor" };

  return (
    <div className="page">
      <div className="page-header">
        <h2>🏠 Airbnb / Kiralık Evler</h2>
        <div style={{ display:"flex", gap:8 }}>
          {tab==="evler" && <button className="btn-primary" onClick={()=>{ setForm(emptyEv); setModal("addEv"); }}><Icon name="plus" size={16}/> Ev Ekle</button>}
          {tab==="rezervasyonlar" && <button className="btn-primary" onClick={()=>{ setForm({...emptyRez}); setSelectedEv(evler[0]||null); setModal("addRez"); }}><Icon name="plus" size={16}/> Rezervasyon Ekle</button>}
        </div>
      </div>

      {/* ÖZET KARTLAR */}
      <div style={{ display:"flex", gap:10, marginBottom:18, flexWrap:"wrap" }}>
        {[
          { l:"Toplam Ev",          v:evler.length,    bg:"#ede9fe", c:"#5b21b6" },
          { l:"Aktif Rezervasyon",  v:aktifRez,        bg:"#dbeafe", c:"#1e40af" },
          { l:"Bugün Dolu",         v:bugunAktif,      bg:"#fef3c7", c:"#92400e" },
          { l:"Net Gelir (Ödendi)", v:`₺${toplamNetGelir.toLocaleString()}`, bg:"#d1fae5", c:"#065f46" },
        ].map(s=>(
          <div key={s.l} style={{ background:s.bg, borderRadius:12, padding:"10px 18px" }}>
            <div style={{ fontSize:11, color:s.c, opacity:0.8 }}>{s.l}</div>
            <div style={{ fontSize:20, fontWeight:800, color:s.c }}>{s.v}</div>
          </div>
        ))}
      </div>

      {/* TAB SEKMELERİ */}
      <div style={{ display:"flex", gap:0, marginBottom:20, background:"#f1f5f9", borderRadius:12, padding:4, width:"fit-content" }}>
        {[["evler","🏠 Evler"],["rezervasyonlar","📅 Rezervasyonlar"],["takvim","🗓️ Takvim"]].map(([id,lbl])=>(
          <button key={id} onClick={()=>setTab(id)} style={{ padding:"9px 20px", borderRadius:9, border:"none", cursor:"pointer", fontWeight:700, fontSize:13,
            background:tab===id?"white":"transparent", color:tab===id?"#0f172a":"#64748b",
            boxShadow:tab===id?"0 1px 4px rgba(0,0,0,0.1)":"none", transition:"all 0.15s" }}>
            {lbl}
          </button>
        ))}
      </div>

      {/* ─── EVLER ─── */}
      {tab==="evler" && (
        <div>
          <EvFiltreBar placeholder="Ev adı veya adres ara..." />
          {filtreliEvler.length===0 && <div className="empty-state" style={{background:"white",borderRadius:14,border:"1px solid #e2e8f0"}}>Henüz ev eklenmedi.</div>}
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(320px,1fr))", gap:16 }}>
            {filtreliEvler.map(ev => {
              const d   = durumCfg[ev.durum] || durumCfg.musait;
              const evRez = rezervasyonlar.filter(r=>r.evId===ev.id&&r.durum==="onaylandi");
              const bugunDolu = evRez.some(r=>r.girisTarihi<=bugunTarih&&r.cikisTarihi>bugunTarih);
              const evNetGelir = rezervasyonlar.filter(r=>r.evId===ev.id&&r.odeme==="odendi"&&r.durum!=="iptal").reduce((s,r)=>s+(r.netGelir||0),0);
              return (
                <div key={ev.id} style={{ background:"white", borderRadius:14, border:"1px solid #e2e8f0", overflow:"hidden" }}>
                  <div style={{ padding:"16px 18px", borderBottom:"1px solid #f1f5f9" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:8 }}>
                      <div>
                        <div style={{ fontWeight:700, fontSize:15, color:"#0f172a" }}>{ev.baslik}</div>
                        <div style={{ fontSize:12, color:"#64748b", marginTop:2 }}>📍 {ev.adres}</div>
                      </div>
                      <span style={{ background:d.bg, color:d.c, padding:"3px 10px", borderRadius:20, fontSize:11, fontWeight:600, display:"flex", alignItems:"center", gap:4 }}>
                        <span style={{ width:6, height:6, borderRadius:"50%", background:d.dot }}/>
                        {d.l}
                      </span>
                    </div>
                    <div style={{ display:"flex", gap:12, flexWrap:"wrap", fontSize:12, color:"#64748b" }}>
                      <span>🛏️ {ev.odaSayisi} oda</span>
                      <span>🚿 {ev.banyoSayisi} banyo</span>
                      <span>👥 {ev.kapasite} kişi</span>
                      <span style={{ color:"#0f172a", fontWeight:700 }}>₺{(ev.geceLikFiyat||0).toLocaleString()}/gece</span>
                    </div>
                    <div style={{ display:"flex", gap:5, marginTop:8, flexWrap:"wrap" }}>
                      {(ev.platformlar||[]).map(p=>{ const pc=platformCfg[p]||platformCfg.diger; return <span key={p} style={{ background:pc.bg, color:pc.c, padding:"2px 8px", borderRadius:20, fontSize:11, fontWeight:600 }}>{pc.l}</span>; })}
                    </div>
                  </div>
                  <div style={{ padding:"10px 18px", background:"#f8fafc", display:"flex", gap:16, fontSize:12, color:"#64748b" }}>
                    <span>Bugün: <strong style={{ color:bugunDolu?"#ef4444":"#10b981" }}>{bugunDolu?"Dolu":"Boş"}</strong></span>
                    <span>Aktif: <strong>{evRez.length}</strong></span>
                    <span>Net Gelir: <strong style={{ color:"#10b981" }}>₺{evNetGelir.toLocaleString()}</strong></span>
                  </div>
                  {(ev.airbnbUrl||ev.bookingUrl) && (
                    <div style={{ padding:"8px 18px", display:"flex", gap:8 }}>
                      {ev.airbnbUrl && <a href={ev.airbnbUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize:11, color:"#991b1b", background:"#fee2e2", padding:"3px 10px", borderRadius:8, textDecoration:"none", fontWeight:600 }}>Airbnb ↗</a>}
                      {ev.bookingUrl && <a href={ev.bookingUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize:11, color:"#1e40af", background:"#dbeafe", padding:"3px 10px", borderRadius:8, textDecoration:"none", fontWeight:600 }}>Booking ↗</a>}
                    </div>
                  )}
                  <div style={{ padding:"10px 18px", display:"flex", gap:6, justifyContent:"flex-end" }}>
                    <button className="btn-outline" style={{ fontSize:12 }}
                      onClick={()=>{ setForm({...emptyRez, evId:ev.id, gecelik:ev.geceLikFiyat}); setSelectedEv(ev); setModal("addRez"); setTab("rezervasyonlar"); }}>
                      📅 Rezervasyon Ekle
                    </button>
                    <button className="icon-btn" onClick={()=>{ setForm({...ev}); setModal("editEv"); }}><Icon name="edit" size={15}/></button>
                    <button className="icon-btn danger" onClick={()=>delEv(ev.id)}><Icon name="trash" size={15}/></button>
                  </div>
                  {ev.notlar && <div style={{ padding:"0 18px 12px", fontSize:12, color:"#64748b" }}>📝 {ev.notlar}</div>}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ─── REZERVASYONLAR ─── */}
      {tab==="rezervasyonlar" && (
        <div>
          <div className="filter-tabs" style={{ marginBottom:10 }}>
            <button className={`filter-tab ${filterEv===0?"active":""}`} onClick={()=>setFilterEv(0)}>Tümü ({rezervasyonlar.length})</button>
            {evler.map(e=><button key={e.id} className={`filter-tab ${filterEv===e.id?"active":""}`} onClick={()=>setFilterEv(e.id)}>{e.baslik} ({rezervasyonlar.filter(r=>r.evId===e.id).length})</button>)}
          </div>
          <RezFiltreBar placeholder="Misafir adı veya platform ara..." />
          <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
            {filtreliRez.sort((a,b)=>b.girisTarihi.localeCompare(a.girisTarihi)).map(r => {
              const ev  = evler.find(e=>e.id===r.evId);
              const rdc = rezDurumCfg[r.durum] || rezDurumCfg.beklemede;
              const plc = platformCfg[r.platform] || platformCfg.diger;
              const gece = geceSayisi(r.girisTarihi, r.cikisTarihi);
              return (
                <div key={r.id} style={{ background:"white", borderRadius:14, border:"1px solid #e2e8f0", overflow:"hidden" }}>
                  <div style={{ padding:"14px 18px" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:10, flexWrap:"wrap", gap:8 }}>
                      <div>
                        <div style={{ fontWeight:700, fontSize:15, color:"#0f172a" }}>{r.misafirAd}</div>
                        <div style={{ fontSize:12, color:"#64748b", marginTop:2 }}>📞 {r.misafirTel}</div>
                        {ev && <div style={{ fontSize:12, color:"#3b82f6", marginTop:2 }}>🏠 {ev.baslik}</div>}
                      </div>
                      <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                        <span style={{ background:plc.bg, color:plc.c, padding:"3px 10px", borderRadius:20, fontSize:11, fontWeight:600 }}>{plc.l}</span>
                        <span style={{ background:rdc.bg, color:rdc.c, padding:"3px 10px", borderRadius:20, fontSize:11, fontWeight:600 }}>{rdc.l}</span>
                        <span style={{ background:r.odeme==="odendi"?"#d1fae5":"#fef3c7", color:r.odeme==="odendi"?"#065f46":"#92400e", padding:"3px 10px", borderRadius:20, fontSize:11, fontWeight:600 }}>
                          {r.odeme==="odendi"?"💰 Ödendi":"⏳ Bekliyor"}
                        </span>
                      </div>
                    </div>
                    <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(120px,1fr))", gap:8 }}>
                      {[
                        { l:"Giriş",    v:r.girisTarihi },
                        { l:"Çıkış",    v:r.cikisTarihi },
                        { l:"Gece",     v:`${gece} gece` },
                        { l:"Gecelik",  v:`₺${(r.gecelik||0).toLocaleString()}` },
                        { l:"Toplam",   v:`₺${(r.toplamTutar||0).toLocaleString()}`, bold:true },
                        { l:"Komisyon", v:`₺${(r.komisyon||0).toLocaleString()}`, red:true },
                        { l:"Net Gelir",v:`₺${(r.netGelir||0).toLocaleString()}`, green:true },
                      ].map(s=>(
                        <div key={s.l} style={{ background:"#f8fafc", borderRadius:8, padding:"6px 10px" }}>
                          <div style={{ fontSize:10, color:"#64748b" }}>{s.l}</div>
                          <div style={{ fontSize:13, fontWeight:s.bold||s.green||s.red?700:500, color:s.green?"#10b981":s.red?"#ef4444":"#0f172a" }}>{s.v}</div>
                        </div>
                      ))}
                    </div>
                    {r.notlar && <div style={{ marginTop:8, fontSize:12, color:"#64748b" }}>📝 {r.notlar}</div>}
                  </div>
                  <div style={{ padding:"8px 18px", display:"flex", gap:6, justifyContent:"flex-end", borderTop:"1px solid #f1f5f9" }}>
                    <button className="icon-btn" onClick={()=>{ setForm({...r, komisyonOran:r.toplamTutar?Math.round((r.komisyon||0)/(r.toplamTutar||1)*100):10}); setSelectedEv(ev||null); setModal("editRez"); }}><Icon name="edit" size={15}/></button>
                    <button className="icon-btn danger" onClick={()=>delRez(r.id)}><Icon name="trash" size={15}/></button>
                  </div>
                </div>
              );
            })}
            {filtreliRez.length===0 && <div className="empty-state" style={{background:"white",borderRadius:14,border:"1px solid #e2e8f0"}}>Rezervasyon bulunamadı.</div>}
          </div>
        </div>
      )}

      {/* ─── TAKVİM ─── */}
      {tab==="takvim" && (
        <div>
          <div style={{ display:"flex", gap:8, alignItems:"center", marginBottom:16, background:"white", borderRadius:12, padding:"12px 16px", border:"1px solid #e2e8f0" }}>
            <button className="btn-secondary" onClick={()=>{ let y=takvimYil,a=takvimAy-1; if(a<0){a=11;y--;} setTakvimYil(y); setTakvimAy(a); }}>◀</button>
            <div style={{ flex:1, textAlign:"center", fontWeight:700, fontSize:15 }}>{AYLAR_TR[takvimAy]} {takvimYil}</div>
            <button className="btn-secondary" onClick={()=>{ let y=takvimYil,a=takvimAy+1; if(a>11){a=0;y++;} setTakvimYil(y); setTakvimAy(a); }}>▶</button>
          </div>
          <div className="filter-tabs" style={{ marginBottom:12 }}>
            <button className={`filter-tab ${filterEv===0?"active":""}`} onClick={()=>setFilterEv(0)}>Tümü</button>
            {evler.map(e=><button key={e.id} className={`filter-tab ${filterEv===e.id?"active":""}`} onClick={()=>setFilterEv(e.id)}>{e.baslik}</button>)}
          </div>
          <div style={{ background:"white", borderRadius:14, border:"1px solid #e2e8f0", overflow:"hidden" }}>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)", background:"#f8fafc" }}>
              {["Pzt","Sal","Çar","Per","Cum","Cmt","Paz"].map(g=>(
                <div key={g} style={{ padding:"10px 0", textAlign:"center", fontSize:11, fontWeight:700, color:"#64748b" }}>{g}</div>
              ))}
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:1, background:"#f1f5f9" }}>
              {Array.from({length:ilkGun}).map((_,i)=><div key={`e${i}`} style={{ background:"white", minHeight:80 }}/>)}
              {Array.from({length:ayGunSayisi},(_,i)=>i+1).map(gun=>{
                const tarih = `${takvimYil}-${String(takvimAy+1).padStart(2,"0")}-${String(gun).padStart(2,"0")}`;
                const gunRez = gunRezervasyonlar(gun).filter(r=>filterEv===0||r.evId===filterEv);
                const isToday = tarih===bugunTarih;
                return (
                  <div key={gun} style={{ background:"white", minHeight:80, padding:"6px 8px" }}>
                    <div style={{ fontSize:12, fontWeight:isToday?700:500, color:isToday?"#3b82f6":"#475569",
                      width:22, height:22, borderRadius:"50%", background:isToday?"#dbeafe":"transparent",
                      display:"flex", alignItems:"center", justifyContent:"center", marginBottom:4 }}>{gun}</div>
                    {gunRez.map(r=>{
                      const ev=evler.find(e=>e.id===r.evId);
                      const plc=platformCfg[r.platform]||platformCfg.diger;
                      return <div key={r.id} style={{ background:plc.bg, color:plc.c, borderRadius:4, padding:"2px 4px", fontSize:10, fontWeight:600, marginBottom:2, overflow:"hidden", whiteSpace:"nowrap", textOverflow:"ellipsis" }}>{ev?.baslik||"—"}: {r.misafirAd.split(" ")[0]}</div>;
                    })}
                  </div>
                );
              })}
            </div>
          </div>
          <div style={{ marginTop:12, display:"flex", gap:10, flexWrap:"wrap" }}>
            {Object.entries(platformCfg).map(([k,v])=>(
              <div key={k} style={{ display:"flex", alignItems:"center", gap:5, fontSize:12, color:"#64748b" }}>
                <span style={{ width:12, height:12, borderRadius:3, background:v.bg, border:`1px solid ${v.c}` }}/>
                {v.l}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* EV EKLE/DÜZENLE MODAL */}
      {(modal==="addEv"||modal==="editEv") && (
        <Modal title={modal==="addEv"?"🏠 Ev Ekle":"🏠 Ev Düzenle"} onClose={()=>setModal(null)} wide>
          <div className="form-grid">
            <Field label="Ev Başlığı" value={form.baslik||""} onChange={v=>f("baslik",v)} required fullWidth/>
            <Field label="Adres / Konum" value={form.adres||""} onChange={v=>f("adres",v)} fullWidth/>
            <Field label="Tür" type="select" value={form.tur||"daire"} onChange={v=>f("tur",v)} options={[{value:"daire",label:"Daire"},{value:"villa",label:"Villa"},{value:"yazlik",label:"Yazlık"},{value:"studyo",label:"Stüdyo"},{value:"diger",label:"Diğer"}]}/>
            <Field label="Durum" type="select" value={form.durum||"musait"} onChange={v=>f("durum",v)} options={Object.entries(durumCfg).map(([k,v])=>({value:k,label:v.l}))}/>
            <Field label="Kapasite (kişi)" type="number" value={form.kapasite||""} onChange={v=>f("kapasite",v)}/>
            <Field label="Oda Sayısı" type="number" value={form.odaSayisi||""} onChange={v=>f("odaSayisi",v)}/>
            <Field label="Banyo Sayısı" type="number" value={form.banyoSayisi||""} onChange={v=>f("banyoSayisi",v)}/>
            <Field label="Gecelik Fiyat (₺)" type="number" value={form.geceLikFiyat||""} onChange={v=>f("geceLikFiyat",v)} required/>
          </div>
          <div style={{ marginBottom:14 }}>
            <label style={{ fontSize:12, fontWeight:600, color:"#374151", display:"block", marginBottom:6 }}>Platformlar</label>
            <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
              {Object.entries(platformCfg).filter(([k])=>k!=="diger").map(([k,v])=>(
                <button key={k} type="button" onClick={()=>{
                  const m=form.platformlar||[];
                  f("platformlar", m.includes(k)?m.filter(p=>p!==k):[...m,k]);
                }} style={{ padding:"6px 14px", borderRadius:20, border:`2px solid ${(form.platformlar||[]).includes(k)?v.c:"#e2e8f0"}`,
                  background:(form.platformlar||[]).includes(k)?v.bg:"white", color:(form.platformlar||[]).includes(k)?v.c:"#64748b",
                  cursor:"pointer", fontWeight:600, fontSize:12 }}>
                  {v.l}
                </button>
              ))}
            </div>
          </div>
          <div className="form-grid">
            <Field label="Airbnb Listing URL" value={form.airbnbUrl||""} onChange={v=>f("airbnbUrl",v)} placeholder="https://airbnb.com/rooms/..."/>
            <Field label="Booking.com URL" value={form.bookingUrl||""} onChange={v=>f("bookingUrl",v)} placeholder="https://booking.com/..."/>
            <Field label="Notlar" type="textarea" value={form.notlar||""} onChange={v=>f("notlar",v)} fullWidth/>
          </div>
          <div className="modal-footer">
            <button className="btn-secondary" onClick={()=>setModal(null)}>İptal</button>
            <button className="btn-primary" onClick={saveEv}>Kaydet</button>
          </div>
        </Modal>
      )}

      {/* REZERVASYON EKLE/DÜZENLE MODAL */}
      {(modal==="addRez"||modal==="editRez") && (
        <Modal title={modal==="addRez"?"📅 Rezervasyon Ekle":"📅 Rezervasyon Düzenle"} onClose={()=>setModal(null)} wide>
          <div style={{ background:"#f0f7ff", borderRadius:10, padding:"10px 14px", marginBottom:14, fontSize:12, color:"#1e40af" }}>
            💡 Ödeme <strong>"Ödendi"</strong> yapılınca net gelir otomatik kasaya eklenir.
          </div>
          <div className="form-grid">
            <div style={{ display:"flex", flexDirection:"column", gap:5 }}>
              <label style={{ fontSize:12, fontWeight:600, color:"#374151" }}>Ev *</label>
              <select value={form.evId||""} onChange={e=>{ const ev=evler.find(ev=>ev.id===Number(e.target.value)); setSelectedEv(ev||null); f("evId",Number(e.target.value)); f("gecelik",ev?.geceLikFiyat||""); }}
                style={{ padding:"9px 12px", borderRadius:9, border:"1px solid #e2e8f0", fontSize:13, outline:"none" }}>
                <option value="">— Ev seç —</option>
                {evler.map(e=><option key={e.id} value={e.id}>{e.baslik} — {e.adres}</option>)}
              </select>
            </div>
            <Field label="Platform" type="select" value={form.platform||"airbnb"} onChange={v=>f("platform",v)} options={Object.entries(platformCfg).map(([k,v])=>({value:k,label:v.l}))}/>
            <Field label="Misafir Ad Soyad" value={form.misafirAd||""} onChange={v=>f("misafirAd",v)} required/>
            <Field label="Misafir Telefon" value={form.misafirTel||""} onChange={v=>f("misafirTel",v)}/>
            <Field label="Giriş Tarihi" type="date" value={form.girisTarihi||""} onChange={v=>{ f("girisTarihi",v); const g=geceSayisi(v,form.cikisTarihi); const gl=Number(form.gecelik)||0; if(g>0&&gl>0)f("toplamTutar",g*gl); }}/>
            <Field label="Çıkış Tarihi" type="date" value={form.cikisTarihi||""} onChange={v=>{ f("cikisTarihi",v); const g=geceSayisi(form.girisTarihi,v); const gl=Number(form.gecelik)||0; if(g>0&&gl>0)f("toplamTutar",g*gl); }}/>
            <Field label="Gecelik Ücret (₺)" type="number" value={form.gecelik||""} onChange={v=>{ f("gecelik",v); const g=geceSayisi(form.girisTarihi,form.cikisTarihi); if(g>0)f("toplamTutar",g*Number(v)); }}/>
            <Field label="Toplam Tutar (₺)" type="number" value={form.toplamTutar||""} onChange={v=>f("toplamTutar",v)}/>
            <Field label="Komisyon (%)" type="number" value={form.komisyonOran||10} onChange={v=>f("komisyonOran",v)} placeholder="10"/>
            <Field label="Rezervasyon Durumu" type="select" value={form.durum||"onaylandi"} onChange={v=>f("durum",v)} options={Object.entries(rezDurumCfg).map(([k,v])=>({value:k,label:v.l}))}/>
            <Field label="Ödeme Durumu" type="select" value={form.odeme||"bekliyor"} onChange={v=>f("odeme",v)} options={[{value:"bekliyor",label:"⏳ Bekliyor"},{value:"odendi",label:"✅ Ödendi"},{value:"iade",label:"↩ İade"}]}/>
            <Field label="Notlar" type="textarea" value={form.notlar||""} onChange={v=>f("notlar",v)} fullWidth/>
          </div>
          {form.girisTarihi && form.cikisTarihi && form.toplamTutar && (
            <div style={{ background:"#f8fafc", borderRadius:10, padding:"12px 16px", marginBottom:14 }}>
              <div style={{ fontSize:12, fontWeight:700, color:"#374151", marginBottom:8 }}>Finansal Özet</div>
              <div style={{ display:"flex", gap:16, flexWrap:"wrap", fontSize:13 }}>
                <span>🌙 {geceSayisi(form.girisTarihi,form.cikisTarihi)} gece</span>
                <span>💵 Toplam: <strong>₺{Number(form.toplamTutar).toLocaleString()}</strong></span>
                <span style={{ color:"#ef4444" }}>📉 Komisyon %{form.komisyonOran||0}: <strong>₺{Math.round(Number(form.toplamTutar)*(Number(form.komisyonOran)||0)/100).toLocaleString()}</strong></span>
                <span style={{ color:"#10b981" }}>✅ Net: <strong>₺{(Number(form.toplamTutar)-Math.round(Number(form.toplamTutar)*(Number(form.komisyonOran)||0)/100)).toLocaleString()}</strong></span>
              </div>
            </div>
          )}
          <div className="modal-footer">
            <button className="btn-secondary" onClick={()=>setModal(null)}>İptal</button>
            <button className="btn-primary" onClick={saveRez}>Kaydet</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ============================================================
// GELİR GİDER — Merkezi Kasa
// ============================================================
function GelirGider({ data, setData, t }) {
  const [raporModal, setRaporModal] = useState(false);
  const [tab, setTab] = useState("gelir");
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({});

  const kasa = hesaplaKasa(data);
  const emptyForm = { tarih: new Date().toISOString().split("T")[0], tutar: "", aciklama: "" };

  const save = () => {
    const item = { ...form, tutar: Number(form.tutar), id: Date.now(), kaynak: "manuel" };
    if (tab === "gelir") setData((d) => ({ ...d, gelir: [...d.gelir, item] }));
    else setData((d) => ({ ...d, gider: [...d.gider, item] }));
    setModal(false);
  };
  const del = (id, type) => { if (window.confirm("Sil?")) { if (type === "gelir") setData((d) => ({ ...d, gelir: d.gelir.filter((g) => g.id !== id) })); else setData((d) => ({ ...d, gider: d.gider.filter((g) => g.id !== id) })); } };
  const f = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const { filtreli: filtreliGelir, FiltreBar: GelirFiltreBar } = useFiltre(data.gelir, (x, q) => x.aciklama?.toLowerCase().includes(q), x => x.tarih);
  const { filtreli: filtreliGider, FiltreBar: GiderFiltreBar } = useFiltre(data.gider, (x, q) => x.aciklama?.toLowerCase().includes(q), x => x.tarih);

  const items = tab === "gelir" ? filtreliGelir : filtreliGider;

  return (
    <div className="page">
      <div className="page-header">
        <h2>{t.income}</h2>
        <div style={{display:"flex",gap:8}}><button className="btn-secondary" onClick={()=>setRaporModal(true)}>Rapor Al</button></div>
        <button className={`btn-primary ${tab === "gider" ? "danger" : ""}`} onClick={() => { setForm(emptyForm); setModal(true); }}>
          <Icon name="plus" size={16} /> {tab === "gelir" ? "Gelir Ekle" : "Gider Ekle"}
        </button>
      </div>

      {/* MERKEZ KASA KARTI */}
      <div style={{ background: "#0f172a", borderRadius: 16, padding: "20px 24px", marginBottom: 20, color: "white" }}>
        <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>Kasa Özeti — Tüm Kaynaklar</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 12 }}>
          <div style={{ background: "rgba(16,185,129,0.15)", borderRadius: 10, padding: "10px 14px", borderLeft: "3px solid #10b981" }}>
            <div style={{ fontSize: 11, color: "#6ee7b7" }}>Toplam Gelir</div>
            <div style={{ fontSize: 20, fontWeight: 800, color: "#10b981" }}>₺{kasa.toplamGelir.toLocaleString()}</div>
          </div>
          <div style={{ background: "rgba(239,68,68,0.15)", borderRadius: 10, padding: "10px 14px", borderLeft: "3px solid #ef4444" }}>
            <div style={{ fontSize: 11, color: "#fca5a5" }}>Toplam Gider</div>
            <div style={{ fontSize: 20, fontWeight: 800, color: "#ef4444" }}>₺{kasa.toplamGider.toLocaleString()}</div>
          </div>
          <div style={{ background: kasa.bakiye >= 0 ? "rgba(59,130,246,0.2)" : "rgba(239,68,68,0.2)", borderRadius: 10, padding: "10px 14px", borderLeft: `3px solid ${kasa.bakiye >= 0 ? "#3b82f6" : "#ef4444"}` }}>
            <div style={{ fontSize: 11, color: "#93c5fd" }}>Kasa Bakiyesi</div>
            <div style={{ fontSize: 22, fontWeight: 800, color: kasa.bakiye >= 0 ? "#60a5fa" : "#ef4444" }}>₺{kasa.bakiye.toLocaleString()}</div>
          </div>
        </div>
        {/* Kaynak breakdown */}
        <div style={{ display: "flex", gap: 12, marginTop: 12, flexWrap: "wrap" }}>
          {[
            { l: "Manuel Gelir", v: kasa.manuelGelir, c: "#10b981" },
            { l: "İş Gelirleri", v: kasa.isGelir, c: "#3b82f6" },
            { l: "Müşteri Tahsilatı", v: kasa.musteriGelir, c: "#8b5cf6" },
            { l: "Manuel Gider", v: -kasa.manuelGider, c: "#f59e0b" },
            { l: "Personel Avans", v: -kasa.personelGider, c: "#ef4444" },
          ].map(s => (
            <div key={s.l} style={{ fontSize: 12, color: "#94a3b8" }}>
              {s.l}: <strong style={{ color: s.c }}>{s.v >= 0 ? "+" : ""}₺{s.v.toLocaleString()}</strong>
            </div>
          ))}
        </div>
      </div>

      <div className="tab-row">
        <button className={`tab-btn ${tab === "gelir" ? "active" : ""}`} onClick={() => setTab("gelir")}>💰 Manuel Gelirler ({data.gelir.length})</button>
        <button className={`tab-btn ${tab === "gider" ? "active" : ""}`} onClick={() => setTab("gider")}>📉 Manuel Giderler ({data.gider.length})</button>
      </div>

      {tab === "gelir" ? <GelirFiltreBar placeholder="Açıklama ara..." /> : <GiderFiltreBar placeholder="Açıklama ara..." />}

      <div className="table-card">
        <table className="data-table">
          <thead><tr><th>{t.date}</th><th>{t.amount}</th><th>{t.description}</th><th>İşlem</th></tr></thead>
          <tbody>
            {items.sort((a, b) => new Date(b.tarih) - new Date(a.tarih)).map((item) => (
              <tr key={item.id}>
                <td>{item.tarih}</td>
                <td><strong style={{ color: tab === "gelir" ? "#10b981" : "#ef4444" }}>₺{item.tutar.toLocaleString()}</strong></td>
                <td>{item.aciklama}</td>
                <td><button className="icon-btn danger" onClick={() => del(item.id, tab)}><Icon name="trash" size={15} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
        {items.length === 0 && <div className="empty-state">Kayıt yok.</div>}
      </div>

      {modal && (
        <Modal title={tab === "gelir" ? "Gelir Ekle" : "Gider Ekle"} onClose={() => setModal(false)}>
          <div className="form-grid">
            <Field label={t.date} type="date" value={form.tarih} onChange={(v) => f("tarih", v)} />
            <Field label={`${t.amount} (₺)`} type="number" value={form.tutar} onChange={(v) => f("tutar", v)} required />
            <Field label={t.description} type="textarea" value={form.aciklama} onChange={(v) => f("aciklama", v)} fullWidth />
          </div>
          <div className="modal-footer">
            <button className="btn-secondary" onClick={() => setModal(false)}>{t.cancel}</button>
            <button className="btn-primary" onClick={save}>{t.save}</button>
          </div>
        </Modal>
      )}
      {raporModal && <EvrenselRaporModal tip="gelirGider" data={data} onClose={()=>setRaporModal(false)} />}
    </div>
  );
}

// ============================================================
// İŞLER — Kasaya otomatik yansıma + arama
// ============================================================
function Isler({ data, setData, t }) {
  const [raporModal, setRaporModal] = useState(false);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [filterDurum, setFilterDurum] = useState("hepsi");

  const emptyForm = { tarih: new Date().toISOString().split("T")[0], musteriIsmi: "", musteriTel: "", isBilgisi: "", adres: "", bedel: "", odemeTuru: "nakit", odemeDurum: "bekliyor" };

  const save = () => {
    const item = { ...form, bedel: Number(form.bedel), id: modal === "edit" ? form.id : Date.now() };
    const eskiItem = modal === "edit" ? data.isler.find(i => i.id === item.id) : null;

    setData((d) => {
      let yeniIsler = modal === "add" ? [...d.isler, item] : d.isler.map(i => i.id === item.id ? item : i);

      // Kasaya yansıma: ödendi yapıldığında gelir ekle, geri alındığında kaldır
      let yeniGelir = [...d.gelir];
      if (modal === "edit" && eskiItem) {
        // Eski otomatik geliri kaldır
        yeniGelir = yeniGelir.filter(g => g.kaynak !== `is_${item.id}`);
      }
      if (item.odemeDurum === "odendi") {
        yeniGelir.push({ id: `is_${item.id}`, tarih: item.tarih, tutar: item.bedel, aciklama: `İş geliri: ${item.musteriIsmi} — ${item.isBilgisi}`, kaynak: `is_${item.id}` });
      }

      return { ...d, isler: yeniIsler, gelir: yeniGelir };
    });
    setModal(null);
  };

  const del = (id) => {
    if (window.confirm("Sil?")) {
      setData((d) => ({
        ...d,
        isler: d.isler.filter(i => i.id !== id),
        gelir: d.gelir.filter(g => g.kaynak !== `is_${id}`),
      }));
    }
  };

  const f = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const { filtreli, FiltreBar } = useFiltre(
    filterDurum === "hepsi" ? data.isler : data.isler.filter(i => i.odemeDurum === filterDurum),
    (x, q) => x.musteriIsmi?.toLowerCase().includes(q) || x.isBilgisi?.toLowerCase().includes(q) || x.adres?.toLowerCase().includes(q),
    x => x.tarih
  );

  const toplamBedel = filtreli.reduce((a, b) => a + b.bedel, 0);
  const toplamOdendi = filtreli.filter(i => i.odemeDurum === "odendi").reduce((a, b) => a + b.bedel, 0);
  const toplamBekliyor = filtreli.filter(i => i.odemeDurum === "bekliyor").reduce((a, b) => a + b.bedel, 0);

  return (
    <div className="page">
      <div className="page-header">
        <h2>{t.jobs}</h2>
        <div style={{display:"flex",gap:8}}><button className="btn-secondary" onClick={()=>setRaporModal(true)}>Rapor Al</button></div>
        <button className="btn-primary" onClick={() => { setForm(emptyForm); setModal("add"); }}><Icon name="plus" size={16} /> {t.add}</button>
      </div>

      {/* Özet kartlar */}
      <div style={{ display: "flex", gap: 10, marginBottom: 18, flexWrap: "wrap" }}>
        <div style={{ background: "#f8fafc", borderRadius: 12, padding: "10px 18px", border: "1px solid #e2e8f0" }}>
          <div style={{ fontSize: 11, color: "#64748b" }}>Toplam</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: "#1e293b" }}>₺{toplamBedel.toLocaleString()}</div>
        </div>
        <div style={{ background: "#d1fae5", borderRadius: 12, padding: "10px 18px", border: "1px solid #a7f3d0" }}>
          <div style={{ fontSize: 11, color: "#065f46" }}>✓ Ödendi → Kasaya Eklendi</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: "#10b981" }}>₺{toplamOdendi.toLocaleString()}</div>
        </div>
        <div style={{ background: "#fef3c7", borderRadius: 12, padding: "10px 18px", border: "1px solid #fde68a" }}>
          <div style={{ fontSize: 11, color: "#92400e" }}>○ Bekliyor</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: "#f59e0b" }}>₺{toplamBekliyor.toLocaleString()}</div>
        </div>
      </div>

      <div className="tab-row">
        {[["hepsi", "Tümü"], ["bekliyor", t.pending], ["odendi", t.paid]].map(([v, l]) => (
          <button key={v} className={`tab-btn ${filterDurum === v ? "active" : ""}`} onClick={() => setFilterDurum(v)}>
            {l} ({(v === "hepsi" ? data.isler : data.isler.filter(i => i.odemeDurum === v)).length})
          </button>
        ))}
      </div>

      <FiltreBar placeholder="Müşteri adı, iş veya adres ara..." />

      <div className="table-card">
        <table className="data-table">
          <thead><tr><th>{t.date}</th><th>Müşteri</th><th>İş</th><th>Bedel</th><th>Ödeme</th><th>Durum</th><th>İşlem</th></tr></thead>
          <tbody>
            {filtreli.sort((a, b) => new Date(b.tarih) - new Date(a.tarih)).map((i) => (
              <tr key={i.id}>
                <td>{i.tarih}</td>
                <td><div><strong>{i.musteriIsmi}</strong></div><div style={{ fontSize: 12, color: "#94a3b8" }}>{i.musteriTel}</div></td>
                <td>{i.isBilgisi}</td>
                <td><strong>₺{i.bedel.toLocaleString()}</strong></td>
                <td><Badge text={i.odemeTuru} type="info" /></td>
                <td>
                  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <Badge text={i.odemeDurum === "odendi" ? t.paid : t.pending} type={i.odemeDurum === "odendi" ? "success" : "warning"} />
                    {i.odemeDurum === "odendi" && <span style={{ fontSize: 10, color: "#10b981" }}>💰 Kasada</span>}
                  </div>
                </td>
                <td>
                  <div style={{ display: "flex", gap: 4 }}>
                    <button className="icon-btn" onClick={() => { setForm({ ...i }); setModal("edit"); }}><Icon name="edit" size={15} /></button>
                    <button className="icon-btn danger" onClick={() => del(i.id)}><Icon name="trash" size={15} /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {filtreli.length === 0 && <div className="empty-state">Kayıt yok.</div>}
      </div>

      {modal && (
        <Modal title={modal === "add" ? "İş Ekle" : "İş Düzenle"} onClose={() => setModal(null)} wide>
          <div style={{ background: "#dbeafe", borderRadius: 8, padding: "8px 12px", marginBottom: 14, fontSize: 12, color: "#1e40af" }}>
            💡 Durum <strong>"Ödendi"</strong> yapıldığında iş bedeli otomatik olarak kasaya gelir olarak eklenir.
          </div>
          <div className="form-grid">
            <Field label={t.date} type="date" value={form.tarih} onChange={(v) => f("tarih", v)} />
            <Field label="Müşteri" value={form.musteriIsmi} onChange={(v) => f("musteriIsmi", v)} required />
            <Field label="Tel" value={form.musteriTel} onChange={(v) => f("musteriTel", v)} />
            <Field label="Bedel (₺)" type="number" value={form.bedel} onChange={(v) => f("bedel", v)} />
            <Field label="Ödeme" type="select" value={form.odemeTuru} onChange={(v) => f("odemeTuru", v)} options={[{ value: "nakit", label: "Nakit" }, { value: "havale", label: "Havale" }, { value: "kart", label: "Kart" }]} />
            <Field label="Durum" type="select" value={form.odemeDurum} onChange={(v) => f("odemeDurum", v)} options={[{ value: "bekliyor", label: t.pending }, { value: "odendi", label: t.paid }]} />
            <Field label="İş Bilgisi" type="textarea" value={form.isBilgisi} onChange={(v) => f("isBilgisi", v)} />
            <Field label={t.address} type="textarea" value={form.adres} onChange={(v) => f("adres", v)} />
          </div>
          <div className="modal-footer">
            <button className="btn-secondary" onClick={() => setModal(null)}>{t.cancel}</button>
            <button className="btn-primary" onClick={save}>{t.save}</button>
          </div>
        </Modal>
      )}
      {raporModal && <EvrenselRaporModal tip="isler" data={data} onClose={()=>setRaporModal(false)} />}
    </div>
  );
}

// ============================================================
// YAPILACAKLAR
// ============================================================
function Yapilacaklar({ data, setData, t }) {
  const [raporModal, setRaporModal] = useState(false);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const emptyForm = { tarih: new Date().toISOString().split("T")[0], baslik: "", aciklama: "", durum: "bekliyor" };
  const save = () => {
    const item = { ...form, id: modal === "edit" ? form.id : Date.now() };
    if (modal === "add") setData((d) => ({ ...d, yapilacaklar: [...d.yapilacaklar, item] }));
    else setData((d) => ({ ...d, yapilacaklar: d.yapilacaklar.map((y) => y.id === item.id ? item : y) }));
    setModal(null);
  };
  const del = (id) => { if (window.confirm("Sil?")) setData((d) => ({ ...d, yapilacaklar: d.yapilacaklar.filter((y) => y.id !== id) })); };
  const toggle = (y) => setData((d) => ({ ...d, yapilacaklar: d.yapilacaklar.map((item) => item.id === y.id ? { ...item, durum: item.durum === "tamamlandi" ? "bekliyor" : "tamamlandi" } : item) }));
  const f = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const { filtreli: filtreBekliyen, FiltreBar } = useFiltre(
    data.yapilacaklar.filter(y => y.durum === "bekliyor"),
    (x, q) => x.baslik?.toLowerCase().includes(q) || x.aciklama?.toLowerCase().includes(q),
    x => x.tarih
  );
  const { filtreli: filtreTamamlanan } = useFiltre(
    data.yapilacaklar.filter(y => y.durum === "tamamlandi"),
    (x, q) => x.baslik?.toLowerCase().includes(q) || x.aciklama?.toLowerCase().includes(q),
    x => x.tarih
  );

  return (
    <div className="page">
      <div className="page-header">
        <h2>{t.todos}</h2>
        <div style={{display:"flex",gap:8}}><button className="btn-secondary" onClick={()=>setRaporModal(true)}>Rapor Al</button></div>
        <button className="btn-primary" onClick={() => { setForm(emptyForm); setModal("add"); }}><Icon name="plus" size={16} /> {t.add}</button>
      </div>
      <FiltreBar placeholder="Görev başlığı ara..." />
      <div className="todo-sections">
        <div>
          <div style={{ marginBottom: 12 }}>
            <span style={{ background: "#fef3c7", borderRadius: 8, padding: "2px 10px", fontSize: 14, color: "#92400e" }}>Bekleyen ({filtreBekliyen.length})</span>
          </div>
          <div className="todo-cards">
            {filtreBekliyen.map((y) => (
              <div key={y.id} className="todo-card pending">
                <div className="todo-card-header">
                  <div className="todo-check" onClick={() => toggle(y)} />
                  <div><div className="todo-card-title">{y.baslik}</div><div className="todo-card-date">{y.tarih}</div></div>
                  <div style={{ display: "flex", gap: 4, marginLeft: "auto" }}>
                    <button className="icon-btn" onClick={() => { setForm({ ...y }); setModal("edit"); }}><Icon name="edit" size={15} /></button>
                    <button className="icon-btn danger" onClick={() => del(y.id)}><Icon name="trash" size={15} /></button>
                  </div>
                </div>
                {y.aciklama && <p className="todo-card-desc">{y.aciklama}</p>}
              </div>
            ))}
            {filtreBekliyen.length === 0 && <div className="empty-state">Bekleyen görev yok 🎉</div>}
          </div>
        </div>
        <div>
          <div style={{ marginBottom: 12 }}>
            <span style={{ background: "#d1fae5", borderRadius: 8, padding: "2px 10px", fontSize: 14, color: "#065f46" }}>Tamamlanan ({filtreTamamlanan.length})</span>
          </div>
          <div className="todo-cards">
            {filtreTamamlanan.map((y) => (
              <div key={y.id} className="todo-card done">
                <div className="todo-card-header">
                  <div className="todo-check checked" onClick={() => toggle(y)}>✓</div>
                  <div><div className="todo-card-title done-text">{y.baslik}</div><div className="todo-card-date">{y.tarih}</div></div>
                  <button className="icon-btn danger" style={{ marginLeft: "auto" }} onClick={() => del(y.id)}><Icon name="trash" size={15} /></button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {modal && (
        <Modal title={modal === "add" ? "Görev Ekle" : "Düzenle"} onClose={() => setModal(null)}>
          <div className="form-grid">
            <Field label={t.date} type="date" value={form.tarih} onChange={(v) => f("tarih", v)} />
            <Field label="Durum" type="select" value={form.durum} onChange={(v) => f("durum", v)} options={[{ value: "bekliyor", label: "Bekliyor" }, { value: "tamamlandi", label: "Tamamlandı" }]} />
            <Field label="Başlık" value={form.baslik} onChange={(v) => f("baslik", v)} required fullWidth />
            <Field label={t.description} type="textarea" value={form.aciklama} onChange={(v) => f("aciklama", v)} fullWidth />
          </div>
          <div className="modal-footer">
            <button className="btn-secondary" onClick={() => setModal(null)}>{t.cancel}</button>
            <button className="btn-primary" onClick={save}>{t.save}</button>
          </div>
        </Modal>
      )}
      {raporModal && <EvrenselRaporModal tip="yapilacaklar" data={data} onClose={()=>setRaporModal(false)} />}
    </div>
  );
}

// ============================================================
// AYLAR YARDIMCI
// ============================================================
function tumAylariUret(siteKayitTarihi) {
  const aylar = [];
  const bas = siteKayitTarihi
    ? new Date(siteKayitTarihi)
    : new Date(new Date().getFullYear() - 1, 0, 1);
  const bugun = new Date();
  let d = new Date(bas);
  while (d <= bugun) {
    const yil = d.getFullYear();
    const ay = d.getMonth();
    aylar.push({ key: `${yil}-${String(ay + 1).padStart(2, "0")}`, label: `${AYLAR_TR[ay]} ${yil}`, yil, ay });
    d.setMonth(d.getMonth() + 1);
  }
  return aylar.reverse();
}

// ============================================================
// AİDAT DETAY MODAL
// ============================================================
function AidatDetayModal({ daire, site, data, setData, onClose, t }) {
  const aylar = tumAylariUret(site?.kayitTarihi);
  const [selectedAy, setSelectedAy] = useState(aylar[0]?.key || "");
  const [tab, setTab] = useState("aidat");
  const [eklemeModal, setEklemeModal] = useState(null);
  const [form, setForm] = useState({});

  const getOdeme = (ayKey) => {
    const key = `${daire.id}_${ayKey}`;
    return data.daireOdemeler?.[key] || { aidat: { durum: "bekleniyor", tarih: "" }, flat: { tutar: 0, tarih: "" }, diger: [] };
  };

  const setOdeme = (ayKey, updater) => {
    const key = `${daire.id}_${ayKey}`;
    setData((d) => ({ ...d, daireOdemeler: { ...d.daireOdemeler, [key]: updater(getOdeme(ayKey)) } }));
  };

  const seciliAy = getOdeme(selectedAy);
  const toplamOdendi = aylar.filter((a) => getOdeme(a.key).aidat?.durum === "odendi").length;
  const toplamGecikti = aylar.filter((a) => getOdeme(a.key).aidat?.durum === "gecikti").length;
  const toplamBekliyor = aylar.filter((a) => {
    const durum = getOdeme(a.key).aidat?.durum || "bekleniyor";
    return durum === "bekleniyor" || durum === "kismi";
  }).length;
  const toplamFlat = aylar.reduce((acc, a) => acc + (getOdeme(a.key).flat?.tutar || 0), 0);
  const toplamDiger = aylar.reduce((acc, a) => acc + (getOdeme(a.key).diger || []).reduce((s, d) => {
    const odenen = Number(d.odenenTutar) || 0;
    const kalan = Math.max(0, (d.tutar || 0) - odenen);
    return s + kalan;
  }, 0), 0);

  const aidatRenk = { odendi: "success", gecikti: "danger", bekleniyor: "warning", kismi: "warning" };
  const aidatLabel = { odendi: t.paid || "Ödendi", gecikti: t.late || "Gecikti", bekleniyor: t.pending || "Bekliyor", kismi: "Kısmi" };
  const [kismiModal, setKismiModal] = useState(false);

  const donemTutariHesapla = (ayKey) => {
    const [yStr, mStr] = ayKey.split("-");
    const y = parseInt(yStr), m = parseInt(mStr);
    const donem = getDönemTutari(data.aidatTarihleri, site.id, y, m);
    return donem > 0 ? donem : daire.aidatBedeli;
  };

  // BORÇ HESABI
  const gecikmisBorcAidat = aylar.filter(a => getOdeme(a.key).aidat?.durum === "gecikti")
    .reduce((s, a) => {
      const od = getOdeme(a.key).aidat;
      const odenen = Number(od?.odenenTutar) || 0;
      const donem = donemTutariHesapla(a.key);
      return s + Math.max(0, donem - odenen);
    }, 0);
  const bekleyenBorcAidat = aylar.filter(a => {
    const durum = getOdeme(a.key).aidat?.durum || "bekleniyor";
    return durum === "bekleniyor" || durum === "kismi";
  }).reduce((s, a) => {
    const od = getOdeme(a.key).aidat;
    const odenen = Number(od?.odenenTutar) || 0;
    const donem = donemTutariHesapla(a.key);
    return s + Math.max(0, donem - odenen);
  }, 0);
  const toplamBorcAidat = gecikmisBorcAidat + bekleyenBorcAidat;
  const toplamBorcTumu = toplamBorcAidat + toplamDiger; // flat genelde ayrı tutulur

  const kaydetAidat = () => {
    setOdeme(selectedAy, (prev) => ({ ...prev, aidat: { durum: form.durum, tarih: form.tarih || "" } }));
    setEklemeModal(null);
  };
  const kaydetFlat = () => {
    setOdeme(selectedAy, (prev) => ({ ...prev, flat: { tutar: Number(form.tutar) || 0, tarih: form.tarih || "" } }));
    setEklemeModal(null);
  };
  const kaydetDiger = () => {
    const yeniItem = {
      id: form.editId || Date.now(),
      aciklama: form.aciklama,
      tutar: Number(form.tutar) || 0,
      tarih: form.tarih || "",
      odenenTutar: Number(form.odenenTutar) || 0,
      durum: Number(form.odenenTutar) >= Number(form.tutar) ? "odendi" : Number(form.odenenTutar) > 0 ? "kismi" : "bekliyor",
    };
    if (form.editId) {
      setOdeme(selectedAy, (prev) => ({ ...prev, diger: (prev.diger || []).map(d => d.id === form.editId ? yeniItem : d) }));
    } else {
      setOdeme(selectedAy, (prev) => ({ ...prev, diger: [...(prev.diger || []), yeniItem] }));
    }
    setEklemeModal(null);
  };
  const silDiger = (ayKey, itemId) => {
    setOdeme(ayKey, (prev) => ({ ...prev, diger: (prev.diger || []).filter((d) => d.id !== itemId) }));
  };

  const dotRenk = { odendi: "#10b981", gecikti: "#ef4444", bekleniyor: "#f59e0b" };

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal-box modal-xwide">
        <div className="modal-header">
          <div>
            <h3>💳 Ödeme Detayı — {daire.blok} Blok, Daire {daire.daireNo}</h3>
            <div style={{ fontSize: 12, color: "#64748b", marginTop: 4, display: "flex", gap: 16, flexWrap: "wrap" }}>
              <span>👤 {daire.evSahibi || "—"}</span>
              {daire.kiraci && <span>🏠 {daire.kiraci}</span>}
              <span>💰 ₺{daire.aidatBedeli}/ay</span>
            </div>
          </div>
          <button className="icon-btn" onClick={onClose}><Icon name="close" /></button>
        </div>
        <div className="modal-body">
          {/* TOPLAM BORÇ BANNER */}
          {toplamBorcTumu > 0 && (
            <div style={{ background: "linear-gradient(135deg,#7f1d1d,#991b1b)", borderRadius: 12, padding: "14px 20px", marginBottom: 16, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ fontSize: 24 }}>⚠️</div>
                <div>
                  <div style={{ fontSize: 13, color: "#fca5a5", fontWeight: 600 }}>Toplam Ödenmemiş Borç</div>
                  <div style={{ fontSize: 28, fontWeight: 900, color: "white" }}>₺{toplamBorcTumu.toLocaleString()}</div>
                </div>
              </div>
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                {gecikmisBorcAidat > 0 && (
                  <div style={{ background: "rgba(0,0,0,0.3)", borderRadius: 10, padding: "8px 14px", textAlign: "center" }}>
                    <div style={{ fontSize: 10, color: "#fca5a5" }}>Gecikmiş Aidat ({toplamGecikti} ay)</div>
                    <div style={{ fontSize: 18, fontWeight: 800, color: "#fca5a5" }}>₺{gecikmisBorcAidat.toLocaleString()}</div>
                  </div>
                )}
                {bekleyenBorcAidat > 0 && (
                  <div style={{ background: "rgba(0,0,0,0.3)", borderRadius: 10, padding: "8px 14px", textAlign: "center" }}>
                    <div style={{ fontSize: 10, color: "#fde68a" }}>Bekleyen Aidat ({toplamBekliyor} ay)</div>
                    <div style={{ fontSize: 18, fontWeight: 800, color: "#fde68a" }}>₺{bekleyenBorcAidat.toLocaleString()}</div>
                  </div>
                )}
                {toplamDiger > 0 && (
                  <div style={{ background: "rgba(0,0,0,0.3)", borderRadius: 10, padding: "8px 14px", textAlign: "center" }}>
                    <div style={{ fontSize: 10, color: "#c4b5fd" }}>Diğer Ödemeler</div>
                    <div style={{ fontSize: 18, fontWeight: 800, color: "#c4b5fd" }}>₺{toplamDiger.toLocaleString()}</div>
                  </div>
                )}
              </div>
            </div>
          )}
          {toplamBorcTumu === 0 && (
            <div style={{ background: "linear-gradient(135deg,#064e3b,#065f46)", borderRadius: 12, padding: "12px 20px", marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ fontSize: 22 }}>✅</div>
              <div>
                <div style={{ fontSize: 13, color: "#6ee7b7", fontWeight: 600 }}>Borç Yok</div>
                <div style={{ fontSize: 13, color: "#a7f3d0" }}>Tüm aidatlar ödenmiş durumda.</div>
              </div>
            </div>
          )}

          {/* ÖZET KARTLAR */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: 8, marginBottom: 18 }}>
            {[
              { n: toplamOdendi, l: "Ay Ödendi", c: "#10b981", bg: "#d1fae5" },
              { n: toplamBekliyor, l: "Ay Bekliyor", c: "#f59e0b", bg: "#fef3c7" },
              { n: toplamGecikti, l: "Ay Gecikti", c: "#ef4444", bg: "#fee2e2" },
              { n: `₺${toplamFlat.toLocaleString()}`, l: "Toplam Flat", c: "#3b82f6", bg: "#dbeafe" },
              { n: `₺${toplamDiger.toLocaleString()}`, l: "Diğer Öd.", c: "#8b5cf6", bg: "#ede9fe" },
            ].map((s) => (
              <div key={s.l} style={{ background: s.bg, borderRadius: 10, padding: "10px 8px", textAlign: "center" }}>
                <div style={{ fontSize: 18, fontWeight: 800, color: s.c }}>{s.n}</div>
                <div style={{ fontSize: 10, color: "#64748b", marginTop: 2 }}>{s.l}</div>
              </div>
            ))}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "200px 1fr", gap: 18 }}>
            {/* Ay Listesi */}
            <div>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 8 }}>Aylar</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 3, maxHeight: 440, overflowY: "auto" }}>
                {aylar.map((a) => {
                  const od = getOdeme(a.key);
                  const durum = od.aidat?.durum || "bekleniyor";
                  return (
                    <button key={a.key} onClick={() => setSelectedAy(a.key)}
                      style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 11px", borderRadius: 8, border: "1px solid #e2e8f0", background: selectedAy === a.key ? "#0f172a" : "white", color: selectedAy === a.key ? "white" : "#475569", cursor: "pointer", fontSize: 12, fontWeight: 500 }}>
                      <span>{a.label}</span>
                      <span style={{ width: 8, height: 8, borderRadius: "50%", background: dotRenk[durum], flexShrink: 0 }} />
                    </button>
                  );
                })}
              </div>
            </div>
            {/* Sağ panel */}
            <div>
              <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 12 }}>{aylar.find((a) => a.key === selectedAy)?.label}</div>
              <div className="tab-row" style={{ marginBottom: 14 }}>
                <button className={`tab-btn ${tab === "aidat" ? "active" : ""}`} onClick={() => setTab("aidat")}>🏠 Aidat</button>
                <button className={`tab-btn ${tab === "flat" ? "active" : ""}`} onClick={() => setTab("flat")}>⚡ Flat</button>
                <button className={`tab-btn ${tab === "diger" ? "active" : ""}`} onClick={() => setTab("diger")}>📋 Diğer</button>
              </div>

              {tab === "aidat" && (
                <div>
                  <div style={{ background: "#f8fafc", borderRadius: 10, padding: 16, display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                    <div><div style={{ fontSize: 12, color: "#64748b" }}>Durum</div><Badge text={aidatLabel[seciliAy.aidat?.durum || "bekleniyor"]} type={aidatRenk[seciliAy.aidat?.durum || "bekleniyor"]} /></div>
                    <div><div style={{ fontSize: 12, color: "#64748b" }}>Ödeme Tarihi</div><strong>{seciliAy.aidat?.tarih || "—"}</strong></div>
                    <div><div style={{ fontSize: 12, color: "#64748b" }}>Tutar</div><strong style={{ fontSize: 20 }}>₺{donemTutariHesapla(selectedAy).toLocaleString()}</strong></div>
                    <button className="btn-primary" style={{ fontSize: 12 }} onClick={() => { setForm({ durum: seciliAy.aidat?.durum || "bekleniyor", tarih: seciliAy.aidat?.tarih || "" }); setEklemeModal("aidat"); }}>
                      <Icon name="edit" size={13} /> Güncelle
                    </button>
                    <button className="btn-primary" style={{ fontSize: 12, background: "linear-gradient(135deg,#10b981,#059669)", marginLeft: 8 }}
                      onClick={() => setKismiModal(true)}>
                          💳 Kısmi Öde
                    </button>
                  </div>
                  <div className="table-card">
                    <table className="data-table">
                      <thead><tr><th>Ay</th><th>Durum</th><th>Tarih</th><th>Tutar</th></tr></thead>
                      <tbody>
                        {aylar.map((a) => {
                          const od = getOdeme(a.key);
                          const durum = od.aidat?.durum || "bekleniyor";
                          return (
                            <tr key={a.key} style={{ cursor: "pointer" }} onClick={() => setSelectedAy(a.key)}>
                              <td><strong>{a.label}</strong></td>
                              <td><Badge text={aidatLabel[durum]} type={aidatRenk[durum]} /></td>
                              <td>{od.aidat?.tarih || "—"}</td>
                              <td>₺{donemTutariHesapla(a.key).toLocaleString()}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {tab === "flat" && (
                <div>
                  <div style={{ background: "#f8fafc", borderRadius: 10, padding: 16, display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                    <div><div style={{ fontSize: 12, color: "#64748b" }}>Flat Tutarı</div><div style={{ fontSize: 24, fontWeight: 800, color: seciliAy.flat?.tutar > 0 ? "#3b82f6" : "#94a3b8" }}>₺{(seciliAy.flat?.tutar || 0).toLocaleString()}</div></div>
                    <div><div style={{ fontSize: 12, color: "#64748b" }}>Tarih</div><strong>{seciliAy.flat?.tarih || "—"}</strong></div>
                    <button className="btn-primary" style={{ fontSize: 12 }} onClick={() => { setForm({ tutar: seciliAy.flat?.tutar || "", tarih: seciliAy.flat?.tarih || "" }); setEklemeModal("flat"); }}>
                      <Icon name="edit" size={13} /> Güncelle
                    </button>
                  </div>
                  <div className="table-card">
                    <table className="data-table">
                      <thead><tr><th>Ay</th><th>Tutar</th><th>Tarih</th></tr></thead>
                      <tbody>
                        {aylar.map((a) => {
                          const od = getOdeme(a.key);
                          return (
                            <tr key={a.key}><td><strong>{a.label}</strong></td>
                              <td style={{ color: od.flat?.tutar > 0 ? "#3b82f6" : "#94a3b8", fontWeight: 700 }}>{od.flat?.tutar > 0 ? `₺${od.flat.tutar.toLocaleString()}` : "—"}</td>
                              <td>{od.flat?.tarih || "—"}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {tab === "diger" && (
                <div>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                    <span style={{ fontSize: 13, color: "#64748b" }}>{aylar.find((a) => a.key === selectedAy)?.label} — Diğer Ödemeler</span>
                    <button className="btn-primary" style={{ fontSize: 12 }} onClick={() => { setForm({ aciklama: "", tutar: "", tarih: new Date().toISOString().split("T")[0], odenenTutar: "", editId: null }); setEklemeModal("diger"); }}>
                      <Icon name="plus" size={13} /> Ekle
                    </button>
                  </div>
                  {(seciliAy.diger || []).length === 0 ? <div className="empty-state">Bu ay için kayıt yok.</div> : (
                    <div className="table-card">
                      <table className="data-table">
                        <thead><tr><th>Açıklama</th><th>Borç</th><th>Ödenen</th><th>Kalan</th><th>Tarih</th><th>Durum</th><th>İşlem</th></tr></thead>
                        <tbody>
                          {(seciliAy.diger || []).map((d) => {
                            const odenen = Number(d.odenenTutar) || 0;
                            const kalan = Math.max(0, d.tutar - odenen);
                            const durumCfg = d.durum === "odendi"
                              ? { l: "Ödendi", bg: "#d1fae5", c: "#065f46" }
                              : d.durum === "kismi"
                              ? { l: "Kısmi", bg: "#fef3c7", c: "#92400e" }
                              : { l: "Bekliyor", bg: "#fee2e2", c: "#991b1b" };
                            return (
                              <tr key={d.id}>
                                <td>{d.aciklama}</td>
                                <td><strong style={{ color: "#8b5cf6" }}>₺{d.tutar.toLocaleString()}</strong></td>
                                <td style={{ color: "#10b981", fontWeight: 600 }}>₺{odenen.toLocaleString()}</td>
                                <td style={{ color: kalan > 0 ? "#ef4444" : "#10b981", fontWeight: 600 }}>₺{kalan.toLocaleString()}</td>
                                <td>{d.tarih}</td>
                                <td><span style={{ background: durumCfg.bg, color: durumCfg.c, padding: "2px 8px", borderRadius: 20, fontSize: 11, fontWeight: 600 }}>{durumCfg.l}</span></td>
                                <td>
                                  <div style={{ display: "flex", gap: 4 }}>
                                    <button className="icon-btn" onClick={() => { setForm({ aciklama: d.aciklama, tutar: d.tutar, tarih: d.tarih, odenenTutar: d.odenenTutar || 0, editId: d.id }); setEklemeModal("diger"); }}><Icon name="edit" size={14} /></button>
                                    <button className="icon-btn danger" onClick={() => silDiger(selectedAy, d.id)}><Icon name="trash" size={14} /></button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {eklemeModal === "aidat" && (
        <Modal title="Aidat Durumu Güncelle" onClose={() => setEklemeModal(null)}>
          <div className="form-grid">
            <Field label="Durum" type="select" value={form.durum} onChange={(v) => setForm((p) => ({ ...p, durum: v }))} options={[{ value: "odendi", label: "Ödendi" }, { value: "gecikti", label: "Gecikti" }, { value: "bekleniyor", label: "Bekleniyor" }]} />
            <Field label="Ödeme Tarihi" type="date" value={form.tarih} onChange={(v) => setForm((p) => ({ ...p, tarih: v }))} />
          </div>
          <div className="modal-footer"><button className="btn-secondary" onClick={() => setEklemeModal(null)}>İptal</button><button className="btn-primary" onClick={kaydetAidat}>Kaydet</button></div>
        </Modal>
      )}
      {eklemeModal === "flat" && (
        <Modal title="Flat Ödemesi Güncelle" onClose={() => setEklemeModal(null)}>
          <div className="form-grid">
            <Field label="Tutar (₺)" type="number" value={form.tutar} onChange={(v) => setForm((p) => ({ ...p, tutar: v }))} />
            <Field label="Ödeme Tarihi" type="date" value={form.tarih} onChange={(v) => setForm((p) => ({ ...p, tarih: v }))} />
          </div>
          <div className="modal-footer"><button className="btn-secondary" onClick={() => setEklemeModal(null)}>İptal</button><button className="btn-primary" onClick={kaydetFlat}>Kaydet</button></div>
        </Modal>
      )}
      {eklemeModal === "diger" && (
        <Modal title={form.editId ? "Diğer Ödeme Güncelle" : "Diğer Ödeme Ekle"} onClose={() => setEklemeModal(null)}>
          <div style={{ fontSize: 12, color: "#64748b", marginBottom: 12, background: "#fef3c7", borderRadius: 8, padding: "8px 12px" }}>
            💡 Buraya eklenen kayıtlar sakini borçlandırır. Ödeme alındığında "Ödenen Tutar" alanını güncelleyin.
          </div>
          <div className="form-grid">
            <Field label="Açıklama" value={form.aciklama} onChange={(v) => setForm((p) => ({ ...p, aciklama: v }))} required />
            <Field label="Borç Tutarı (₺)" type="number" value={form.tutar} onChange={(v) => setForm((p) => ({ ...p, tutar: v }))} required />
            <Field label="Ödenen Tutar (₺)" type="number" value={form.odenenTutar} onChange={(v) => setForm((p) => ({ ...p, odenenTutar: v }))} />
            <Field label="Tarih" type="date" value={form.tarih} onChange={(v) => setForm((p) => ({ ...p, tarih: v }))} />
          </div>
          {form.tutar && (
            <div style={{ background: "#f8fafc", borderRadius: 8, padding: "10px 14px", marginTop: 8, fontSize: 13 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                <span style={{ color: "#64748b" }}>Borç</span>
                <span style={{ fontWeight: 700, color: "#8b5cf6" }}>₺{Number(form.tutar || 0).toLocaleString()}</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                <span style={{ color: "#64748b" }}>Ödenen</span>
                <span style={{ fontWeight: 700, color: "#10b981" }}>₺{Number(form.odenenTutar || 0).toLocaleString()}</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", borderTop: "1px solid #e2e8f0", paddingTop: 6, marginTop: 4 }}>
                <span style={{ fontWeight: 700 }}>Kalan</span>
                <span style={{ fontWeight: 800, color: Math.max(0, Number(form.tutar) - Number(form.odenenTutar || 0)) > 0 ? "#ef4444" : "#10b981" }}>
                  ₺{Math.max(0, Number(form.tutar || 0) - Number(form.odenenTutar || 0)).toLocaleString()}
                </span>
              </div>
            </div>
          )}
          <div className="modal-footer">
            <button className="btn-secondary" onClick={() => setEklemeModal(null)}>İptal</button>
            <button className="btn-primary" onClick={kaydetDiger}>{form.editId ? "Güncelle" : "Ekle"}</button>
          </div>
        </Modal>
      )}
           {kismiModal && (
        <KismiOdemeModal
          ayLabel={aylar.find(a => a.key === selectedAy)?.label || selectedAy}
          donemTutari={donemTutariHesapla(selectedAy)}
          mevcutAidat={seciliAy.aidat}
          onClose={() => setKismiModal(false)}
          onSave={(vals) => {
            setOdeme(selectedAy, (prev) => ({ ...prev, aidat: vals }));
            setKismiModal(false);
          }}
        />
      )}
    </div>
  );
}

// ── Aidat Tarih Geçmişi ────────────────────────────────────────
function AidatTarihGecmisi({ siteId, data, setData }) {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ baslangicTarihi: "", bitisTarihi: "", tutar: "", aciklama: "" });

  const liste = (data.aidatTarihleri || [])
    .filter(a => String(a.siteId) === String(siteId))
    .sort((a, b) => new Date(b.baslangicTarihi) - new Date(a.baslangicTarihi));

  const ekle = (e) => {
    e.preventDefault();
    if (!form.baslangicTarihi || !form.tutar) return;
    let guncelListe = [...(data.aidatTarihleri || [])];
    if (!form.bitisTarihi) {
      guncelListe = guncelListe.map(a => {
        if (String(a.siteId) === String(siteId) && !a.bitisTarihi) {
          const yeniBitis = new Date(form.baslangicTarihi);
          yeniBitis.setDate(yeniBitis.getDate() - 1);
          return { ...a, bitisTarihi: yeniBitis.toISOString().split("T")[0] };
        }
        return a;
      });
    }
    const yeni = { id: Date.now(), siteId, baslangicTarihi: form.baslangicTarihi, bitisTarihi: form.bitisTarihi || null, tutar: Number(form.tutar), aciklama: form.aciklama };
    setData(d => ({ ...d, aidatTarihleri: [...guncelListe, yeni] }));
    setForm({ baslangicTarihi: "", bitisTarihi: "", tutar: "", aciklama: "" });
    setShowForm(false);
  };

  const sil = (id) => {
    if (!window.confirm("Bu dönemi silmek istediğinize emin misiniz?")) return;
    setData(d => ({ ...d, aidatTarihleri: (d.aidatTarihleri || []).filter(a => a.id !== id) }));
  };

  return (
    <div style={{ marginTop: 22, borderTop: "1px solid #f1f5f9", paddingTop: 16 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
        <div style={{ fontWeight: 700, fontSize: 14 }}>📅 Aidat Dönem Geçmişi</div>
        <button onClick={() => setShowForm(!showForm)} className="btn-secondary" style={{ fontSize: 12, padding: "5px 12px" }}>+ Yeni Dönem</button>
      </div>
      {showForm && (
        <div style={{ background: "#f8fafc", borderRadius: 10, padding: 14, border: "1px solid #e2e8f0", marginBottom: 10 }}>
          <form onSubmit={ekle}>
            <div className="form-grid">
              <div className="field"><label>Başlangıç Tarihi *</label><input type="date" value={form.baslangicTarihi} onChange={e => setForm(p => ({ ...p, baslangicTarihi: e.target.value }))} required /></div>
              <div className="field"><label>Bitiş Tarihi (boş = aktif)</label><input type="date" value={form.bitisTarihi} onChange={e => setForm(p => ({ ...p, bitisTarihi: e.target.value }))} /></div>
              <div className="field"><label>Aidat Tutarı (₺) *</label><input type="number" placeholder="1800" value={form.tutar} onChange={e => setForm(p => ({ ...p, tutar: e.target.value }))} required /></div>
              <div className="field"><label>Açıklama</label><input type="text" placeholder="opsiyonel" value={form.aciklama} onChange={e => setForm(p => ({ ...p, aciklama: e.target.value }))} /></div>
            </div>
            <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
              <button type="submit" className="btn-primary" style={{ fontSize: 12, padding: "7px 14px" }}>Kaydet</button>
              <button type="button" className="btn-secondary" style={{ fontSize: 12, padding: "7px 14px" }} onClick={() => setShowForm(false)}>İptal</button>
            </div>
          </form>
        </div>
      )}
      {liste.length === 0
        ? <p style={{ color: "#94a3b8", fontSize: 13 }}>Henüz dönem tanımlanmamış.</p>
        : liste.map(item => (
          <div key={item.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: !item.bitisTarihi ? "#f0fdf4" : "#f8fafc", border: `1px solid ${!item.bitisTarihi ? "#86efac" : "#e2e8f0"}`, borderRadius: 9, padding: "9px 13px", marginBottom: 6, flexWrap: "wrap", gap: 8 }}>
            <div>
              <div style={{ fontWeight: 700, fontSize: 15 }}>₺{Number(item.tutar).toLocaleString()}</div>
              <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>{item.baslangicTarihi} → {item.bitisTarihi || "∞ (aktif)"}</div>
              {item.aciklama && <div style={{ fontSize: 11, color: "#94a3b8" }}>{item.aciklama}</div>}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              {!item.bitisTarihi && <span style={{ background: "#d1fae5", color: "#065f46", fontSize: 11, fontWeight: 600, padding: "2px 8px", borderRadius: 20 }}>Aktif</span>}
              <button className="icon-btn danger" onClick={() => sil(item.id)}><Icon name="trash" size={14} /></button>
            </div>
          </div>
        ))
      }
    </div>
  );
}

// ── Kısmi Ödeme Modalı ─────────────────────────────────────────
function KismiOdemeModal({ ayLabel, donemTutari, mevcutAidat, onClose, onSave }) {
  const [odenen, setOdenen] = useState(mevcutAidat?.odenenTutar || (mevcutAidat?.durum === "odendi" ? donemTutari : 0));
  const [notlar, setNotlar] = useState(mevcutAidat?.notlar || "");
  const eksik = Math.max(0, (donemTutari || 0) - Number(odenen));
  const durum = eksik === 0 ? "odendi" : Number(odenen) > 0 ? "kismi" : "bekleniyor";
  const dRenk = eksik === 0 ? "#10b981" : Number(odenen) > 0 ? "#f59e0b" : "#ef4444";
  const dLabel = eksik === 0 ? "Tam Ödendi" : Number(odenen) > 0 ? "Kısmi Ödeme" : "Ödenmedi";
  const kaydet = () => {
    onSave({ durum, tarih: Number(odenen) > 0 ? new Date().toISOString().split("T")[0] : (mevcutAidat?.tarih || ""), odenenTutar: Number(odenen), eksikTutar: eksik, notlar });
    onClose();
  };
  return (
    <Modal title={`Ödeme Kaydet — ${ayLabel}`} onClose={onClose}>
      <div style={{ fontSize: 13, color: "#64748b", marginBottom: 14 }}>Dönem tutarı: <strong style={{ color: "#0f172a", fontSize: 16 }}>₺{(donemTutari || 0).toLocaleString()}</strong></div>
      <div className="field" style={{ marginBottom: 14 }}>
        <label>Ödenen Tutar (₺)</label>
        <input type="number" value={odenen} min={0} onChange={e => setOdenen(e.target.value)} autoFocus style={{ fontSize: 18, fontWeight: 700, padding: "12px 14px" }} />
      </div>
      <div style={{ background: "#f8fafc", borderRadius: 10, padding: 14, marginBottom: 14 }}>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "3px 0" }}><span style={{ color: "#64748b" }}>Dönem Tutarı</span><span>₺{(donemTutari || 0).toLocaleString()}</span></div>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "3px 0" }}><span style={{ color: "#64748b" }}>Ödenen</span><span style={{ color: "#10b981", fontWeight: 700 }}>₺{Number(odenen).toLocaleString()}</span></div>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 15, fontWeight: 800, borderTop: "1px solid #e2e8f0", paddingTop: 8, marginTop: 6 }}><span>Kalan Borç</span><span style={{ color: dRenk }}>₺{eksik.toLocaleString()}</span></div>
        <div style={{ textAlign: "right", marginTop: 8 }}><span style={{ background: `${dRenk}20`, color: dRenk, padding: "3px 12px", borderRadius: 20, fontSize: 12, fontWeight: 700 }}>{dLabel}</span></div>
      </div>
      <div className="field" style={{ marginBottom: 14 }}><label>Not (opsiyonel)</label><textarea value={notlar} onChange={e => setNotlar(e.target.value)} rows={2} placeholder="Ödeme notu..." /></div>
      <div className="modal-footer"><button className="btn-secondary" onClick={onClose}>İptal</button><button className="btn-primary" onClick={kaydet}>✓ Kaydet</button></div>
    </Modal>
  );
}
// ============================================================

// EVRENSEL RAPOR MODAL
function EvrenselRaporModal({ tip, data, onClose }) {
  const buYil = new Date().getFullYear();
  const [baslangic, setBaslangic] = useState(`${buYil}-01-01`);
  const [bitis, setBitis] = useState(new Date().toISOString().split("T")[0]);

  const indir = () => {
    const rows = [];
    rows.push(["Rapor: " + tip, "Tarih: " + baslangic + " - " + bitis]);
    rows.push([]);
    const tf = (t) => (!t || (t >= baslangic && t <= bitis));

    if (tip === "personel") {
      rows.push(["Ad","Iletisim","Tip","Maas/GunlukUcret","Durum"]);
      (data.personel||[]).forEach(p => rows.push([p.ad, p.iletisim||"", p.tip, p.tip==="kadrolu"?p.maas:p.gunlukUcret, p.durum]));
      rows.push([]);
      rows.push(["AVANSLAR","Personel","Tarih","Tutar","Aciklama"]);
      (data.personelDetay||[]).filter(d=>d.tip==="avans"&&tf(d.tarih)).forEach(d=>{
        const p=(data.personel||[]).find(x=>x.id===d.personelId);
        rows.push([p?.ad||"-",d.tarih,d.tutar,d.aciklama||""]);
      });
      rows.push([]);
      rows.push(["DEVAM","Personel","Tarih","Durum"]);
      (data.personelDetay||[]).filter(d=>d.tip==="devam"&&tf(d.tarih)).forEach(d=>{
        const p=(data.personel||[]).find(x=>x.id===d.personelId);
        rows.push([p?.ad||"-",d.tarih,d.durum==="geldi"?"Geldi":"Gelmedi"]);
      });
    } else if (tip === "isler") {
      rows.push(["Tarih","Musteri","Tel","Is","Adres","Bedel","OdemeTuru","Durum"]);
      (data.isler||[]).filter(i=>tf(i.tarih)).sort((a,b)=>new Date(b.tarih)-new Date(a.tarih))
        .forEach(i=>rows.push([i.tarih,i.musteriIsmi,i.musteriTel,i.isBilgisi,i.adres,i.bedel,i.odemeTuru,i.odemeDurum]));
      const tot=(data.isler||[]).filter(i=>tf(i.tarih)).reduce((s,i)=>s+i.bedel,0);
      const od=(data.isler||[]).filter(i=>tf(i.tarih)&&i.odemeDurum==="odendi").reduce((s,i)=>s+i.bedel,0);
      rows.push(["TOPLAM",tot],["ODENDI",od],["BEKLIYOR",tot-od]);
    } else if (tip === "gelirGider") {
      rows.push(["=== GELIRLER ==="]);
      rows.push(["Tarih","Tutar","Aciklama","Kaynak"]);
      (data.gelir||[]).filter(g=>tf(g.tarih)).sort((a,b)=>new Date(b.tarih)-new Date(a.tarih))
        .forEach(g=>rows.push([g.tarih,g.tutar,g.aciklama,g.kaynak||"manuel"]));
      const tg=(data.gelir||[]).filter(g=>tf(g.tarih)).reduce((s,g)=>s+g.tutar,0);
      rows.push(["TOPLAM GELIR",tg],[]);
      rows.push(["=== GIDERLER ==="]);
      rows.push(["Tarih","Tutar","Aciklama","Kaynak"]);
      (data.gider||[]).filter(g=>tf(g.tarih)).sort((a,b)=>new Date(b.tarih)-new Date(a.tarih))
        .forEach(g=>rows.push([g.tarih,g.tutar,g.aciklama,g.kaynak||"manuel"]));
      const td=(data.gider||[]).filter(g=>tf(g.tarih)).reduce((s,g)=>s+g.tutar,0);
      rows.push(["TOPLAM GIDER",td],[],["NET BAKIYE",tg-td]);
    } else if (tip === "siteGiderleri") {
      rows.push(["Site","Tarih","Kategori","Aciklama","Tutar","Dosya"]);
      (data.siteGiderleri||[]).filter(g=>tf(g.tarih)).sort((a,b)=>new Date(b.tarih)-new Date(a.tarih))
        .forEach(g=>{
          const s=(data.siteler||[]).find(x=>x.id===g.siteId);
          rows.push([s?.siteIsmi||"-",g.tarih,g.kategori,g.aciklama,g.tutar,g.dosyaAdi||""]);
        });
      rows.push(["TOPLAM",(data.siteGiderleri||[]).filter(g=>tf(g.tarih)).reduce((s,g)=>s+g.tutar,0)]);
    } else if (tip === "duzenlMusteriler") {
      rows.push(["Ad","Tel","Adres","Is Bedeli","Tahsilat","Kalan"]);
      (data.duzenlMusteriler||[]).forEach(m=>{
        const isl=(data.musteriIslemleri||[]).filter(x=>x.musteriId===m.id);
        const tb=isl.filter(x=>x.tip==="is").reduce((s,x)=>s+x.ucret,0);
        const to=isl.filter(x=>x.tip==="odeme").reduce((s,x)=>s+x.tutar,0);
        rows.push([m.ad,m.tel,m.adres,tb,to,tb-to]);
      });
      rows.push([],["=== ISLEMLER ==="]);
      rows.push(["Musteri","Tarih","Tip","Tutar","Aciklama"]);
      (data.musteriIslemleri||[]).filter(x=>tf(x.tarih)).forEach(x=>{
        const m=(data.duzenlMusteriler||[]).find(m=>m.id===x.musteriId);
        rows.push([m?.ad||"-",x.tarih,x.tip==="is"?"Is":"Odeme",x.tip==="is"?x.ucret:x.tutar,x.aciklama||""]);
      });
    } else if (tip === "arizalar") {
      rows.push(["Tarih","Site","Konum","Bildiren","Aciklama","Durum","Admin Notu"]);
      (data.arizalar||[]).filter(a=>tf(a.tarih)).sort((a,b)=>new Date(b.tarih)-new Date(a.tarih))
        .forEach(a=>{
          const s=(data.siteler||[]).find(x=>x.id===a.siteId);
          rows.push([a.tarih,s?.siteIsmi||"-",a.konum||"-",a.bildiren||"-",a.aciklama,a.durum,a.adminNot||""]);
        });
    } else if (tip === "yapilacaklar") {
      rows.push(["Tarih","Baslik","Aciklama","Durum"]);
      (data.yapilacaklar||[]).filter(y=>tf(y.tarih))
        .forEach(y=>rows.push([y.tarih,y.baslik,y.aciklama||"",y.durum==="tamamlandi"?"Tamamlandi":"Bekliyor"]));
    }

    const csv = rows.map(r=>r.map(c=>`"${String(c??"").replace(/"/g,'""')}"`).join(",")).join("\n");
    const blob = new Blob(["\uFEFF"+csv],{type:"text/csv;charset=utf-8;"});
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href=url; a.download=`rapor_${tip}_${baslangic}_${bitis}.csv`; a.click();
    URL.revokeObjectURL(url);
    onClose();
  };

  return (
    <Modal title="Rapor Al" onClose={onClose}>
      <p style={{fontSize:13,color:"#64748b",marginBottom:16}}>Secilen tarih araligindaki kayitlar CSV olarak indirilir.</p>
      <div className="form-grid">
        <div className="field"><label>Baslangic Tarihi</label><input type="date" value={baslangic} onChange={e=>setBaslangic(e.target.value)}/></div>
        <div className="field"><label>Bitis Tarihi</label><input type="date" value={bitis} onChange={e=>setBitis(e.target.value)}/></div>
      </div>
      <div className="modal-footer">
        <button className="btn-secondary" onClick={onClose}>Iptal</button>
        <button className="btn-primary" onClick={indir}>CSV Indir</button>
      </div>
    </Modal>
  );
}

// EXCEL RAPOR — Site bazlı, tarih aralıklı
// ============================================================
function SiteExcelModal({ site, data, onClose }) {
  const buYil = new Date().getFullYear();
  const buAy = new Date().getMonth() + 1;
  const [baslangic, setBaslangic] = useState(`${buYil}-01-01`);
  const [bitis, setBitis] = useState(new Date().toISOString().split("T")[0]);

  const indir = () => {
    const rows = [];
    const siteBilgi = data.siteler.find((s) => s.id === site.id) || site;
    rows.push([`RAPOR: ${site.siteIsmi}`]);
    rows.push([`Tarih Aralığı: ${baslangic} — ${bitis}`]);
    rows.push([`Oluşturulma: ${new Date().toLocaleString("tr-TR")}`]);
    rows.push([]);

    // Daireler
    rows.push(["=== DAİRELER ==="]);
    rows.push(["Blok", "Daire No", "Ev Sahibi", "Ev Sahibi Tel", "Kiracı", "Kiracı Tel", "Araç Plaka", "Durum", "Aidat"]);
    data.siteDetay.filter((d) => d.siteId === site.id).sort((a, b) => a.blok.localeCompare(b.blok) || a.daireNo - b.daireNo).forEach((d) => {
      rows.push([d.blok, d.daireNo, d.evSahibi, d.evSahibiTel, d.kiraci || "", d.kiraciTel || "", d.aracPlaka || "", d.evDurum, d.aidatBedeli]);
    });
    rows.push([]);

    // Aidat ödemeleri — tarih aralığına göre filtrele
    rows.push(["=== AİDAT ÖDEMELERİ ==="]);
    rows.push(["Blok", "Daire", "Ev Sahibi", "Ay", "Aidat Durum", "Aidat Tarihi", "Flat Tutarı", "Flat Tarihi", "Diğer Toplam"]);
    const tumAylar = [];
    const bas = new Date(baslangic);
    const bit = new Date(bitis);
    let d2 = new Date(bas.getFullYear(), bas.getMonth(), 1);
    while (d2 <= bit) {
      tumAylar.push(`${d2.getFullYear()}-${String(d2.getMonth() + 1).padStart(2, "0")}`);
      d2.setMonth(d2.getMonth() + 1);
    }
    data.siteDetay.filter((d) => d.siteId === site.id).forEach((daire) => {
      tumAylar.forEach((ayKey) => {
        const od = data.daireOdemeler?.[`${daire.id}_${ayKey}`] || {};
        const digerToplam = (od.diger || []).reduce((s, x) => s + x.tutar, 0);
        rows.push([daire.blok, daire.daireNo, daire.evSahibi, ayKey, od.aidat?.durum || "—", od.aidat?.tarih || "—", od.flat?.tutar || 0, od.flat?.tarih || "—", digerToplam]);
      });
    });
    rows.push([]);

    // Site Giderleri — tarih aralığına göre filtrele
    rows.push(["=== SİTE GİDERLERİ ==="]);
    rows.push(["Tarih", "Kategori", "Açıklama", "Tutar", "Dosya"]);
    (data.siteGiderleri || []).filter((g) => g.siteId === site.id && g.tarih >= baslangic && g.tarih <= bitis).forEach((g) => {
      rows.push([g.tarih, g.kategori, g.aciklama, g.tutar, g.dosyaAdi || ""]);
    });
    rows.push([]);

    // Duyurular
    rows.push(["=== DUYURULAR ==="]);
    rows.push(["Tarih", "Başlık", "İçerik"]);
    data.duyurular.filter((d) => (d.siteId === 0 || d.siteId === site.id) && d.tarih >= baslangic && d.tarih <= bitis).forEach((d) => {
      rows.push([d.tarih, d.baslik, d.icerik]);
    });

    const csv = rows.map((r) => r.map((c) => `"${String(c ?? "").replace(/"/g, '""')}"`).join(",")).join("\n");
    const BOM = "\uFEFF";
    const blob = new Blob([BOM + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${site.siteIsmi.replace(/\s/g, "_")}_Rapor_${baslangic}_${bitis}.csv`;
    a.click();
    URL.revokeObjectURL(url);
    onClose();
  };

  return (
    <Modal title={`📊 Rapor Al — ${site.siteIsmi}`} onClose={onClose}>
      <p style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
        Seçtiğiniz tarih aralığına ait daireler, aidat ödemeleri, site giderleri ve duyurular Excel (CSV) olarak indirilir.
      </p>
      <div className="form-grid">
        <div className="field">
          <label>Başlangıç Tarihi</label>
          <input type="date" value={baslangic} onChange={(e) => setBaslangic(e.target.value)} />
        </div>
        <div className="field">
          <label>Bitiş Tarihi</label>
          <input type="date" value={bitis} onChange={(e) => setBitis(e.target.value)} />
        </div>
      </div>
      <div style={{ marginTop: 14, background: "#f8fafc", borderRadius: 8, padding: "10px 14px", fontSize: 12, color: "#475569" }}>
        Rapor içeriği: <strong>Daire listesi, Aidat/Flat/Diğer ödemeler, Site giderleri, Duyurular</strong>
      </div>
      <div className="modal-footer">
        <button className="btn-secondary" onClick={onClose}>İptal</button>
        <button className="btn-primary" onClick={indir}>📥 CSV İndir</button>
      </div>
    </Modal>
  );
}

// Geriye dönük uyumluluk için global rapor fonksiyonu (dashboard'da kullanılabilir)
function excelIndir(data) {
  const rows = [["=== TAM SİSTEM RAPORU ==="], []];
  rows.push(["Site", "Yönetici", "Adres", "Aidat", "Bloklar"]);
  data.siteler.forEach((s) => rows.push([s.siteIsmi, s.yonetici, s.adres, s.aidatBedeli, s.bloklar.join(", ")]));
  const csv = rows.map((r) => r.map((c) => `"${String(c ?? "").replace(/"/g, '""')}"`).join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = `SiteYonet_Rapor_${new Date().toISOString().split("T")[0]}.csv`;
  a.click(); URL.revokeObjectURL(url);
}

// ============================================================
// SITE DETAY (Blok bazlı kart görünümü — güncellenmiş)
// ============================================================
function SiteDetay({ site, data, setData, onBack, t, readOnly }) {
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [filterBlok, setFilterBlok] = useState("hepsi");
  const [bulkModal, setBulkModal] = useState(false);
  const [bulkForm, setBulkForm] = useState({ blok: "", baslangic: 1, bitis: 10 });
  const [gorunum, setGorunum] = useState("kart");
  const [aidatDetayDaire, setAidatDetayDaire] = useState(null);
  const [raporModal, setRaporModal] = useState(false);
  const [tarihGecmisiAcik, setTarihGecmisiAcik] = useState(false);
  const [mesajlarAcik, setMesajlarAcik] = useState(false);
  const [siteMesajlar, setSiteMesajlar] = useState([]);
  const [adminYanit, setAdminYanit] = useState("");
  const adminMesajSonRef = useRef(null);
  const adminFileRef = useRef(null);

  // Mesajları DOĞRUDAN Supabase'den çek (Realtime PATCH'i yakalamayabiliyor)
  const chatKey = `siteMesajlar_${site.id}`;

  const mesajlariYukle = async () => {
    try {
      const { data: row } = await supabase
        .from('app_data').select('veri').eq('id', 1).single();
      const mesajlar = row?.veri?.[chatKey];
      setSiteMesajlar(Array.isArray(mesajlar) ? mesajlar : []);
    } catch(e) {
      console.error('Mesaj yükle hatası:', e);
    }
  };

  // Modal açıkken 4 saniyede bir otomatik yenile
  useEffect(() => {
    if (!mesajlarAcik) return;
    mesajlariYukle();
    const timer = setInterval(mesajlariYukle, 4000);
    return () => clearInterval(timer);
  }, [mesajlarAcik, site.id]); // eslint-disable-line react-hooks/exhaustive-deps

  // Admin resim sıkıştır
  const adminResimSikistir = (file) => new Promise((resolve) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      const MAX = 1200;
      let w=img.width, h=img.height;
      if(w>MAX||h>MAX){if(w>h){h=Math.round(h*MAX/w);w=MAX;}else{w=Math.round(w*MAX/h);h=MAX;}}
      const canvas=document.createElement("canvas"); canvas.width=w; canvas.height=h;
      canvas.getContext("2d").drawImage(img,0,0,w,h);
      URL.revokeObjectURL(url);
      resolve(canvas.toDataURL("image/jpeg",0.85));
    };
    img.onerror=()=>{URL.revokeObjectURL(url);resolve(null);};
    img.src=url;
  });

  // Admin dosya gönder
  const adminDosyaGonder = async (e) => {
    const file = e.target.files?.[0]; if (!file) return;
    const tip = file.type.startsWith("image/") ? "resim" : file.type.startsWith("video/") ? "video" : "dosya";
    const MAX = 8 * 1024 * 1024;
    const chatKey = `siteMesajlar_${site.id}`;

    const mesajKaydet = async (dosyaData) => {
      const yeniMsg = {
        id: Date.now(), kId: 99, kAd: "Yönetim", kAv: "Y",
        tarih: new Date().toISOString(), mesaj: file.name, tip,
        dosyaAdi: file.name, dosyaBoyut: file.size, dosyaTur: file.type,
        dosyaData, buyukDosya: !dosyaData,
      };
      try {
        const { data: row } = await supabase.from('app_data').select('veri').eq('id', 1).single();
        const mevcutVeri = row?.veri || {};
        const yeniListe = [...(mevcutVeri[chatKey] || []), yeniMsg];
        await supabase.from('app_data').upsert({ id: 1, veri: { ...mevcutVeri, [chatKey]: yeniListe } });
        setSiteMesajlar(yeniListe);
      } catch(e) { console.error("Admin dosya hatası:", e); }
      setTimeout(() => adminMesajSonRef.current?.scrollIntoView({ behavior: "smooth" }), 100);
    };

    if (tip === "resim") {
      const s = await adminResimSikistir(file);
      await mesajKaydet(s);
    } else if (file.size <= MAX) {
      const reader = new FileReader();
      reader.onload = async (ev) => { await mesajKaydet(ev.target.result); };
      reader.readAsDataURL(file);
    } else {
      await mesajKaydet(null);
    }
    e.target.value = "";
  };

  // Admin yanıt gönder — Supabase'e direkt yaz (sakin paneli de görür)
  const adminYanitGonder = async () => {
    const tmz = adminYanit.trim(); if (!tmz) return;
    const yeniMsg = {
      id: Date.now(), kId: 99, kAd: "Yönetim", kAv: "Y",
      tarih: new Date().toISOString(), mesaj: tmz, tip: "metin",
    };
    try {
      const { data: row } = await supabase.from('app_data').select('veri').eq('id', 1).single();
      const mevcutVeri = row?.veri || {};
      const yeniListe = [...(mevcutVeri[chatKey] || []), yeniMsg];
      await supabase.from('app_data').upsert({ id: 1, veri: { ...mevcutVeri, [chatKey]: yeniListe } });
      setSiteMesajlar(yeniListe);
    } catch(e) { console.error("Admin yanıt hatası:", e); }
    setAdminYanit("");
    setTimeout(() => adminMesajSonRef.current?.scrollIntoView({ behavior: "smooth" }), 100);
  };

  const detaylar = data.siteDetay.filter((d) => d.siteId === site.id);
  const filtered = filterBlok === "hepsi" ? detaylar : detaylar.filter((d) => d.blok === filterBlok);
  const emptyForm = { siteId: site.id, blok: "", daireNo: "", evSahibi: "", evSahibiTel: "", kiraci: "", kiraciTel: "", aracPlaka: "", evDurum: "dolu", aidatBedeli: site.aidatBedeli };

  const save = () => {
    const item = { ...form, daireNo: Number(form.daireNo), aidatBedeli: Number(form.aidatBedeli), id: modal === "edit" ? form.id : Date.now() };
    if (modal === "add") {
      setData((d) => {
        // Daire eklenince otomatik sakin kullanıcısı oluştur
        const yeniSakin = item.evSahibiTel ? {
          id: Date.now() + 1,
          ad: item.evSahibi || `${site.siteIsmi} ${item.blok}${item.daireNo}`,
          tel: item.evSahibiTel.replace(/[\s\-\(\)]/g, ""),
          sifre: "1234",
          siteId: Number(site.id),
          daireId: Number(item.id),
          rol: "sakin",
          aktif: true,
          mesajEngel: false,
        } : null;
        return {
          ...d,
          siteDetay: [...d.siteDetay, item],
          sakinKullanicilari: yeniSakin
            ? [...(d.sakinKullanicilari || []), yeniSakin]
            : (d.sakinKullanicilari || []),
        };
      });
    } else {
      // Daire düzenlenince sakin kullanıcısını da güncelle
      setData((d) => {
        const yeniDetay = d.siteDetay.map((s) => s.id === item.id ? item : s);
        // Bu daireye bağlı sakin kullanıcısını bul ve güncelle
        const yeniSakinler = (d.sakinKullanicilari || []).map(u => {
          if (u.daireId === item.id) {
            return {
              ...u,
              ad: item.evSahibi || u.ad,
              tel: item.evSahibiTel ? item.evSahibiTel.replace(/[\s\-\(\)]/g, "") : u.tel,
              siteId: Number(site.id),
            };
          }
          return u;
        });
        return { ...d, siteDetay: yeniDetay, sakinKullanicilari: yeniSakinler };
      });
    }
    setModal(null);
  };

  const del = (id) => { if (window.confirm("Bu daireyi silmek istediğinize emin misiniz?")) setData((d) => ({ ...d, siteDetay: d.siteDetay.filter((s) => s.id !== id) })); };
  const bulkAdd = () => {
    const items = [];
    for (let i = Number(bulkForm.baslangic); i <= Number(bulkForm.bitis); i++) {
      if (!detaylar.find((d) => d.blok === bulkForm.blok && d.daireNo === i))
        items.push({ ...emptyForm, blok: bulkForm.blok, daireNo: i, id: Date.now() + i });
    }
    setData((d) => ({ ...d, siteDetay: [...d.siteDetay, ...items] }));
    setBulkModal(false);
  };
  const f = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  // Bu ay aidat durumu
  const buAy = new Date().toISOString().slice(0, 7);
  const getAidatDurum = (daireId) => data.daireOdemeler?.[`${daireId}_${buAy}`]?.aidat?.durum || "bekleniyor";

  // Renkli istatistikler
  const odendiSay = detaylar.filter((d) => getAidatDurum(d.id) === "odendi").length;
  const geciktiSay = detaylar.filter((d) => getAidatDurum(d.id) === "gecikti").length;
  const bekliSay = detaylar.filter((d) => getAidatDurum(d.id) === "bekleniyor").length;

  const durumRenk = { odendi: "success", gecikti: "danger", bekleniyor: "warning", kismi: "warning" };
  const durumLabel = { odendi: t.paid || "Ödendi", gecikti: t.late || "Gecikti", bekleniyor: t.pending || "Bekliyor", kismi: "Kısmi" };
  const kartRenk = { odendi: "#10b981", gecikti: "#ef4444", bekleniyor: "#f59e0b" };

  const blokGruplari = {};
  (filterBlok === "hepsi" ? site.bloklar : [filterBlok]).forEach((b) => {
    blokGruplari[b] = filtered.filter((d) => d.blok === b).sort((a, c) => a.daireNo - c.daireNo);
  });

  return (
    <div className="page">
      <div className="page-header">
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <button className="btn-back" onClick={onBack}><Icon name="back" size={18} /></button>
          <div><h2>{site.siteIsmi}</h2><p style={{ color: "#64748b", fontSize: 14 }}>{site.adres}</p></div>
        </div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
          {/* Mesajlar — her zaman görünür */}
          <button
            onClick={() => { mesajlariYukle(); setMesajlarAcik(true); }}
            style={{ display: "flex", alignItems: "center", gap: 6, padding: "9px 16px", background: "#ede9fe", color: "#5b21b6", border: "2px solid #c4b5fd", borderRadius: 9, cursor: "pointer", fontSize: 13, fontWeight: 700 }}
          >
            💬 Mesajlar
          </button>
          {!readOnly && (
            <>
              <button
                onClick={() => setRaporModal(true)}
                style={{ display: "flex", alignItems: "center", gap: 6, padding: "9px 14px", background: "#d1fae5", color: "#065f46", border: "none", borderRadius: 9, cursor: "pointer", fontSize: 13, fontWeight: 700 }}
              >
                📊 Rapor Al

                  <button
                onClick={() => setTarihGecmisiAcik(true)}
                style={{ display: "flex", alignItems: "center", gap: 6, padding: "9px 14px", background: "#dbeafe", color: "#1e40af", border: "none", borderRadius: 9, cursor: "pointer", fontSize: 13, fontWeight: 700 }}
              >
                📅 Dönem Geçmişi
              </button>
              </button>
              <button className={`btn-secondary ${gorunum === "kart" ? "active-view" : ""}`} onClick={() => setGorunum("kart")}>{t.cardView}</button>
              <button className={`btn-secondary ${gorunum === "tablo" ? "active-view" : ""}`} onClick={() => setGorunum("tablo")}>{t.tableView}</button>
              <button className="btn-secondary" onClick={() => setBulkModal(true)}>{t.bulkAdd}</button>
              <button className="btn-primary" onClick={() => { setForm(emptyForm); setModal("add"); }}><Icon name="plus" size={16} /> {t.addApartment}</button>
            </>
          )}
        </div>
      </div>

      {/* Renkli aidat istatistik bandı */}
      <div className="stats-row">
        <div className="mini-stat"><span>Toplam Daire</span><strong>{detaylar.length}</strong></div>
        <div style={{ background: "#d1fae5", borderRadius: 10, padding: "10px 18px", border: "1px solid #a7f3d0" }}>
          <span style={{ fontSize: 12, color: "#065f46", display: "block" }}>✓ Bu Ay Ödendi</span>
          <strong style={{ fontSize: 22, fontWeight: 800, color: "#10b981" }}>{odendiSay}</strong>
        </div>
        <div style={{ background: "#fef3c7", borderRadius: 10, padding: "10px 18px", border: "1px solid #fde68a" }}>
          <span style={{ fontSize: 12, color: "#92400e", display: "block" }}>○ Bekliyor</span>
          <strong style={{ fontSize: 22, fontWeight: 800, color: "#f59e0b" }}>{bekliSay}</strong>
        </div>
        <div style={{ background: "#fee2e2", borderRadius: 10, padding: "10px 18px", border: "1px solid #fecaca" }}>
          <span style={{ fontSize: 12, color: "#991b1b", display: "block" }}>✕ Gecikti</span>
          <strong style={{ fontSize: 22, fontWeight: 800, color: "#ef4444" }}>{geciktiSay}</strong>
        </div>
        {site.bloklar.map((b) => (
          <div key={b} className="mini-stat"><span>{b} {t.block}</span><strong style={{ color: "#6366f1" }}>{detaylar.filter((d) => d.blok === b).length}</strong></div>
        ))}
      </div>

      <div className="filter-tabs">
        <button className={`filter-tab ${filterBlok === "hepsi" ? "active" : ""}`} onClick={() => setFilterBlok("hepsi")}>{t.allBlocks} ({detaylar.length})</button>
        {site.bloklar.map((b) => (
          <button key={b} className={`filter-tab ${filterBlok === b ? "active" : ""}`} onClick={() => setFilterBlok(b)}>{b} {t.block} ({detaylar.filter((d) => d.blok === b).length})</button>
        ))}
      </div>

      {/* KART GÖRÜNÜMÜ */}
      {gorunum === "kart" && Object.entries(blokGruplari).map(([blok, daireler]) => (
        <div key={blok} style={{ marginBottom: 28 }}>
          <div className="blok-baslik">
            <div className="blok-rozet">{blok}</div>
            <span>{blok} {t.block} — {daireler.length} Daire</span>
            <div style={{ marginLeft: "auto", display: "flex", gap: 6 }}>
              <Badge text={`${daireler.filter((d) => getAidatDurum(d.id) === "odendi").length} Ödendi`} type="success" />
              <Badge text={`${daireler.filter((d) => getAidatDurum(d.id) === "gecikti").length} Gecikti`} type="danger" />
            </div>
          </div>
          <div className="daire-grid">
            {daireler.map((d) => {
              const aidatD = getAidatDurum(d.id);
              return (
                <div key={d.id} className="daire-kart" style={{ borderTopColor: kartRenk[aidatD] }}>
                  <div className="daire-kart-no">
                    <span className="daire-numara">{d.daireNo}</span>
                    <Badge text={d.evDurum === "dolu" ? t.full : t.empty} type={d.evDurum === "dolu" ? "info" : "neutral"} />
                  </div>
                  <div className="daire-kisi">
                    <div className="daire-kisi-ad">👤 {d.evSahibi || "—"}</div>
                    {d.kiraci && <div className="daire-kisi-kiraci">🏠 {d.kiraci}</div>}
                  </div>
                  {d.aracPlaka && <div className="daire-plaka">🚗 {d.aracPlaka}</div>}
                  <div style={{ marginBottom: 6 }}>
                    <Badge text={durumLabel[aidatD]} type={durumRenk[aidatD]} />
                  </div>
                  <div className="daire-aksiyonlar">
                    <button className="daire-btn detay" onClick={() => setAidatDetayDaire(d)} style={{ background: "#eff6ff", color: "#3b82f6", flex: 1, justifyContent: "center", fontSize: 11 }}>💳 Detay</button>
                    {!readOnly && <>
                      <button className="daire-btn duzenle" onClick={() => { setForm({ ...d }); setModal("edit"); }}><Icon name="edit" size={13} /></button>
                      <button className="daire-btn sil" onClick={() => del(d.id)}><Icon name="trash" size={13} /></button>
                    </>}
                  </div>
                </div>
              );
            })}
          </div>
          {daireler.length === 0 && <div className="empty-state">Bu blokta daire kaydı yok.</div>}
        </div>
      ))}

      {/* TABLO GÖRÜNÜMÜ */}
      {gorunum === "tablo" && (
        <div className="table-card">
          <table className="data-table">
            <thead><tr><th>{t.block}</th><th>Daire</th><th>{t.owner}</th><th>{t.tenant}</th><th>{t.plate}</th><th>Durum</th><th>{t.dues}</th><th>Bu Ay Aidat</th><th>İşlem</th></tr></thead>
            <tbody>
              {filtered.sort((a, b) => a.blok.localeCompare(b.blok) || a.daireNo - b.daireNo).map((d) => {
                const aidatD = getAidatDurum(d.id);
                return (
                  <tr key={d.id}>
                    <td><strong>{d.blok} {t.block}</strong></td>
                    <td><strong>D.{d.daireNo}</strong></td>
                    <td><div>{d.evSahibi}</div><div style={{ fontSize: 12, color: "#94a3b8" }}>{d.evSahibiTel}</div></td>
                    <td>{d.kiraci || "—"}</td>
                    <td>{d.aracPlaka || "—"}</td>
                    <td><Badge text={d.evDurum === "dolu" ? t.full : t.empty} type={d.evDurum === "dolu" ? "info" : "neutral"} /></td>
                    <td>₺{d.aidatBedeli}</td>
                    <td><Badge text={durumLabel[aidatD]} type={durumRenk[aidatD]} /></td>
                    <td>
                      <div style={{ display: "flex", gap: 4 }}>
                        <button className="btn-outline" style={{ fontSize: 11, padding: "4px 8px" }} onClick={() => setAidatDetayDaire(d)}>💳</button>
                        {!readOnly && <>
                          <button className="icon-btn" onClick={() => { setForm({ ...d }); setModal("edit"); }}><Icon name="edit" size={15} /></button>
                          <button className="icon-btn danger" onClick={() => del(d.id)}><Icon name="trash" size={15} /></button>
                        </>}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {filtered.length === 0 && <div className="empty-state">Kayıt yok.</div>}
        </div>
      )}
              {/* AİDAT DÖNEM GEÇMİŞİ MODAL */}
      {tarihGecmisiAcik && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setTarihGecmisiAcik(false)}>
          <div className="modal-box modal-wide">
            <div className="modal-header">
              <h3>📅 {site.siteIsmi} — Aidat Dönem Geçmişi</h3>
              <button className="icon-btn" onClick={() => setTarihGecmisiAcik(false)}><Icon name="close" /></button>
            </div>
            <div className="modal-body">
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 16 }}>
                <div style={{ background: "#f0f9ff", borderRadius: 10, padding: 14 }}>
                  <div style={{ fontSize: 12, color: "#64748b" }}>Aktif Aidat Tutarı</div>
                  <div style={{ fontSize: 24, fontWeight: 800, color: "#3b82f6", marginTop: 4 }}>
                    ₺{getDönemTutari(data.aidatTarihleri, site.id, new Date().getFullYear(), new Date().getMonth() + 1).toLocaleString() || site.aidatBedeli || 0}
                  </div>
                </div>
                <div style={{ background: "#f8fafc", borderRadius: 10, padding: 14 }}>
                  <div style={{ fontSize: 12, color: "#64748b" }}>Toplam Dönem Sayısı</div>
                  <div style={{ fontSize: 24, fontWeight: 800, color: "#475569", marginTop: 4 }}>
                    {(data.aidatTarihleri || []).filter(a => String(a.siteId) === String(site.id)).length}
                  </div>
                </div>
              </div>
              <AidatTarihGecmisi siteId={site.id} data={data} setData={setData} />
            </div>
          </div>
        </div>
      )}
      {/* RAPOR MODAL */}
      {raporModal && <SiteExcelModal site={site} data={data} onClose={() => setRaporModal(false)} />}

      {/* AİDAT DETAY MODAL */}
      {aidatDetayDaire && (
        <AidatDetayModal daire={aidatDetayDaire} site={site} data={data} setData={setData} onClose={() => setAidatDetayDaire(null)} t={t} />
      )}

      {/* DAİRE EKLE/DÜZENLE */}
      {!readOnly && modal && (
        <Modal title={modal === "add" ? t.addApartment : t.edit} onClose={() => setModal(null)} wide>
          {modal === "add" && (
            <div style={{ background: "#f0fdf4", border: "1px solid #86efac", borderRadius: 8, padding: "8px 12px", marginBottom: 14, fontSize: 12, color: "#065f46" }}>
              💡 Daire eklendiğinde ev sahibi telefonu varsa <strong>Sakin Kullanıcıları</strong>'na otomatik eklenecek (şifre: 1234)
            </div>
          )}
          <div className="form-grid">
            <Field label={t.block} type="select" value={form.blok} onChange={(v) => f("blok", v)} options={site.bloklar.map((b) => ({ value: b, label: `${b} ${t.block}` }))} required />
            <Field label={t.apartmentNo} type="number" value={form.daireNo} onChange={(v) => f("daireNo", v)} required />
            <Field label={t.owner} value={form.evSahibi} onChange={(v) => f("evSahibi", v)} />
            <Field label="Tel" value={form.evSahibiTel} onChange={(v) => f("evSahibiTel", v)} />
            <Field label={t.tenant} value={form.kiraci} onChange={(v) => f("kiraci", v)} />
            <Field label="Kiracı Tel" value={form.kiraciTel} onChange={(v) => f("kiraciTel", v)} />
            <Field label={t.plate} value={form.aracPlaka} onChange={(v) => f("aracPlaka", v)} />
            <Field label="Durum" type="select" value={form.evDurum} onChange={(v) => f("evDurum", v)} options={[{ value: "dolu", label: t.full }, { value: "bos", label: t.empty }]} />
            <Field label={`${t.dues} (₺)`} type="number" value={form.aidatBedeli} onChange={(v) => f("aidatBedeli", v)} />
          </div>
          <div className="modal-footer">
            <button className="btn-secondary" onClick={() => setModal(null)}>{t.cancel}</button>
            <button className="btn-primary" onClick={save}>{t.save}</button>
          </div>
        </Modal>
      )}

      {!readOnly && bulkModal && (
        <Modal title={t.bulkAdd} onClose={() => setBulkModal(false)}>
          <div className="form-grid">
            <Field label={t.block} type="select" value={bulkForm.blok} onChange={(v) => setBulkForm((p) => ({ ...p, blok: v }))} options={site.bloklar.map((b) => ({ value: b, label: `${b} ${t.block}` }))} />
            <div />
            <Field label="Başlangıç No" type="number" value={bulkForm.baslangic} onChange={(v) => setBulkForm((p) => ({ ...p, baslangic: v }))} />
            <Field label="Bitiş No" type="number" value={bulkForm.bitis} onChange={(v) => setBulkForm((p) => ({ ...p, bitis: v }))} />
          </div>
          <div className="modal-footer">
            <button className="btn-secondary" onClick={() => setBulkModal(false)}>{t.cancel}</button>
            <button className="btn-primary" onClick={bulkAdd}>Oluştur ({Math.max(0, bulkForm.bitis - bulkForm.baslangic + 1)} Daire)</button>
          </div>
        </Modal>
      )}

      {/* ─── MESAJLAR MODAL ─── */}
      {mesajlarAcik && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:200, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
          <div style={{ background:"white", borderRadius:20, width:"100%", maxWidth:540, maxHeight:"80vh", display:"flex", flexDirection:"column", overflow:"hidden", boxShadow:"0 20px 60px rgba(0,0,0,0.2)" }}>
            {/* Başlık */}
            <div style={{ padding:"16px 20px", borderBottom:"1px solid #f1f5f9", display:"flex", alignItems:"center", justifyContent:"space-between", flexShrink:0 }}>
              <div>
                <div style={{ fontWeight:700, fontSize:15, color:"#0f172a" }}>💬 {site.siteIsmi} — Grup Sohbeti</div>
                <div style={{ fontSize:12, color:"#64748b", marginTop:2 }}>Salt okunur · Sakin panelindeki mesaj geçmişi</div>
              </div>
              <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                <button onClick={async()=>{ await mesajlariYukle(); }} style={{ background:"#f1f5f9", border:"none", borderRadius:8, padding:"6px 12px", cursor:"pointer", fontSize:12, color:"#475569", fontWeight:600 }}>
                  🔄 Yenile
                </button>
                <button onClick={() => setMesajlarAcik(false)} style={{ width:32, height:32, borderRadius:"50%", background:"#f1f5f9", border:"none", cursor:"pointer", fontSize:18, color:"#64748b", display:"flex", alignItems:"center", justifyContent:"center" }}>×</button>
              </div>
            </div>

            {/* Mesaj listesi */}
            <div style={{ flex:1, overflowY:"auto", padding:"16px 20px", background:"#f8fafc", display:"flex", flexDirection:"column", gap:10 }}>
              {siteMesajlar.length === 0 ? (
                <div style={{ textAlign:"center", padding:"40px 20px", color:"#94a3b8" }}>
                  <div style={{ fontSize:32, marginBottom:8 }}>💬</div>
                  <div style={{ fontWeight:600, marginBottom:4 }}>Mesaj bulunamadı</div>
                  <div style={{ fontSize:12 }}>Sakinler henüz mesaj yazmamış.</div>
                </div>
              ) : (
                (() => {
                  const saat = (ts) => { const d=new Date(ts); return `${String(d.getHours()).padStart(2,"0")}:${String(d.getMinutes()).padStart(2,"0")}`; };
                  const gL = (ts) => new Date(ts).toLocaleDateString("tr-TR",{day:"numeric",month:"long",year:"numeric"});
                  const bS = (b) => b<1048576?`${(b/1024).toFixed(0)} KB`:`${(b/1048576).toFixed(1)} MB`;
                  const urlRe = /(https?:\/\/[^\s]+)/g;
                  const ytId = (url) => { const m=url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]{11})/); return m?.[1]||null; };
                  const fIco = (t="") => t.includes("pdf")?"📄":t.includes("word")||t.includes("doc")?"📝":t.includes("sheet")||t.includes("excel")||t.includes("xls")?"📊":"📎";
                  let sG = ""; const items = [];
                  siteMesajlar.forEach(m => {
                    const g=new Date(m.tarih).toDateString();
                    if(g!==sG){items.push({tip:"ayrac",label:gL(m.tarih),key:g});sG=g;}
                    items.push({tip:"mesaj",...m});
                  });
                  const sakinler = data.sakinKullanicilari || [];
                  return items.map(item => {
                    if(item.tip==="ayrac") return (
                      <div key={item.key} style={{textAlign:"center",margin:"4px 0"}}>
                        <span style={{background:"#e2e8f0",color:"#64748b",fontSize:10,fontWeight:600,padding:"3px 10px",borderRadius:20}}>{item.label}</span>
                      </div>
                    );
                    const ynt=item.kId===99||item.kId===0;
                    const sb=sakinler.find(s=>s.id===item.kId);
                    return (
                      <div key={item.id} style={{display:"flex",gap:8,alignItems:"flex-end",flexDirection:ynt?"row-reverse":"row"}}>
                        <div style={{width:28,height:28,borderRadius:"50%",background:ynt?"#1e293b":"#e2e8f0",color:ynt?"white":"#64748b",display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700,flexShrink:0}}>{item.kAv}</div>
                        <div style={{maxWidth:"72%"}}>
                          {!ynt&&<div style={{fontSize:10,color:"#64748b",marginBottom:2,fontWeight:600}}>
                            {item.kAd}{sb&&<span style={{color:"#94a3b8",marginLeft:6}}>({sb.tel})</span>}
                          </div>}
                          {item.tip==="resim"&&(
                            <div style={{borderRadius:12,overflow:"hidden",border:"1px solid #e2e8f0",maxWidth:240,cursor:item.dosyaData?"pointer":"default"}}
                              onClick={()=>{if(item.dosyaData){const w=window.open();w.document.write(`<body style="margin:0;background:#000"><img src="${item.dosyaData}" style="max-width:100%;max-height:100vh;display:block;margin:auto"/></body>`);}}}>
                              {item.dosyaData
                                ?<img src={item.dosyaData} alt={item.dosyaAdi} style={{maxWidth:"100%",maxHeight:200,display:"block",objectFit:"cover"}}/>
                                :<div style={{padding:"10px 14px",fontSize:11,color:"#94a3b8"}}>🖼️ {item.dosyaAdi}</div>
                              }
                              <div style={{padding:"4px 8px",background:"#f8fafc",fontSize:9,color:"#94a3b8",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                                <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:140}}>{item.dosyaAdi}</span>
                                {item.dosyaData&&<a href={item.dosyaData} download={item.dosyaAdi} onClick={e=>e.stopPropagation()} style={{color:"#3b82f6",textDecoration:"none"}}>⬇️</a>}
                                <span>{saat(item.tarih)}</span>
                              </div>
                            </div>
                          )}
                          {item.tip==="video"&&(
                            <div style={{borderRadius:12,overflow:"hidden",border:"1px solid #e2e8f0",maxWidth:280}}>
                              {item.dosyaData
                                ?<video controls style={{width:"100%",maxHeight:200,display:"block"}} src={item.dosyaData}/>
                                :<div style={{padding:"10px 14px",display:"flex",gap:8,alignItems:"center"}}><span style={{fontSize:22}}>🎬</span><div><div style={{fontSize:12,fontWeight:600}}>{item.dosyaAdi}</div><div style={{fontSize:10,opacity:0.6}}>{item.dosyaBoyut?bS(item.dosyaBoyut):""}</div></div></div>
                              }
                              <div style={{padding:"4px 8px",background:"#f8fafc",fontSize:9,color:"#94a3b8",display:"flex",justifyContent:"space-between"}}>
                                <span>{item.dosyaAdi}</span>
                                {item.dosyaData&&<a href={item.dosyaData} download={item.dosyaAdi} style={{color:"#3b82f6",textDecoration:"none"}}>⬇️ İndir</a>}
                                <span>{saat(item.tarih)}</span>
                              </div>
                            </div>
                          )}
                          {item.tip==="dosya"&&(
                            <div style={{background:ynt?"#3b82f6":"white",color:ynt?"white":"#1e293b",borderRadius:12,padding:"10px 14px",border:ynt?"none":"1px solid #e2e8f0",display:"flex",alignItems:"center",gap:10,maxWidth:280}}>
                              <span style={{fontSize:22,flexShrink:0}}>{fIco(item.dosyaTur||"")}</span>
                              <div style={{flex:1,minWidth:0}}>
                                <div style={{fontSize:12,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{item.dosyaAdi}</div>
                                <div style={{fontSize:9,opacity:0.6}}>{item.dosyaBoyut?bS(item.dosyaBoyut):""} · {saat(item.tarih)}</div>
                              </div>
                              {item.dosyaData&&(
                                <div style={{display:"flex",flexDirection:"column",gap:4}}>
                                  <a href={item.dosyaData} download={item.dosyaAdi} style={{background:"rgba(255,255,255,0.2)",borderRadius:6,padding:"3px 8px",fontSize:11,color:ynt?"white":"#3b82f6",fontWeight:600,textDecoration:"none",textAlign:"center"}}>⬇️</a>
                                  {item.dosyaTur?.includes("pdf")&&<a href={item.dosyaData} target="_blank" rel="noopener noreferrer" style={{background:"rgba(255,255,255,0.15)",borderRadius:6,padding:"3px 8px",fontSize:11,color:ynt?"white":"#10b981",fontWeight:600,textDecoration:"none",textAlign:"center"}}>👁️</a>}
                                </div>
                              )}
                            </div>
                          )}
                          {(!item.tip||item.tip==="metin")&&(
                            <div style={{background:ynt?"#1e293b":"white",color:ynt?"white":"#1e293b",borderRadius:16,padding:"8px 12px",fontSize:13,lineHeight:1.5,border:ynt?"none":"1px solid #e2e8f0",borderBottomLeftRadius:ynt?16:3,borderBottomRightRadius:ynt?3:16,maxWidth:300}}>
                              {(item.mesaj||"").split(urlRe).filter(Boolean).map((p,i)=>
                                urlRe.test(p)
                                  ?<a key={i} href={p} target="_blank" rel="noopener noreferrer" style={{color:ynt?"#93c5fd":"#2563eb",textDecoration:"underline",wordBreak:"break-all"}}>{p}</a>
                                  :<span key={i}>{p}</span>
                              )}
                              {(item.linkler||(item.mesaj||"").match(urlRe)||[]).map((url,i)=>{
                                const yt=ytId(url);
                                return yt?<div key={i} style={{marginTop:6,borderRadius:8,overflow:"hidden"}}><iframe src={`https://www.youtube.com/embed/${yt}`} style={{width:"100%",height:150,border:"none",display:"block"}} allowFullScreen title="YouTube"/></div>:null;
                              })}
                              <div style={{fontSize:9,opacity:0.5,marginTop:3,textAlign:"right"}}>{saat(item.tarih)}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  });
                })()
              )}
              <div ref={adminMesajSonRef}/>
            </div>

            {/* Admin Yanıt Gönderme Alanı */}
            <div style={{ padding:"10px 14px", borderTop:"1px solid #f1f5f9", background:"white", flexShrink:0 }}>
              <div style={{ display:"flex", gap:8, alignItems:"flex-end" }}>
                {/* Dosya gönder butonu */}
                <input ref={adminFileRef} type="file" accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.zip,.rar" onChange={adminDosyaGonder} style={{display:"none"}}/>
                <button
                  onClick={()=>adminFileRef.current?.click()}
                  title="Dosya / Fotoğraf / Video Gönder"
                  style={{ width:36, height:36, borderRadius:"50%", background:"#f1f5f9", border:"1px solid #e2e8f0", cursor:"pointer", fontSize:16, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}
                >📎</button>
                <div style={{ flex:1, background:"#f8fafc", borderRadius:12, border:"1px solid #e2e8f0", display:"flex", alignItems:"flex-end", overflow:"hidden" }}>
                  <div style={{ width:32, height:32, borderRadius:"50%", background:"#1e293b", color:"white", fontSize:10, fontWeight:700, display:"flex", alignItems:"center", justifyContent:"center", margin:"8px 6px 8px 8px", flexShrink:0 }}>Y</div>
                  <textarea
                    value={adminYanit}
                    onChange={e => setAdminYanit(e.target.value)}
                    onKeyDown={e => { if(e.key==="Enter"&&!e.shiftKey){ e.preventDefault(); adminYanitGonder(); }}}
                    placeholder="Yönetim adına yanıt yaz... (Enter = gönder)"
                    rows={1}
                    style={{ flex:1, border:"none", background:"transparent", outline:"none", padding:"10px 8px 10px 0", fontSize:13, resize:"none", fontFamily:"inherit", maxHeight:80, overflowY:"auto" }}
                  />
                </div>
                <button
                  onClick={adminYanitGonder}
                  disabled={!adminYanit.trim()}
                  style={{ width:40, height:40, borderRadius:"50%", background:adminYanit.trim()?"#1e293b":"#e2e8f0", color:adminYanit.trim()?"white":"#94a3b8", border:"none", cursor:adminYanit.trim()?"pointer":"default", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, transition:"all 0.15s" }}
                >
                  <Icon name="send" size={16}/>
                </button>
              </div>
              <div style={{ fontSize:10, color:"#94a3b8", marginTop:4, paddingLeft:46 }}>
                Yanıtınız sakinlere <strong>"Yönetim"</strong> adıyla görünür · 📎 Dosya/Fotoğraf/Video gönderebilirsiniz
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ============================================================
// MAIN APP
// ============================================================
export default function App() {
  // ── Auth: sadece localStorage (küçük, cihaza özgü, güvenli) ─────────
  const loadAuth = () => {
    try {
      const s = localStorage.getItem("siteyonet_auth");
      return s ? JSON.parse(s) : { loggedIn: false, lang: "TR" };
    } catch { return { loggedIn: false, lang: "TR" }; }
  };

  const auth = loadAuth();
  const [loggedIn, setLoggedIn] = useState(auth.loggedIn);
  const [currentUser, setCurrentUser] = useState(auth.currentUser || null);
  const [lang, setLang] = useState(auth.lang || "TR");
  const [page, setPage] = useState("dashboard");
  // ── Veri: Supabase-first, MOCK sadece ilk render için ────────────────
  const [data, setDataRaw] = useState(MOCK);

  // İlk yükleme + Realtime sync
  useEffect(() => {
    // İlk çekim
    supabase.from('app_data').select('veri').eq('id', 1).single()
      .then(({ data: row }) => { if (row?.veri) setDataRaw(row.veri); });

    // Realtime — her değişiklikte otomatik güncelle
    const channel = supabase
      .channel('app-sync')
      .on('postgres_changes',
        { event: '*', schema: 'public', table: 'app_data' },
        (payload) => { if (payload.new?.veri) setDataRaw(payload.new.veri); }
      )
      .subscribe();

    return () => supabase.removeChannel(channel);
  }, []);
  const [selectedSite, setSelectedSite] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const isSuperAdmin = !currentUser || currentUser.rol === "superAdmin";
  const isSiteManager = currentUser?.rol === "siteYoneticisi";
  const myiteId = currentUser?.siteId || null;

  // setData — SADECE Supabase'e yazar, localStorage KULLANMAZ
  const setData = (updater) => {
    setDataRaw((prev) => {
      const next = typeof updater === "function" ? updater(prev) : updater;
      supabase.from('app_data').upsert({ id: 1, veri: next })
        .then(({ error }) => { if (error) console.error('Supabase yazma hatası:', error); });
      return next;
    });
  };

  const changeLang = (l) => {
    setLang(l);
    try { localStorage.setItem("siteyonet_auth", JSON.stringify({ loggedIn: true, lang: l, currentUser })); } catch {}
  };

  // Aktivite bazlı oturum timeout — 5 dakika hareketsizlikte çıkış
  useEffect(() => {
    if (!loggedIn) return;
    let timer;
    const resetTimer = () => {
      clearTimeout(timer);
      const loginTime = Date.now();
      try { 
        const saved = localStorage.getItem("siteyonet_auth");
        const auth = saved ? JSON.parse(saved) : {};
        localStorage.setItem("siteyonet_auth", JSON.stringify({ ...auth, loginTime }));
      } catch {}
      timer = setTimeout(() => {
        setLoggedIn(false);
        setCurrentUser(null);
        try { localStorage.setItem("siteyonet_auth", JSON.stringify({ loggedIn: false, lang: "TR", currentUser: null })); } catch {}
      }, 5 * 60 * 1000);
    };
    const events = ["click","touchstart","keydown","scroll","mousemove"];
    events.forEach(e => window.addEventListener(e, resetTimer, { passive: true }));
    resetTimer();
    return () => {
      clearTimeout(timer);
      events.forEach(e => window.removeEventListener(e, resetTimer));
    };
  }, [loggedIn]);

  // ── URL Yönetimi ────────────────────────────────────────────
  const slugify = (str) => (str || "").toLowerCase()
    .replace(/ğ/g,"g").replace(/ü/g,"u").replace(/ş/g,"s")
    .replace(/ı/g,"i").replace(/ö/g,"o").replace(/ç/g,"c")
    .replace(/[^a-z0-9]+/g,"-").replace(/^-|-$/g,"");

  const urlToPage = (path) => {
    const parts = path.replace(/^\//, "").split("/").filter(Boolean);
    // Sakin paneli URL'lerini yoksay
    if (!parts.length || parts[0] === "dashboard") return { page: "dashboard", site: null };
    if (parts[0] === "sakin") return { page: "dashboard", site: null };
    if (parts[0] === "siteler") {
      if (parts[1]) {
        const site = data.siteler.find(s => slugify(s.siteIsmi) === parts[1]);
        return { page: "site-detay", site: site || null };
      }
      return { page: "siteler", site: null };
    }
    const map = {
      "duyurular": "duyurular", "ariza-takip": "arizalar",
      "site-giderleri": "siteGiderleri", "personel": "personel",
      "gelir-gider": "gelir-gider", "isler": "isler",
      "airbnb": "airbnb", "yapilacaklar": "yapilacaklar",
      "sakin-kullanicilari": "sakinler", "duzenli-musteriler": "duzenlMusteriler",
      "ayarlar": "ayarlar",
    };
    return { page: map[parts[0]] || "dashboard", site: null };
  };

  const pageToUrl = (p, site) => {
    const map = {
      "dashboard": "/dashboard", "siteler": "/siteler",
      "duyurular": "/duyurular", "arizalar": "/ariza-takip",
      "siteGiderleri": "/site-giderleri", "personel": "/personel",
      "gelir-gider": "/gelir-gider", "isler": "/isler",
      "airbnb": "/airbnb", "yapilacaklar": "/yapilacaklar",
      "sakinler": "/sakin-kullanicilari", "duzenlMusteriler": "/duzenli-musteriler",
      "ayarlar": "/ayarlar",
    };
    if (p === "site-detay" && site) return `/siteler/${slugify(site.siteIsmi)}`;
    return map[p] || "/dashboard";
  };

  // İlk yüklemede URL'den sayfa belirle
  useEffect(() => {
    if (!loggedIn) return;
    const { page: p, site: s } = urlToPage(window.location.pathname);
    if (p) setPage(p);
    if (s) setSelectedSite(s);
  }, [loggedIn]); // eslint-disable-line react-hooks/exhaustive-deps

  // Geri tuşu → URL'den sayfa belirle
  useEffect(() => {
    window.onpopstate = () => {
      const { page: p, site: s } = urlToPage(window.location.pathname);
      setPage(p || "dashboard");
      setSelectedSite(s || null);
    };
    return () => { window.onpopstate = null; };
  }, [data.siteler]); // eslint-disable-line react-hooks/exhaustive-deps

  const doLogin = (user) => {
    setLoggedIn(true);
    setCurrentUser(user || null);
    const loginTime = Date.now();
    try { localStorage.setItem("siteyonet_auth", JSON.stringify({ loggedIn: true, lang, currentUser: user || null, loginTime })); } catch {}
    // Login sonrası URL'yi /dashboard'a ayarla
    if (window.location.pathname === "/" || window.location.pathname === "") {
      window.history.replaceState({}, "", "/dashboard");
    }
  };

  const doLogout = () => {
    setLoggedIn(false);
    setCurrentUser(null);
    try { localStorage.setItem("siteyonet_auth", JSON.stringify({ loggedIn: false, lang, currentUser: null })); } catch {}
  };

  const t = TRANSLATIONS[lang];

  // Süper admin tüm menüyü görür; site yöneticisi sadece kendi sitesini
  const allNav = [
    { id: "dashboard", label: t.dashboard, icon: "dashboard", adminOnly: false },
    { id: "siteler", label: t.sites, icon: "building", adminOnly: false },
    { id: "duyurular", label: t.announcements, icon: "bell", adminOnly: true },
    { id: "arizalar", label: t.faults, icon: "wrench", adminOnly: true },
    { id: "siteGiderleri", label: t.siteExpenses, icon: "wallet", adminOnly: true },
    { id: "personel", label: t.personnel, icon: "users", adminOnly: true },
    { id: "gelir-gider", label: t.income, icon: "money", adminOnly: true },
    { id: "isler", label: t.jobs, icon: "briefcase", adminOnly: true },
    { id: "airbnb", label: t.airbnb || "Airbnb / Kiralık", icon: "home", adminOnly: true },
    { id: "yapilacaklar", label: t.todos, icon: "check", adminOnly: true },
    { id: "sakinler", label: t.residents, icon: "shield", adminOnly: true },
    { id: "duzenlMusteriler", label: t.regularClients || "Düzenli Müşteriler", icon: "users", adminOnly: true },
    { id: "ayarlar", label: t.adminSettings, icon: "settings", adminOnly: true },
  ];
  const nav = isSuperAdmin ? allNav : allNav.filter((n) => !n.adminOnly);

  const goTo = (p, site) => {
    setPage(p);
    setSelectedSite(site || null);
    const url = pageToUrl(p, site);
    window.history.pushState({ page: p }, "", url);
  };
  const kasaOzet = hesaplaKasa(data);
  const kasa = kasaOzet.bakiye;

  if (!loggedIn) return <LoginScreen onLogin={doLogin} t={t} data={data} />;

  // Site yöneticisi için verileri sınırla
  const filteredData = isSiteManager ? {
    ...data,
    siteler: data.siteler.filter((s) => s.id === myiteId),
    siteDetay: data.siteDetay.filter((d) => d.siteId === myiteId),
    siteGiderleri: (data.siteGiderleri || []).filter((g) => g.siteId === myiteId),
    duyurular: data.duyurular.filter((d) => d.siteId === 0 || d.siteId === myiteId),
  } : data;

  const renderPage = () => {
    // Site yöneticisi sadece kendi sitesini görebilir
    if (isSiteManager) {
      const kendiSite = data.siteler.find((s) => s.id === myiteId);
      return kendiSite
        ? <SiteDetay site={kendiSite} data={filteredData} setData={() => {}} onBack={() => {}} t={t} readOnly={true} />
        : <div style={{ padding: 40, textAlign: "center", color: "#64748b" }}>Atanmış siteniz bulunamadı.</div>;
    }

    if (page === "site-detay" && selectedSite) return <SiteDetay site={selectedSite} data={data} setData={setData} onBack={() => { goTo("siteler"); }} t={t} readOnly={false} />;
    switch (page) {
      case "dashboard": return <Dashboard data={data} t={t} />;
      case "siteler": return <Siteler data={data} setData={setData} onSelectSite={(s) => { goTo("site-detay", s); }} t={t} />;
      case "duyurular": return <Duyurular data={data} setData={setData} t={t} />;
      case "arizalar": return <ArizaTakip data={data} setData={setData} t={t} />;
      case "siteGiderleri": return <SiteGiderleri data={data} setData={setData} t={t} />;
      case "personel": return <Personel data={data} setData={setData} t={t} />;
      case "gelir-gider": return <GelirGider data={data} setData={setData} t={t} />;
      case "isler": return <Isler data={data} setData={setData} t={t} />;
      case "airbnb": return <AirbnbEvler data={data} setData={setData} t={t} />;
      case "yapilacaklar": return <Yapilacaklar data={data} setData={setData} t={t} />;
      case "sakinler": return <SakinKullanicilari data={data} setData={setData} t={t} />;
      case "duzenlMusteriler": return <DuzenlMusteriler data={data} setData={setData} t={t} />;
      case "ayarlar": return <AdminAyarlari data={data} setData={setData} t={t} />;
      default: return <Dashboard data={data} t={t} />;
    }
  };

  return (
    <>
      <style>{`
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
        body{font-family:'Segoe UI',system-ui,sans-serif;background:#f1f5f9;color:#1e293b;}
        .app{display:flex;height:100vh;overflow:hidden;}
        
        /* LOGIN */
        .login-bg{min-height:100vh;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#0f172a,#1e3a5f);padding:20px;}
        .login-card{background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.1);border-radius:24px;padding:36px;width:100%;max-width:400px;}
        .login-field{display:flex;flex-direction:column;gap:6px;margin-bottom:4px;}
        .login-field label{font-size:13px;font-weight:600;color:#94a3b8;}
        .login-field input{background:rgba(255,255,255,0.08);border:1px solid rgba(255,255,255,0.12);border-radius:10px;padding:11px 14px;color:white;font-size:14px;outline:none;font-family:inherit;}
        .login-field input:focus{border-color:#3b82f6;}
        .login-btn{width:100%;background:linear-gradient(135deg,#3b82f6,#6366f1);color:white;border:none;border-radius:10px;padding:12px;font-size:14px;font-weight:700;cursor:pointer;margin-top:8px;}
        
        /* SIDEBAR */
        .sidebar{width:${sidebarOpen?"240px":"60px"};background:#0f172a;color:white;display:flex;flex-direction:column;transition:width 0.25s;overflow:hidden;flex-shrink:0;}
        .sidebar-logo{padding:16px 14px;display:flex;align-items:center;gap:10px;border-bottom:1px solid #1e293b;min-height:64px;}
        .logo-icon{width:32px;height:32px;background:linear-gradient(135deg,#3b82f6,#6366f1);border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0;}
        .logo-text{font-size:14px;font-weight:700;white-space:nowrap;}.logo-sub{font-size:11px;color:#64748b;}
        .nav-items{flex:1;padding:10px 8px;display:flex;flex-direction:column;gap:2px;overflow-y:auto;}
        .nav-item{display:flex;align-items:center;gap:10px;padding:9px 10px;border-radius:8px;cursor:pointer;color:#94a3b8;border:none;background:none;width:100%;text-align:left;font-size:13px;white-space:nowrap;transition:all 0.15s;}
        .nav-item:hover{background:#1e293b;color:white;}.nav-item.active{background:linear-gradient(135deg,#3b82f6,#6366f1);color:white;}
        .sidebar-footer{padding:12px 8px;border-top:1px solid #1e293b;}
        .kasa-mini{background:#1e293b;border-radius:8px;padding:10px 12px;margin-bottom:6px;display:${sidebarOpen?"block":"none"};}
        .kasa-mini-label{font-size:11px;color:#64748b;margin-bottom:2px;}.kasa-mini-value{font-size:18px;font-weight:800;color:${kasa>=0?"#10b981":"#ef4444"};}
        
        /* TOPBAR */
        .topbar{height:64px;background:white;border-bottom:1px solid #e2e8f0;display:flex;align-items:center;padding:0 20px;gap:14px;flex-shrink:0;}
        .topbar-toggle{background:none;border:none;cursor:pointer;color:#64748b;display:flex;align-items:center;padding:6px;border-radius:8px;}
        .topbar-toggle:hover{background:#f1f5f9;}
        .topbar-title{font-weight:700;font-size:17px;flex:1;}
        .user-avatar{width:36px;height:36px;background:linear-gradient(135deg,#3b82f6,#6366f1);border-radius:50%;display:flex;align-items:center;justify-content:center;color:white;font-weight:700;font-size:13px;}
        
        /* LANG SELECTOR */
        .lang-sel{display:flex;gap:4px;}
        .lang-btn{padding:4px 10px;border-radius:6px;border:1px solid #e2e8f0;background:white;cursor:pointer;font-size:12px;font-weight:600;color:#64748b;}
        .lang-btn.active{background:#0f172a;color:white;border-color:#0f172a;}
        .logout-btn{display:flex;align-items:center;gap:8px;width:100%;padding:9px 10px;background:rgba(239,68,68,0.08);border:none;border-radius:8px;cursor:pointer;color:#ef4444;font-size:13px;font-weight:600;transition:background 0.15s;margin-top:6px;}
        .logout-btn:hover{background:rgba(239,68,68,0.15);}
        .topbar-logout-btn{display:flex;align-items:center;justify-content:center;width:36px;height:36px;background:rgba(239,68,68,0.08);border:none;border-radius:8px;cursor:pointer;color:#ef4444;transition:background 0.15s;flex-shrink:0;}
        .topbar-logout-btn:hover{background:rgba(239,68,68,0.15);}
        
        .main{flex:1;display:flex;flex-direction:column;overflow:hidden;}
        .content{flex:1;overflow-y:auto;padding:24px;}
        .page{max-width:1400px;}
        .page-header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:24px;flex-wrap:wrap;gap:12px;}
        .page-header h2{font-size:22px;font-weight:800;color:#0f172a;}
        
        .stats-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:14px;margin-bottom:24px;}
        .stat-card{background:white;border-radius:14px;padding:18px;display:flex;align-items:center;gap:14px;border:1px solid #e2e8f0;transition:transform 0.15s;}
        .stat-card:hover{transform:translateY(-2px);}
        .stat-icon{width:48px;height:48px;border-radius:12px;display:flex;align-items:center;justify-content:center;flex-shrink:0;}
        .stat-value{font-size:20px;font-weight:800;}.stat-label{font-size:12px;color:#64748b;margin-top:2px;}
        .stats-row{display:flex;gap:10px;margin-bottom:18px;flex-wrap:wrap;}
        .mini-stat{background:white;border-radius:10px;padding:10px 18px;border:1px solid #e2e8f0;}
        .mini-stat span{font-size:12px;color:#64748b;display:block;}.mini-stat strong{font-size:22px;font-weight:800;color:#1e293b;}
        .mini-stat.success strong{color:#10b981;}.mini-stat.warning strong{color:#f59e0b;}.mini-stat.danger strong{color:#ef4444;}
        .dash-grid{display:grid;grid-template-columns:1fr 1fr;gap:18px;}
        .dash-card{background:white;border-radius:14px;padding:18px;border:1px solid #e2e8f0;}
        .dash-card h3{font-size:14px;font-weight:700;margin-bottom:12px;}
        .card-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(340px,1fr));gap:18px;}
        .site-card{background:white;border-radius:14px;padding:18px;border:1px solid #e2e8f0;transition:box-shadow 0.15s;}
        .site-card:hover{box-shadow:0 6px 20px rgba(0,0,0,0.07);}
        .site-card-header{display:flex;gap:12px;margin-bottom:14px;align-items:flex-start;}
        .site-icon{width:44px;height:44px;background:linear-gradient(135deg,#dbeafe,#ede9fe);color:#6366f1;border-radius:12px;display:flex;align-items:center;justify-content:center;flex-shrink:0;}
        .site-card h3{font-size:15px;font-weight:700;}.site-card p{font-size:12px;color:#64748b;margin-top:2px;}
        .site-info-grid{display:grid;grid-template-columns:1fr 1fr;gap:6px;margin-bottom:14px;}
        .site-info-grid>div{background:#f8fafc;border-radius:7px;padding:7px 10px;}
        .site-info-grid span{font-size:11px;color:#94a3b8;display:block;}.site-info-grid strong{font-size:13px;}
        .card-actions{display:flex;gap:6px;}
        
        /* BLOK & DAİRE */
        .blok-baslik{display:flex;align-items:center;gap:10px;margin-bottom:10px;padding:8px 14px;background:white;border-radius:10px;border:1px solid #e2e8f0;font-weight:600;font-size:14px;}
        .blok-rozet{width:32px;height:32px;background:linear-gradient(135deg,#3b82f6,#6366f1);color:white;border-radius:8px;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:14px;flex-shrink:0;}
        .daire-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:10px;margin-bottom:8px;}
        .daire-kart{background:white;border-radius:12px;padding:12px;border:1px solid #e2e8f0;border-top:3px solid #e2e8f0;}
        .daire-kart-no{display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;}
        .daire-numara{font-size:20px;font-weight:800;color:#0f172a;}
        .daire-kisi-ad{font-size:13px;font-weight:600;color:#1e293b;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
        .daire-kisi-kiraci{font-size:12px;color:#64748b;margin-top:2px;}
        .daire-plaka{font-size:12px;color:#94a3b8;margin-top:6px;}
        .daire-aksiyonlar{display:flex;gap:4px;border-top:1px solid #f1f5f9;padding-top:8px;margin-top:8px;}
        .daire-btn{border:none;border-radius:6px;cursor:pointer;font-size:12px;padding:5px 8px;display:flex;align-items:center;gap:4px;transition:all 0.15s;}
        .daire-btn.duzenle{background:#f8fafc;color:#64748b;flex:1;justify-content:center;}.daire-btn.duzenle:hover{background:#e2e8f0;}
        .daire-btn.sil{background:#fff5f5;color:#ef4444;}.daire-btn.sil:hover{background:#ef4444;color:white;}
        
        .table-card{background:white;border-radius:14px;border:1px solid #e2e8f0;overflow:hidden;}
        .data-table{width:100%;border-collapse:collapse;font-size:13px;}
        .data-table th{text-align:left;padding:12px 14px;background:#f8fafc;color:#64748b;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;border-bottom:1px solid #e2e8f0;}
        .data-table td{padding:11px 14px;border-bottom:1px solid #f1f5f9;vertical-align:middle;}
        .data-table tr:last-child td{border-bottom:none;}.data-table tr:hover td{background:#fafafa;}
        .empty-state{text-align:center;padding:36px;color:#94a3b8;font-size:14px;}
        
        .filter-tabs{display:flex;gap:6px;margin-bottom:14px;flex-wrap:wrap;}
        .filter-tab{padding:7px 14px;border-radius:8px;border:1px solid #e2e8f0;background:white;cursor:pointer;font-size:12px;font-weight:500;color:#64748b;transition:all 0.15s;}
        .filter-tab:hover{border-color:#3b82f6;color:#3b82f6;}.filter-tab.active{background:#3b82f6;color:white;border-color:#3b82f6;}
        .tab-row{display:flex;gap:6px;margin-bottom:14px;align-items:center;flex-wrap:wrap;}
        .tab-btn{padding:7px 14px;border-radius:8px;border:1px solid #e2e8f0;background:white;cursor:pointer;font-size:12px;font-weight:500;color:#64748b;transition:all 0.15s;}
        .tab-btn.active{background:#0f172a;color:white;border-color:#0f172a;}
        
        .btn-primary{display:flex;align-items:center;gap:6px;padding:9px 16px;background:linear-gradient(135deg,#3b82f6,#6366f1);color:white;border:none;border-radius:9px;cursor:pointer;font-size:13px;font-weight:600;transition:opacity 0.15s;}
        .btn-primary:hover{opacity:0.9;}.btn-primary.danger{background:linear-gradient(135deg,#ef4444,#f97316);}
        .btn-secondary{display:flex;align-items:center;gap:6px;padding:9px 16px;background:#f1f5f9;color:#475569;border:1px solid #e2e8f0;border-radius:9px;cursor:pointer;font-size:13px;font-weight:600;}
        .btn-secondary.active-view{background:#0f172a;color:white;border-color:#0f172a;}
        .btn-outline{display:flex;align-items:center;gap:4px;padding:6px 11px;background:white;color:#3b82f6;border:1px solid #3b82f6;border-radius:7px;cursor:pointer;font-size:12px;font-weight:500;transition:all 0.15s;}
        .btn-outline:hover{background:#3b82f6;color:white;}
        .btn-danger-outline{display:flex;align-items:center;padding:6px 11px;background:white;color:#ef4444;border:1px solid #ef4444;border-radius:7px;cursor:pointer;transition:all 0.15s;}
        .btn-danger-outline:hover{background:#ef4444;color:white;}
        .btn-back{display:flex;align-items:center;justify-content:center;width:36px;height:36px;background:#f1f5f9;border:none;border-radius:9px;cursor:pointer;color:#475569;}
        .btn-back:hover{background:#e2e8f0;}
        .icon-btn{background:none;border:none;cursor:pointer;color:#94a3b8;padding:5px;border-radius:6px;display:flex;align-items:center;transition:all 0.15s;}
        .icon-btn:hover{background:#f1f5f9;color:#475569;}.icon-btn.danger:hover{background:#fee2e2;color:#ef4444;}
        
        .kasa-cards{display:grid;grid-template-columns:repeat(3,1fr);gap:14px;margin-bottom:22px;}
        .kasa-card{border-radius:14px;padding:20px;}
        .kasa-card.gelir{background:linear-gradient(135deg,#d1fae5,#a7f3d0);}
        .kasa-card.gider{background:linear-gradient(135deg,#fee2e2,#fecaca);}
        .kasa-card.bakiye.positive{background:linear-gradient(135deg,#dbeafe,#bfdbfe);}
        .kasa-card.bakiye.negative{background:linear-gradient(135deg,#fee2e2,#fecaca);}
        .kasa-label{font-size:12px;font-weight:600;color:#475569;margin-bottom:6px;}.kasa-value{font-size:28px;font-weight:800;color:#0f172a;}
        
        .modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.5);display:flex;align-items:center;justify-content:center;z-index:1000;padding:20px;}
        .modal-box{background:white;border-radius:18px;width:100%;max-width:500px;max-height:90vh;overflow-y:auto;}
        .modal-wide{max-width:700px;}.modal-xwide{max-width:960px;}
        .modal-header{display:flex;justify-content:space-between;align-items:center;padding:18px 22px;border-bottom:1px solid #e2e8f0;}
        .modal-header h3{font-size:16px;font-weight:700;}
        .modal-body{padding:22px;}
        .modal-footer{display:flex;justify-content:flex-end;gap:8px;margin-top:18px;padding-top:18px;border-top:1px solid #e2e8f0;}
        
        .form-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px;}
        .field{display:flex;flex-direction:column;gap:5px;}.field-full{grid-column:1/-1;}
        .field label{font-size:12px;font-weight:600;color:#374151;}
        .field input,.field select,.field textarea{border:1px solid #e2e8f0;border-radius:8px;padding:9px 11px;font-size:13px;outline:none;transition:border-color 0.15s;font-family:inherit;}
        .field input:focus,.field select:focus,.field textarea:focus{border-color:#3b82f6;box-shadow:0 0 0 2px rgba(59,130,246,0.1);}
        .req{color:#ef4444;margin-left:2px;}
        
        .todo-sections{display:grid;grid-template-columns:1fr 1fr;gap:22px;}
        .todo-cards{display:flex;flex-direction:column;gap:8px;}
        .todo-card{background:white;border-radius:12px;padding:14px;border:1px solid #e2e8f0;}
        .todo-card.pending{border-left:4px solid #f59e0b;}.todo-card.done{border-left:4px solid #10b981;opacity:0.7;}
        .todo-card-header{display:flex;align-items:flex-start;gap:10px;}
        .todo-check{width:20px;height:20px;border-radius:50%;border:2px solid #d1d5db;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:11px;transition:all 0.15s;}
        .todo-check.checked{background:#10b981;border-color:#10b981;color:white;}
        .todo-card-title{font-weight:600;font-size:13px;}.done-text{text-decoration:line-through;color:#94a3b8;}
        .todo-card-date{font-size:11px;color:#94a3b8;margin-top:2px;}
        .todo-card-desc{font-size:12px;color:#64748b;margin-top:8px;padding-left:30px;}
        
        @media(max-width:768px){
          .stats-grid{grid-template-columns:1fr 1fr;}
          .dash-grid{grid-template-columns:1fr;}
          .kasa-cards{grid-template-columns:1fr;}
          .todo-sections{grid-template-columns:1fr;}
          .form-grid{grid-template-columns:1fr;}
          .card-grid{grid-template-columns:1fr;}
          .daire-grid{grid-template-columns:1fr 1fr;}
          /* Admin sidebar */
          .sidebar{position:fixed !important;top:0;left:0;bottom:0;z-index:500;width:240px !important;}
          .sidebar.closed{transform:translateX(-100%) !important;}
          .sidebar-overlay{display:block !important;position:fixed;inset:0;background:rgba(0,0,0,0.45);z-index:499;}
          /* Tablolar yatay scroll */
          .table-card{overflow-x:auto;-webkit-overflow-scrolling:touch;}
          .data-table{min-width:480px;}
          /* Topbar */
          .topbar{padding:0 12px;}
          .topbar-title{font-size:14px;}
          /* Page */
          .content{padding:12px;}
          .page-header{flex-direction:column;align-items:flex-start;}
          .page-header>div{flex-wrap:wrap;}
          /* Stat kartlar */
          .stat-card{padding:12px;}
          .stat-value{font-size:16px;}
          /* Modals — tam ekran mobilde */
          .modal-overlay{padding:0;align-items:flex-end;}
          .modal-box{width:100% !important;max-width:100% !important;max-height:92vh;border-radius:20px 20px 0 0;padding:16px;}
          .modal-wide{max-width:100% !important;}
          .modal-xwide{max-width:100% !important;}
          .modal-header{padding:14px 16px;}
          .modal-body{padding:14px 16px;}
          /* Site detay */
          .stats-row{flex-wrap:wrap;}
          .mini-stat{flex:1;min-width:80px;}
          /* Butonlar */
          .btn-primary,.btn-secondary,.btn-outline{font-size:12px;padding:7px 10px;}
          /* Filter tabs */
          .filter-tabs{flex-wrap:wrap;}
          .filter-tab{font-size:11px;padding:5px 10px;}
          /* Aidat detay modal grid */
          .modal-body>div>[style*="grid-template-columns: 200px"]{grid-template-columns:1fr !important;}
        }
        @media(max-width:480px){
          .stats-grid{grid-template-columns:1fr 1fr;}
          .daire-grid{grid-template-columns:1fr 1fr;}
          .kasa-cards{grid-template-columns:1fr;}
          .topbar{padding:0 8px;}
          .topbar-title{font-size:13px;}
          .content{padding:8px;}
          .stat-value{font-size:14px;}
        }
        @media(max-width:380px){
          .stats-grid{grid-template-columns:1fr;}
          .daire-grid{grid-template-columns:1fr;}
        }

      `}</style>

      <div className="app">
        {/* Mobil overlay — sidebar açıkken tıklayınca kapanır */}
        {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />}

        <aside className={`sidebar ${!sidebarOpen ? "closed" : ""}`}>
          {/* LOGO + KAPAT BUTONU */}
          <div className="sidebar-logo">
            <div className="logo-icon"><Icon name="building" size={18} /></div>
            {sidebarOpen && (
              <>
                <div style={{ flex: 1 }}>
                  <div className="logo-text">{t.appName}</div>
                  <div className="logo-sub">{t.appSub}</div>
                </div>
                {/* X butonu — sadece açıkken görünür */}
                <button
                  onClick={() => setSidebarOpen(false)}
                  style={{ background: "none", border: "none", cursor: "pointer", color: "#64748b", padding: 4, borderRadius: 6, display: "flex", alignItems: "center", flexShrink: 0 }}
                  title="Menüyü Kapat"
                >
                  <Icon name="close" size={18} />
                </button>
              </>
            )}
          </div>

          {/* NAVİGASYON */}
          <nav className="nav-items">
            {nav.map((n) => (
              <button
                key={n.id}
                className={`nav-item ${page === n.id || (page === "site-detay" && n.id === "siteler") ? "active" : ""}`}
                onClick={() => { goTo(n.id); if (window.innerWidth < 769) setSidebarOpen(false); }}
                title={!sidebarOpen ? n.label : ""}
              >
                <Icon name={n.icon} size={18} />
                {sidebarOpen && <span>{n.label}</span>}
              </button>
            ))}
          </nav>

          {/* FOOTER — KASA + LOGOUT */}
          <div className="sidebar-footer">
            {isSuperAdmin && (
              <div className="kasa-mini">
                <div className="kasa-mini-label">{t.balance}</div>
                <div className="kasa-mini-value">₺{kasa.toLocaleString()}</div>
              </div>
            )}
            <button
              className="logout-btn"
              onClick={() => { if (window.confirm("Çıkış yapmak istediğinize emin misiniz?")) doLogout(); }}
              title="Çıkış Yap"
            >
              <Icon name="logout" size={16} />
              {sidebarOpen && <span>{t.logout}</span>}
            </button>
          </div>
        </aside>

        <div className="main">
          <header className="topbar">
            {/* Hamburger — aç/kapat */}
            <button
              className="topbar-toggle"
              onClick={() => setSidebarOpen((prev) => !prev)}
              title={sidebarOpen ? "Menüyü Kapat" : "Menüyü Aç"}
            >
              {sidebarOpen
                ? <Icon name="close" size={22} />
                : <Icon name="menu" size={22} />}
            </button>

            <div className="topbar-title">
              {page === "site-detay" && selectedSite
                ? selectedSite.siteIsmi
                : nav.find((n) => n.id === page)?.label || t.appName}
            </div>

            {/* Dil Seçici */}
            <div className="lang-sel">
              {["TR", "EN", "RU"].map((l) => (
                <button key={l} className={`lang-btn ${lang === l ? "active" : ""}`} onClick={() => changeLang(l)}>{l}</button>
              ))}
            </div>

            {/* Kullanıcı + Logout */}
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ textAlign: "right" }}>
                <div style={{ fontSize: 13, fontWeight: 600 }}>{isSiteManager ? currentUser.ad : data.adminProfile.ad}</div>
                <div style={{ fontSize: 11, color: "#94a3b8" }}>{isSiteManager ? t.siteManager : t.superAdmin}</div>
              </div>
              <div className="user-avatar" style={{ cursor: "default" }}>{isSiteManager ? currentUser.ad[0] : "A"}</div>
              <button
                className="topbar-logout-btn"
                onClick={() => { if (window.confirm("Çıkış yapmak istediğinize emin misiniz?")) doLogout(); }}
                title={t.logout}
              >
                <Icon name="logout" size={18} />
              </button>
            </div>
          </header>

          <main className="content">{renderPage()}</main>
        </div>
      </div>
    </>
  );
}
